webpackJsonp([1],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);
exports.getCollectionQuery = function getCollectionQuery(context, payload, queryParameters) {
  console.log('currentPage: ' + context.state.currentPage);
  if (context.state.currentPage === 1) {
    console.log('Show first page');
    return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(queryParameters.orderByField, queryParameters.orderByDirection).limit(context.state.rowsPerPage);
  } else if (context.state.currentPage === Math.ceil(context.state.totalRows / context.state.rowsPerPage)) {
    console.log('Show last page');
    var limit = context.state.totalRows % context.state.rowsPerPage;
    if (limit === 0) {
      limit = context.state.rowsPerPage;
    }
    queryParameters.flippedSorting = true;
    return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(queryParameters.orderByField, queryParameters.orderByFlippedDirection).limit(limit);
  } else if (context.state.currentPage - context.state.lastShown.lastShownPage === 1) {
    console.log('Show next page');
    return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(queryParameters.orderByField, queryParameters.orderByDirection).startAfter(context.state.lastShown.lastRowShown).limit(context.state.rowsPerPage);
  } else if (context.state.currentPage - context.state.lastShown.lastShownPage === -1) {
    console.log('Show previous page');
    queryParameters.flippedSorting = true;
    return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(queryParameters.orderByField, queryParameters.orderByFlippedDirection).startAfter(context.state.lastShown.firstRowShown).limit(context.state.rowsPerPage);
  } else if (context.state.currentPage > 1 && context.state.currentPage === context.state.lastShown.lastShownPage) {
    console.log('Re-Show not first page');
    return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(payload.orderBys, 'desc').startAt(context.state.lastShown.firstRowShown).limit(context.state.rowsPerPage);
  } else {
    if (context.state.currentPage > context.state.lastShown.lastShownPage) {
      console.log('Jumped forward page');
      var _limit = (context.state.currentPage - context.state.lastShown.lastShownPage) * context.state.rowsPerPage;
      queryParameters.jumpedPage = true;
      queryParameters.jumpedLimit = _limit;
      return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(queryParameters.orderByField, queryParameters.orderByDirection).startAfter(context.state.lastShown.lastRowShown).limit(_limit);
    } else if (context.state.currentPage < context.state.lastShown.lastShownPage) {
      console.log('Jumped backward page');
      var _limit2 = (context.state.lastShown.lastShownPage - context.state.currentPage) * context.state.rowsPerPage;
      queryParameters.jumpedPage = true;
      queryParameters.jumpedLimit = _limit2;
      queryParameters.flippedSorting = true;
      return context.rootState.firestoreDB.collection(queryParameters.collectionName).orderBy(queryParameters.orderByField, queryParameters.orderByFlippedDirection).startAfter(context.state.lastShown.firstRowShown).limit(_limit2);
    } else {
      console.error('Unsupported page navigation');
      context.commit('toggleDisabledPagination', false);
      return null;
    }
  }
};
exports.queryCollection = function queryCollection(docQuery, context, queryParameters, hasShowDetail) {
  docQuery.get().then(function (querySnapshot) {
    var index = 0;
    var jumpIndex = 0;
    querySnapshot.forEach(function (doc) {
      if (queryParameters.jumpedPage && jumpIndex < queryParameters.jumpedLimit - context.state.rowsPerPage) {
        jumpIndex++;
        return;
      }
      if (index === 0) {
        context.state.lastShown.firstRowShown = doc;
      }
      index++;

      var documentData = doc.data();
      var rowObject = {};
      for (var eachProp in documentData) {
        var propName = eachProp;

        if (propName === 'orderDate' && doc.data()[eachProp]) {
          var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
          rowObject[propName] = m.format('DD/MMM/YYYY');
        } else if (propName === 'createdDate' && doc.data()[eachProp]) {
          var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
          rowObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
        } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
          var _m2 = moment(dateutils.toJsDate(doc.data()[eachProp]));
          rowObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
        } else if (propName === 'uploadedDate' && doc.data()[eachProp]) {
          var _m3 = moment(dateutils.toJsDate(doc.data()[eachProp]));
          rowObject[propName] = _m3.format('DD/MM/YYYY HH:mm:ss');
        } else {
          rowObject[propName] = doc.data()[eachProp];
        }
      }
      if (hasShowDetail) {
        rowObject['_showDetails'] = false;
      }
      rowObject.docId = doc.id;
      rowObject._rowVariant = '';
      if (queryParameters.flippedSorting === true) {
        queryParameters.flippedResult.push(rowObject);
      } else {
        context.state.all.push(rowObject);
      }
      context.state.lastShown.lastShownPage = context.state.currentPage;
      context.state.lastShown.lastRowShown = doc;
    });
    if (queryParameters.flippedSorting === true) {
      queryParameters.flippedResult.reverse();
      queryParameters.flippedResult.forEach(function (value) {
        context.state.all.push(value);
      });
      var tempHolder = context.state.lastShown.firstRowShown;
      context.state.lastShown.firstRowShown = context.state.lastShown.lastRowShown;
      context.state.lastShown.lastRowShown = tempHolder;
    }
    context.commit('toggleShowLoadingAnimation', false);
    if (context.state.all.length === 0) {
      context.commit('toggleShowNoResult', true);
    }
    context.commit('toggleDisabledPagination', false);
  }).catch(function (err) {
    context.commit('toggleDisabledPagination', false);
    console.log('Error while fetching documents in invoice collection: ' + err);
    context.commit('toggleShowLoadingAnimation', false);

    context.commit('toggleshowLoadingError', true);
    context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
  });
};

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    console.log('App created, firestoreDB:' + this.$store.state.firestoreDB);
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Invoices__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Users__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_InvoiceImports__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Campaigns__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_CreateCampaign__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_MobileAppStuff__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Login__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Claims__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_PairRequests__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_CustomerAccounts__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_CustomerAccountUpload__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_UserClaimReport__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_InvoiceUpload__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_GenerateClaimReports_vue__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Banners_vue__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Notifications_vue__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Configuration_vue__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_firebase_app__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_firebase_auth__ = __webpack_require__(241);


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/login',
    name: 'Info',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Login__["a" /* default */]
    }, {
      path: 'invoices',
      name: 'Invoices',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Invoices__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'users',
      name: 'Users',
      component: __WEBPACK_IMPORTED_MODULE_4__views_Users__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'claims',
      name: 'Claims',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Claims__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'pairrequests',
      name: 'PairRequests',
      component: __WEBPACK_IMPORTED_MODULE_11__views_PairRequests__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'invoiceupload',
      name: 'Upload Invoice',
      component: __WEBPACK_IMPORTED_MODULE_15__views_InvoiceUpload__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'invoiceimports',
      name: 'Imports',
      component: __WEBPACK_IMPORTED_MODULE_5__views_InvoiceImports__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'customeraccounts',
      name: 'Customer Accounts',
      component: __WEBPACK_IMPORTED_MODULE_12__views_CustomerAccounts__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'customeraccountupload',
      name: 'Upload Customer Accounts',
      component: __WEBPACK_IMPORTED_MODULE_13__views_CustomerAccountUpload__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'campaigns',
      name: 'Campaigns',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Campaigns__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'createcampaign',
      name: 'CreateCampaign',
      component: __WEBPACK_IMPORTED_MODULE_7__views_CreateCampaign__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'mobileappstuff',
      name: 'MobileAppStuff',
      component: __WEBPACK_IMPORTED_MODULE_8__views_MobileAppStuff__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'userclaimreport',
      name: 'UserClaimReport',
      component: __WEBPACK_IMPORTED_MODULE_14__views_UserClaimReport__["a" /* default */],
      props: true,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'generateclaimreports',
      name: 'GenerateClaimReports',
      component: __WEBPACK_IMPORTED_MODULE_16__views_GenerateClaimReports_vue__["a" /* default */],
      props: true,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'banners',
      name: 'Banners',
      component: __WEBPACK_IMPORTED_MODULE_17__views_Banners_vue__["a" /* default */],
      props: true,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'notifications',
      name: 'Notifications',
      component: __WEBPACK_IMPORTED_MODULE_18__views_Notifications_vue__["a" /* default */],
      props: true,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'configuration',
      name: 'Configuration',
      component: __WEBPACK_IMPORTED_MODULE_19__views_Configuration_vue__["a" /* default */],
      props: true,
      meta: {
        requiresAuth: true
      }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  console.log('before each, from:' + from.path + ' to:' + to.path);
  var currentUser = __WEBPACK_IMPORTED_MODULE_20_firebase_app__["a" /* default */].auth().currentUser;

  console.log('current firebase user:' + currentUser);
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  if (requiresAuth && !currentUser) {
    next('login');
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(79);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["g" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    },
    showAppChrome: function showAppChrome() {
      return this.$route.matched.some(function (route) {
        return route.meta && route.meta.requiresAuth;
      });
    }
  }
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside'
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    footerToggle: function footerToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('footer-hidden');
    },
    logOut: function logOut() {
      this.$store.commit('logOut');
    }
  },
  computed: {
    loggedInUser: function loggedInUser() {
      return this.$store.state.currentUser ? this.$store.state.currentUser.email : '';
    }
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__(737);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var dateutils = __webpack_require__(62);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['format', 'initialValue', 'width'],
  data: function data() {
    return {
      date: '',
      hideCal: true,
      activePort: null,
      timeStamp: new Date(),
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      monthIndex: 0,
      hourIndex: 0,
      minuteIndex: 0,
      year: 2017,
      portsHolder: [],
      minute: '00',
      hour: '01',
      day: 1,
      minuteSelectorVisible: false,
      hourSelectorVisible: false,
      period: 'AM'
    };
  },

  methods: {
    leftMonth: function leftMonth() {
      var index = this.months.indexOf(this.month);
      if (index === 0) {
        this.monthIndex = 11;
      } else {
        this.monthIndex = index - 1;
      }
      this.updateCalendar();
    },
    rightMonth: function rightMonth() {
      var index = this.months.indexOf(this.month);
      if (index === 11) {
        this.monthIndex = 0;
      } else {
        this.monthIndex = index + 1;
      }
      this.updateCalendar();
    },
    rightYear: function rightYear() {
      this.year++;
      this.updateCalendar();
    },
    leftYear: function leftYear() {
      this.year--;
      this.updateCalendar();
    },
    updateCalendar: function updateCalendar() {
      var me = this;
      var date = new Date(me.year, me.monthIndex, 1, 0, 0, 0);
      var day = date.getDay();
      var daysInMonth = new Date(me.year, me.monthIndex + 1, 0).getDate();
      var ports = [];
      var portsLenght = 35;
      if (day === 6 || day === 5 && daysInMonth === 31) {
        portsLenght = 42;
      }
      var activeFound = false;
      for (var i = 0; i < portsLenght; i++) {
        var j = i - day;
        var curr = j < 0 || j >= daysInMonth ? '' : j + 1;
        ports.push(curr);
        if (curr === me.day && this.timeStamp.getMonth() === me.monthIndex && this.timeStamp.getFullYear() === me.year) {
          me.activePort = i;
          activeFound = true;
        }
      }
      if (!activeFound) {
        me.activePort = -1;
      }
      this.ports = ports;
    },
    setDay: function setDay(index, port) {
      if (port !== '') {
        this.activePort = index;
        this.day = port;
        this.timeStamp = new Date(this.year, this.monthIndex, this.day);
      }
    },
    setMinute: function setMinute(index, closeAfterSet) {
      this.minuteIndex = index;
      this.minute = this.minutes[index];
      if (closeAfterSet) {
        this.minuteSelectorVisible = false;
      }
    },
    setHour: function setHour(index, closeAfterSet) {
      this.hourIndex = index;
      this.hour = this.hours[index];
      if (closeAfterSet) {
        this.hourSelectorVisible = false;
      }
    },
    showHourSelector: function showHourSelector() {
      this.hourSelectorVisible = true;
      this.minuteSelectorVisible = false;
    },
    showMinuteSelector: function showMinuteSelector() {
      this.minuteSelectorVisible = true;
      this.hourSelectorVisible = false;
    },
    keyIsDown: function keyIsDown(event) {
      var key = event.which || event.keycode;
      if (key === 38) {
        if (this.minuteSelectorVisible && this.minuteIndex > 0) {
          this.setMinute(this.minuteIndex - 1, false);
          this.scrollTopMinute();
        } else if (this.hourSelectorVisible && this.hourIndex > 0) {
          this.setHour(this.hourIndex - 1, false);
          this.scrollTopHour();
        }
      } else if (key === 40) {
        if (this.minuteSelectorVisible && this.minuteIndex < this.minutes.length - 1) {
          this.setMinute(this.minuteIndex + 1, false);
          this.scrollTopMinute();
        } else if (this.hourSelectorVisible && this.hourIndex < this.hours.length - 1) {
          this.setHour(this.hourIndex + 1, false);
          this.scrollTopHour();
        }
      } else if (key === 13) {
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
      event.preventDefault();
    },
    scrollTopMinute: function scrollTopMinute() {
      var mHeight = this.$refs.minuteScroller.scrollHeight;
      var wHeight = this.$refs.minuteScrollerWrapper.clientHeight;
      var top = mHeight * (this.minuteIndex / (this.minutes.length - 1)) - wHeight / 2;
      this.$refs.minuteScroller.scrollTop = top;
    },
    scrollTopHour: function scrollTopHour() {
      var mHeight = this.$refs.hourScroller.scrollHeight;
      var wHeight = this.$refs.hourScrollerWrapper.clientHeight;
      var top = mHeight * (this.hourIndex / (this.hours.length - 1)) - wHeight / 2;
      this.$refs.hourScroller.scrollTop = top;
    },
    changePeriod: function changePeriod() {
      this.period = this.period === 'AM' ? 'PM' : 'AM';
    },
    calendarClicked: function calendarClicked(event) {
      if (event.target.id !== 'j-hour' && event.target.id !== 'j-minute') {
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    },
    documentClicked: function documentClicked(event) {
      if (event.target.id !== 'tj-datetime-input') {
        this.hideCal = true;
        document.removeEventListener('keydown', this.keyIsDown);
      }
    },
    toggleCal: function toggleCal() {
      this.hideCal = !this.hideCal;

      if (!this.hideCal) {
        document.addEventListener('keydown', this.keyIsDown);
      } else {
        document.removeEventListener('keydown', this.keyIsDown);
      }
    },
    okButtonClicked: function okButtonClicked() {
      this.updateDate();
      if (!this.hideCal) {
        document.addEventListener('keydown', this.keyIsDown);
      } else {
        document.removeEventListener('keydown', this.keyIsDown);
      }
    },
    setDate: function setDate() {
      var d = null;
      if (!this.dateFormat) {
        console.error('Invalid date format supplied');
      } else {
        var h = this.hour;
        d = this.dateFormat;

        d = d.replace('YYYY', this.year);
        d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day);
        var m = this.monthIndex + 1;
        d = d.replace('MM', m < 10 ? '0' + m : m);
        d = d.replace('h', h);
        d = d.replace('i', this.minute);
        d = d.replace('s', '00');

        this.$emit('update:date-value', d);
        this.date = d;
        this.hideCal = true;
      }
    },
    updateDate: function updateDate() {
      var d = null;
      var h = this.hour;
      if (this.period === 'PM') {
        if (parseInt(h) < 12) {
          h = parseInt(h) + 12;
        }
      } else {
        if (parseInt(h) === 12) {
          h = '00';
        }
      }
      d = this.dateFormat;

      d = d.replace('YYYY', this.year);
      d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day);
      var m = this.monthIndex + 1;
      d = d.replace('MM', m < 10 ? '0' + m : m);
      d = d.replace('h', h);
      d = d.replace('i', this.minute);
      d = d.replace('s', '00');

      this.$emit('update:date-value', d);
      this.date = d;
      this.hideCal = true;
    },
    setInitialDate: function setInitialDate(iDate) {
      console.debug('iDate: ' + iDate);
      if (iDate) {
        var m = dateutils.parseDateTime(iDate);

        this.timeStamp = m.toDate();
        console.debug('This timestamp: ' + this.timeStamp);

        this.year = this.timeStamp.getFullYear();
        this.monthIndex = this.timeStamp.getMonth();

        this.day = this.timeStamp.getDate();
        this.hour = this.timeStamp.getHours();
        if (parseInt(this.hour) >= 12) {
          if (parseInt(this.hour) > 12) {
            this.hour = parseInt(this.hour) - 12;
          }
          this.period = 'PM';
        } else {
          if (parseInt(this.hour) === 0) {
            this.hour = '12';
          }
          this.period = 'AM';
        }
        this.minute = this.timeStamp.getMinutes();

        this.updateCalendar();


        this.setDate();
      }
    }
  },
  created: function created() {
    this.year = this.timeStamp.getFullYear();
    this.monthIndex = this.timeStamp.getMonth();
    this.day = this.timeStamp.getDate();
    this.hour = this.timeStamp.getHours();
    this.minute = this.timeStamp.getMinutes();
    this.updateCalendar();

    document.addEventListener('click', this.documentClicked);
    this.setDate();
  },

  destroyed: function destroyed() {
    document.removeEventListener('keydown', this.keyIsDown);
    document.removeEventListener('click', this.documentClicked);
  },
  computed: {
    ports: {
      get: function get() {
        var p = [];
        if (this.portsHolder.length === 0) {
          for (var i = 0; i < 42; i++) {
            p.push('');
          }
        } else {
          p = this.portsHolder;
        }
        return p;
      },
      set: function set(newValue) {
        this.portsHolder = newValue;
      }
    },
    month: function month() {
      return this.months[this.monthIndex];
    },
    dateTime: function dateTime() {
      return this.timeStamp.getFullYear() + '-' + (this.timeStamp.getMonth() + 1) + '-' + this.timeStamp.getUTCDay();
    },
    minutes: function minutes() {
      var arr = [];
      for (var i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i);
      }
      return arr;
    },
    hours: function hours() {
      var arr = [];
      for (var i = 1; i <= 12; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i);
      }
      return arr;
    },
    dateFormat: function dateFormat() {
      var f = 'DD/MM/YYYY h:i:s';
      var allowedFormats = ['YYYY-MM-DD h:i:s', 'DD-MM-YYYY h:i:s', 'MM-DD-YYYY h:i:s', 'YYYY-MM-DD', 'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY', 'h:i:s', 'YYYY/MM/DD h:i:s', 'DD/MM/YYYY h:i:s', 'MM/DD/YYYY h:i:s'];
      if (this.format) {
        f = this.format;
      }
      if (allowedFormats.indexOf(f) < 0) {
        console.warn('Invalid date format supplied');
        return null;
      } else {
        return f;
      }
    },
    hideTime: function hideTime() {
      return this.dateFormat.indexOf('h:i:s') === -1;
    },
    hideDate: function hideDate() {
      return this.dateFormat === 'h:i:s';
    }
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['headerTitle', 'bodyMessage']
});

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(79);



var moment = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DateTimePicker: __WEBPACK_IMPORTED_MODULE_0__components___["c" /* DateTimePicker */]
  },
  data: function data() {
    return {
      currentPage: this.$store.state.invstomod.currentPage,
      paginationButtonsLimit: 3,
      searchObject: {
        taxInvoice: '',
        customerAccount: '',
        status: '',
        orderDate: ''
      },
      searchModalShow: false,
      campaignClaimsModalShow: false,
      selectedClaimTaxInvoice: ''
    };
  },

  created: function created() {
    this.$store.dispatch('invstomod/showAllInvoices', { orderBys: 'orderDate' });
  },
  methods: {
    updateFromOrderDate: function updateFromOrderDate(dateString) {
      console.log('Updating from order date to: ' + dateString);
      if (dateString && dateString.length > 0) {
        var m = moment(dateString, 'DD/MM/YYYY');
        this.searchObject.orderDate = m.toDate();
        console.log('Updated from order date to: ' + this.searchObject.orderDate);
      }
    },
    updateToOrderDate: function updateToOrderDate(dateString) {
      this.$store.commit('invstomod/updateToOrderDate', dateString);
    },
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('invstomod/changePageNumber', this.currentPage);
      this.$store.dispatch('invstomod/showAllInvoices', { orderBys: 'orderDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.invstomod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('invstomod/changePageNumber', this.currentPage);
        this.$store.commit('invstomod/setRowsPerPage', intRows);
        this.$store.dispatch('invstomod/showAllInvoices', { orderBys: 'orderDate' });
      }
    },
    showRowDetailClicked: function showRowDetailClicked(taxInvoice, invoiceId) {
      console.log('show row detail clicked: ' + taxInvoice);
      this.$store.commit('invstomod/selectTableRow', invoiceId);
      this.$store.commit('invstomod/updatedSelectedTaxInvoice', taxInvoice);
      this.$store.dispatch('invstomod/fetchInvoiceDetails', { taxInvoice: taxInvoice });
    },
    showCampaignClaims: function showCampaignClaims(taxInvoice, invoiceId) {
      var _this = this;

      console.log('show campaign claims clicked: ' + taxInvoice);
      this.selectedClaimTaxInvoice = taxInvoice;
      this.$store.commit('invstomod/selectTableRow', invoiceId);
      this.$store.dispatch('invstomod/fetchInvoiceClaimDetails', { taxInvoice: taxInvoice }).then(function () {
        _this.campaignClaimsModalShow = true;
      });
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);

      var taxInvoice = null;
      for (var i in item) {
        if (i === 'taxInvoice') {
          taxInvoice = item[i];
        }
      }
      this.$store.commit('invstomod/selectTableRow', item.invoiceId);
      this.$store.commit('invstomod/updatedSelectedTaxInvoice', taxInvoice);
      this.$store.dispatch('invstomod/fetchInvoiceDetails', { taxInvoice: taxInvoice });
    },
    search: function search() {
      this.searchModalShow = false;
      this.$store.dispatch('invstomod/searchInvoices', {
        taxInvoice: this.searchObject.taxInvoice,
        customerAccount: this.searchObject.customerAccount,
        status: this.searchObject.status,
        orderDate: this.searchObject.orderDate
      });
    },
    generateInvoiceReport: function generateInvoiceReport() {
      this.$store.dispatch('invstomod/generateInvoiceReport');
    },
    refreshTable: function refreshTable() {
      this.currentPage = 1;
      this.$store.commit('invstomod/changePageNumber', this.currentPage);
      this.$store.dispatch('invstomod/showAllInvoices', { orderBys: 'orderDate' });
    },
    updateFilterOrderDate: function updateFilterOrderDate(dateString) {
      var m = moment(dateString, 'DD/MM/YYYY hh:mm:ss');
      this.searchObject.orderDate = m.toDate();
    },
    searchStatusSelected: function searchStatusSelected(selectedStatus) {
      this.searchObject.status = selectedStatus;
    }
  },
  computed: {
    disabledPagination: function disabledPagination() {
      return this.$store.state.invstomod.disabledPagination;
    },
    tableRows: function tableRows() {

      console.log('all invoice', this.$store.state.invstomod.all);
      return this.$store.state.invstomod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['invstomod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.invstomod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.invstomod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('invstomod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.invstomod.rowsPerPage;
    },
    detailTableRows: function detailTableRows() {
      return this.$store.state.invstomod.detailAll;
    },
    detailTableHeaders: function detailTableHeaders() {
      return this.$store.getters['invstomod/getDetailHeaders'];
    },
    requestedClaimDetails: function requestedClaimDetails() {
      return this.$store.state.invstomod.claimDetails.requested;
    },
    pairingClaimDetails: function pairingClaimDetails() {
      return this.$store.state.invstomod.claimDetails.pairing;
    },
    claimDetailHeaders: function claimDetailHeaders() {
      return this.$store.getters['invstomod/getClaimDetailHeaders'];
    },
    taxInvoice: {
      get: function get() {
        return this.$store.state.invstomod.selectedTaxInvoice;
      }
    },
    clearFilters: function clearFilters() {
      if (this.searchObject.taxInvoice === '' && this.searchObject.customerAccount === '' && this.searchObject.status === '' && this.searchObject.orderDate === null) {
        return;
      }
      this.searchObject.taxInvoice = '';
      this.searchObject.customerAccount = '';
      this.searchObject.status = '';
      this.searchObject.orderDate = null;
      this.currentPage = 1;
      this.$store.commit('invstomod/changePageNumber', this.currentPage);
      this.$store.dispatch('invstomod/showAllInvoices', { orderBys: 'orderDate' });
    },

    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.invstomod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.invstomod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.invstomod.showNoResult;
    }
  },
  name: 'invoices'
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentPage: this.$store.state.usrstomod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      newStatus: '',
      filterModalShow: false,
      searchObject: {
        email: '',
        accountNumber: '',
        status: '',
        phoneNumber: '',
        createdDate: '',
        demo: false
      }
    };
  },

  created: function created() {
    this.$store.dispatch('usrstomod/showAllInvoices', { orderBys: 'createdDate' });
  },
  updated: function updated() {
    var tableElement = document.getElementsByTagName('table')[0];
    var tableOriginalWidth = tableElement.offsetWidth;


    var tableHeaders = document.getElementsByTagName('th');

    var tableBodyCells = document.getElementsByTagName('td');

    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      var totalColumnWidth = 0;
      tableElement.style.width = tableOriginalWidth * 4.5 + 'px';
      tableElement.style.maxWidth = tableOriginalWidth * 4.5 + 'px';

      for (var i = 0; i < tableHeaders.length; i++) {
        var headerWidth = tableHeaders[i].offsetWidth;
        var cellWidth = tableBodyCells[i].offsetWidth;

        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth;
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px';
        tableElement.style.maxWidth = totalColumnWidth + 'px';
      }
    }
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('usrstomod/changePageNumber', this.currentPage);
      this.$store.dispatch('usrstomod/showAllInvoices', { orderBys: 'createdDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.usrstomod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('usrstomod/changePageNumber', this.currentPage);
        this.$store.commit('usrstomod/setRowsPerPage', intRows);
        this.$store.dispatch('usrstomod/showAllInvoices', { orderBys: 'createdDate' });
      }
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);
      this.selectedRowItem = item;
      this.$store.commit('usrstomod/selectTableRow', this.selectedRowItem.email);
    },
    newStatusSelected: function newStatusSelected(selectedStatus) {
      this.newStatus = selectedStatus;
      console.log('selected new status: ' + this.newStatus);
    },
    searchStatusSelected: function searchStatusSelected(selectedStatus) {
      this.searchObject.status = selectedStatus;
    },
    showApproveModal: function showApproveModal() {
      this.$store.commit('usrstomod/toggleShowConfirmApproveModal', true);
    },
    closeApproveModal: function closeApproveModal() {
      this.$store.commit('usrstomod/toggleShowConfirmApproveModal', false);
    },
    showChangeStatusModal: function showChangeStatusModal() {
      this.$store.commit('usrstomod/toggleShowChangeUserStatusModal', true);
    },
    closeChangeStatusModal: function closeChangeStatusModal() {
      this.$store.commit('usrstomod/toggleShowChangeUserStatusModal', false);
    },
    showModifyUserModal: function showModifyUserModal() {
      if (this.selectedRowItem) {
        this.$store.commit('usrstomod/setEditedName', this.selectedRowItem.name);
        this.$store.commit('usrstomod/setEditedEmail', this.selectedRowItem.email);
        this.$store.commit('usrstomod/setEditedAccountNumber', this.selectedRowItem.accountNumber);
        this.$store.commit('usrstomod/setEditedPhoneNumber', this.selectedRowItem.phoneNumber);
        this.$store.commit('usrstomod/setEditedCompanyName', this.selectedRowItem.companyName);
        this.$store.commit('usrstomod/setEditedCompanyRegistrationNumber', this.selectedRowItem.companyRegistrationNumber);
        this.$store.commit('usrstomod/setEditedBankName', this.selectedRowItem.bankName);
        this.$store.commit('usrstomod/setEditedBankAccountName', this.selectedRowItem.bankAccountName);
        this.$store.commit('usrstomod/setEditedBankAccountNumber', this.selectedRowItem.bankAccountNumber);

        if (this.selectedRowItem.demo) {
          this.$store.commit('usrstomod/setIsDemoAccount', this.selectedRowItem.demo);
        } else {
          this.$store.commit('usrstomod/setIsDemoAccount', false);
        }

        this.$store.commit('usrstomod/toggleShowEditUserModal', true);
      }
    },
    generateClaimsReport: function generateClaimsReport() {
      if (this.selectedRowItem) {
        this.$router.push({
          name: 'UserClaimReport',
          params: {
            name: this.selectedRowItem.companyName,
            email: this.selectedRowItem.email,
            accountNumber: this.selectedRowItem.accountNumber,
            bankName: this.selectedRowItem.bankName,
            bankAccountName: this.selectedRowItem.bankAccountName,
            bankAccountNumber: this.selectedRowItem.bankAccountNumber
          }
        });
      }
    },
    closeEditUserModal: function closeEditUserModal() {
      this.$store.commit('usrstomod/toggleShowEditUserModal', false);
    },
    approveUser: function approveUser() {
      if (this.selectedRowItem) {
        this.$store.dispatch('usrstomod/approveUser', { email: this.selectedRowItem.email });
      }
    },
    changeStatus: function changeStatus() {
      if (this.selectedRowItem) {
        this.$store.dispatch('usrstomod/changeUserStatus', {
          email: this.selectedRowItem.email,
          newStatus: this.newStatus
        });
      }
    },
    refreshTable: function refreshTable() {
      this.currentPage = 1;
      this.$store.commit('usrstomod/changePageNumber', this.currentPage);
      this.$store.dispatch('usrstomod/showAllInvoices', { orderBys: 'createdDate' });
    },
    updateUser: function updateUser() {
      if (this.selectedRowItem) {
        this.$store.dispatch('usrstomod/updateUser');
      }
    },
    filter: function filter() {
      this.filterModalShow = false;
      this.$store.dispatch('usrstomod/filterTable', this.searchObject);
    },
    clearFilters: function clearFilters() {
      if (this.searchObject.email === '' && this.searchObject.accountNumber === '' && this.searchObject.status === '' && this.searchObject.phoneNumber === '' && this.searchObject.createdDate === '' && this.searchObject.demo === false) {
        return;
      }
      this.searchObject.email = '';
      this.searchObject.accountNumber = '';
      this.searchObject.status = '';
      this.searchObject.phoneNumber = '';
      this.searchObject.createdDate = '';
      this.searchObject.demo = false;
      this.currentPage = 1;
      this.$store.commit('usrstomod/changePageNumber', this.currentPage);
      this.$store.dispatch('usrstomod/showAllInvoices', { orderBys: 'createdDate' });
    }
  },
  computed: {
    disabledPagination: function disabledPagination() {
      return this.$store.state.usrstomod.disabledPagination;
    },
    tableRows: function tableRows() {
      return this.$store.state.usrstomod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['usrstomod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.usrstomod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.usrstomod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.usrstomod.rowsPerPage;
    },
    showConfirmApproveModal: {
      get: function get() {
        return this.$store.state.usrstomod.showConfirmApproveModal;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/toggleShowConfirmApproveModal', newValue);
      }
    },
    showChangeUserStatusModal: {
      get: function get() {
        return this.$store.state.usrstomod.showChangeUserStatusModal;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/toggleShowChangeUserStatusModal', newValue);
      }
    },
    showEditUserModal: {
      get: function get() {
        return this.$store.state.usrstomod.showEditUserModal;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/toggleShowEditUserModal', newValue);
      }
    },
    editedUserName: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.name;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedName', newValue);
      }
    },
    editedEmail: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.email;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedEmail', newValue);
      }
    },
    editedAccountNumber: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.accountNumber;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedAccountNumber', newValue);
      }
    },
    editedPhoneNumber: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.phoneNumber;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedPhoneNumber', newValue);
      }
    },
    editedCompanyName: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.companyName;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedCompanyName', newValue);
      }
    },
    editedCompanyRegistrationNumber: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.companyRegistrationNumber;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedCompanyRegistrationNumber', newValue);
      }
    },
    editedBankName: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.bankName;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedBankName', newValue);
      }
    },
    editedBankAccountName: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.bankAccountName;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedBankAccountName', newValue);
      }
    },
    editedBankAccountNumber: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.bankAccountNumber;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setEditedBankAccountNumber', newValue);
      }
    },
    editedIsDemoAccount: {
      get: function get() {
        return this.$store.state.usrstomod.editedUser.isDemoAccount;
      },
      set: function set(newValue) {
        this.$store.commit('usrstomod/setIsDemoAccount', newValue);
      }
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.usrstomod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.usrstomod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.usrstomod.showNoResult;
    }
  },
  name: 'users'
});

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentPage: this.$store.state.invimpmod.currentPage,
      paginationButtonsLimit: 3
    };
  },

  created: function created() {
    this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' });
  },
  updated: function updated() {
    var tableElement = document.getElementsByTagName('table')[0];
    var tableOriginalWidth = tableElement.offsetWidth;


    var tableHeaders = document.getElementsByTagName('th');

    var tableBodyCells = document.getElementsByTagName('td');

    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      var totalColumnWidth = 0;
      tableElement.style.width = tableOriginalWidth * 2 + 'px';
      tableElement.style.maxWidth = tableOriginalWidth * 2 + 'px';

      for (var i = 0; i < tableHeaders.length; i++) {
        var headerWidth = tableHeaders[i].offsetWidth;
        var cellWidth = tableBodyCells[i].offsetWidth;

        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth;
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px';
        tableElement.style.maxWidth = totalColumnWidth + 'px';
      }
    }
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('invimpmod/changePageNumber', this.currentPage);
      this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.invimpmod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('invimpmod/changePageNumber', this.currentPage);
        this.$store.commit('invimpmod/setRowsPerPage', intRows);
        this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' });
      }
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);
    },
    refreshTable: function refreshTable() {
      this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' });
    }
  },
  computed: {
    tableRows: function tableRows() {
      return this.$store.state.invimpmod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['invimpmod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.invimpmod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.invimpmod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('invimpmod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.invimpmod.rowsPerPage;
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.invimpmod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.invimpmod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.invimpmod.showNoResult;
    }
  },
  name: 'invoiceimports'
});

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(79);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DateTimePicker: __WEBPACK_IMPORTED_MODULE_0__components___["c" /* DateTimePicker */],
    MyModal: __WEBPACK_IMPORTED_MODULE_0__components___["f" /* MyModal */]
  },
  data: function data() {
    return {
      currentPage: this.$store.state.cammod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      newStatus: ''
    };
  },

  created: function created() {
    this.$store.dispatch('cammod/showAllCampaigns', { orderBys: 'createdDate' });
  },
  updated: function updated() {
    var tableElement = document.getElementsByTagName('table')[0];
    var tableOriginalWidth = tableElement.offsetWidth;


    var tableHeaders = document.getElementsByTagName('th');

    var tableBodyCells = document.getElementsByTagName('td');

    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      var totalColumnWidth = 0;
      tableElement.style.width = tableOriginalWidth * 4 + 'px';
      tableElement.style.maxWidth = tableOriginalWidth * 4 + 'px';

      for (var i = 0; i < tableHeaders.length; i++) {
        var headerWidth = tableHeaders[i].offsetWidth;
        var cellWidth = tableBodyCells[i].offsetWidth;

        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth;
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px';
        tableElement.style.maxWidth = totalColumnWidth + 'px';
      }
    }
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('cammod/changePageNumber', this.currentPage);
      this.$store.dispatch('cammod/showAllCampaigns', { orderBys: 'createdDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.cammod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('cammod/changePageNumber', this.currentPage);
        this.$store.commit('cammod/setRowsPerPage', intRows);
        this.$store.dispatch('cammod/showAllCampaigns', { orderBys: 'createdDate' });
      }
    },
    newStatusSelected: function newStatusSelected(selectedStatus) {
      this.newStatus = selectedStatus;
      console.log('selected new status: ' + this.newStatus);
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked, index:' + index + ' item:' + item + ' event:' + event);

      this.$store.commit('cammod/selectTableRow', item.campaignId);
      this.selectedRowItem = item;
    },
    refreshTable: function refreshTable() {
      this.$store.dispatch('cammod/showAllCampaigns', { orderBys: 'createdDate' });
    },
    showChangeStatus: function showChangeStatus() {
      if (this.selectedRowItem) {
        this.newStatus = '';
        this.$store.commit('cammod/toggleShowChangeStatusModal', true);
      }
    },
    showEditCampaign: function showEditCampaign(campaign) {
      if (campaign) {
        this.selectedRowItem = campaign;
        this.$store.commit('cammod/selectTableRow', campaign.campaignId);
      }
      if (this.selectedRowItem) {
        this.$store.dispatch('cammod/fetchAvailableOrderTypesFromFirestore');

        this.$store.dispatch('cammod/fetchAvailableLensDesignsFromFirestore');

        this.$store.dispatch('cammod/fetchAvailableLensIndexesFromFirestore');

        this.$store.commit('cammod/updateNewCampaignId', this.selectedRowItem.campaignId);
        this.$store.commit('cammod/updateNewCampaignName', this.selectedRowItem.name);
        this.$store.commit('cammod/updateNewCampaignDescription', this.selectedRowItem.description);
        this.$store.commit('cammod/updateNewCampaignImageUrl', this.selectedRowItem.campaignImageUrl);
        this.$store.commit('cammod/updateNewCampaignImageStoragePath', this.selectedRowItem.campaignImageStoragePath);
        this.$store.commit('cammod/updateEditedCampaignBannerFile', null);
        this.$store.commit('cammod/updateminimumInvoicePerPiece', this.selectedRowItem.minimumPrice);
        this.$store.commit('cammod/updateEligibleLenseDesigns', this.selectedRowItem.lensDesigns);
        this.$store.commit('cammod/updateEligibleOrderTypes', this.selectedRowItem.orderTypes);
        this.$store.commit('cammod/updateEligibleLensIndexes', this.selectedRowItem.lensIndexes || []);
        this.$store.commit('cammod/updateEditedCampaignRewards', this.selectedRowItem.notesPool || []);
        this.$store.dispatch('cammod/fetchEditedCampaignLiveRewards', { campaignId: this.selectedRowItem.campaignId });

        if (this.selectedRowItem.demo) {
          this.$store.commit('cammod/updateEditedIsDemoAccount', this.selectedRowItem.demo);
        } else {
          this.$store.commit('cammod/updateEditedIsDemoAccount', false);
        }

        this.$store.commit('cammod/toggleShowEditCampaignModal', true);
        this.$nextTick(function () {
          if (this.$refs.editCampaignStartDateRef) {
            this.$refs.editCampaignStartDateRef.setInitialDate(this.selectedRowItem.startDate);
          }
          if (this.$refs.editCampaignEndDateRef) {
            this.$refs.editCampaignEndDateRef.setInitialDate(this.selectedRowItem.endDate);
          }
          if (this.$refs.editCampaignStartInvoiceDateRef) {
            this.$refs.editCampaignStartInvoiceDateRef.setInitialDate(this.selectedRowItem.invoiceStartDate);
          }
          if (this.$refs.editCampaignEndInvoiceDateRef) {
            this.$refs.editCampaignEndInvoiceDateRef.setInitialDate(this.selectedRowItem.invoiceEndDate);
          }
        });
      }
    },
    changeStatus: function changeStatus() {
      this.$store.dispatch('cammod/updateCampaignStatus', {
        campaignId: this.selectedRowItem.campaignId,
        newStatus: this.newStatus,
        totalPrizeMoney: this.selectedRowItem.totalPrizeMoney,
        notesPool: this.selectedRowItem.notesPool
      });
    },
    editCampaign: function editCampaign() {
      this.$store.dispatch('cammod/updateCampaign', { campaignId: this.selectedRowItem.campaignId });
    },
    addEditedCampaignReward: function addEditedCampaignReward() {
      this.$store.commit('cammod/addEditedCampaignReward');
    },
    removeEditedCampaignReward: function removeEditedCampaignReward(index) {
      this.$store.commit('cammod/removeEditedCampaignReward', index);
    },
    editedCampaignBannerChanged: function editedCampaignBannerChanged(fileList) {
      var file = fileList && fileList.length > 0 ? fileList[0] : null;
      this.$store.commit('cammod/updateEditedCampaignBannerFile', file);
    },
    closeUpdatingStatusModal: function closeUpdatingStatusModal() {
      this.$store.commit('cammod/toggleShowUpdatingStatusModal', false);
    },
    closeShowChangeStatusModal: function closeShowChangeStatusModal() {
      this.$store.commit('cammod/toggleShowChangeStatusModal', false);
    },
    closeUpdateSuccessModal: function closeUpdateSuccessModal() {
      this.$store.commit('cammod/toggleshowUpdateSuccessModal', false);
    },
    closeUpdateFailModal: function closeUpdateFailModal() {
      this.$store.commit('cammod/toggleShowUpdateFailModal', false);
    },
    closeEditCampaignModal: function closeEditCampaignModal() {
      this.$store.commit('cammod/toggleShowEditCampaignModal', false);
    },
    updateCampaignStartDate: function updateCampaignStartDate(dateString) {
      this.$store.commit('cammod/updateNewCampaignStartDate', dateString);
    },
    updateCampaignEndDate: function updateCampaignEndDate(dateString) {
      this.$store.commit('cammod/updateNewCampaignEndDate', dateString);
    },
    updateInvoiceStartDate: function updateInvoiceStartDate(dateString) {
      this.$store.commit('cammod/updateNewInvoiceStartDate', dateString);
    },
    updateInvoiceEndDate: function updateInvoiceEndDate(dateString) {
      this.$store.commit('cammod/updateNewInvoiceEndDate', dateString);
    },
    showCampaignLivePool: function showCampaignLivePool(campaignId) {
      for (var i = 0; i < this.tableRows.length; i++) {
        if (this.tableRows[i].campaignId === campaignId) {
          this.selectedRowItem = this.tableRows[i];
          this.$store.commit('cammod/selectTableRow', campaignId);
          break;
        }
      }
      this.$store.commit('cammod/toggleShowCampaignLiveModal', true);
      this.$store.dispatch('cammod/showCampaignMoneyPool', { campaignId: campaignId });
    },
    showDetailRow: function showDetailRow(campaignId) {
      this.$store.commit('cammod/toggleShowHideRowDetail', campaignId);
    },
    closeCampaignLiveModal: function closeCampaignLiveModal() {
      this.$store.commit('cammod/turnOffLiveCampignListener');
      this.$store.commit('cammod/toggleShowCampaignLiveModal', false);
    },
    getRewardValue: function getRewardValue(reward) {
      return Number(reward.rewardValue || reward.noteType || 0);
    },
    getRewardQuantity: function getRewardQuantity(reward) {
      return Number(reward.totalQuantity || reward.noteAmount || 0);
    },
    getRewardClaimedQuantity: function getRewardClaimedQuantity(reward) {
      return Number(reward && (reward.claimedQuantity || reward.claimedAmount) || 0);
    },
    getRewardLabel: function getRewardLabel(reward) {
      if (!reward) {
        return 'Reward';
      }
      if (reward.rewardLabel && reward.rewardLabel.length > 0) {
        return reward.rewardLabel;
      }
      var rewardValue = this.getRewardValue(reward);
      return rewardValue > 0 ? 'RM ' + rewardValue : 'Reward';
    }
  },
  computed: {
    tableRows: function tableRows() {
      return this.$store.state.cammod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['cammod/getHeaders'];
    },
    campaignLiveModalTitle: function campaignLiveModalTitle() {
      if (this.selectedRowItem && this.selectedRowItem.name) {
        return 'Campaign Reward Pool Live Data - ' + this.selectedRowItem.name;
      }
      return 'Campaign Reward Pool Live Data';
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.cammod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.cammod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.cammod.rowsPerPage;
    },
    showUpdatingStatusModal: function showUpdatingStatusModal() {
      return this.$store.state.cammod.showUpdatingStatusModal;
    },
    showChangeStatusModal: {
      get: function get() {
        return this.$store.state.cammod.showChangeStatusModal;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/toggleShowChangeStatusModal', newValue);
      }
    },
    showUpdateSuccessModal: function showUpdateSuccessModal() {
      return this.$store.state.cammod.showUpdateSuccessModal;
    },
    showUpdateFailModal: function showUpdateFailModal() {
      return this.$store.state.cammod.showUpdateFailModal;
    },
    showEditCampaignModal: {
      get: function get() {
        return this.$store.state.cammod.showEditCampaignModal;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/toggleShowEditCampaignModal', newValue);
      }
    },
    editedCampaignName: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.name;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/updateNewCampaignName', newValue);
      }
    },
    editedCampaignDescription: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.description;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/updateNewCampaignDescription', newValue);
      }
    },
    editedCampaignImageUrl: function editedCampaignImageUrl() {
      return this.$store.state.cammod.editedCampaign.campaignImageUrl;
    },
    editedCampaignStartDate: {
      get: function get() {
        return this.$store.getters['cammod/getEditedCampaignStartDate'];
      }
    },
    editedCampaignEndDate: {
      get: function get() {
        return this.$store.getters['cammod/getEditedCampaignEndDate'];
      }
    },
    editedCampaignInvoiceStartDate: {
      get: function get() {
        return this.$store.getters['cammod/getEditedCampaignInvoiceStartDate'];
      }
    },
    editedCampaignInvoiceEndDate: {
      get: function get() {
        return this.$store.getters['cammod/getEditedCampaignInvoiceEndDate'];
      }
    },
    editedCampaignRewards: function editedCampaignRewards() {
      return this.$store.state.cammod.editedCampaign.notesPool;
    },
    editedCampaignMinimumInvoicePerPiece: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.minimumInvoicePerPiece;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/updateminimumInvoicePerPiece', newValue);
      }
    },
    editedIsDemoAccount: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.editedIsDemoAccount;
      },
      set: function set(newValue) {
        this.$store.commit('cammod/updateEditedIsDemoAccount', newValue);
      }
    },
    showCampaignLiveModal: {
      get: function get() {
        return this.$store.state.cammod.showCampaignLiveModal;
      },
      set: function set(newValue) {
        if (newValue === false) {
          console.log('setter show campaign live modal to false');
          this.$store.commit('cammod/turnOffLiveCampignListener');
        }
        this.$store.commit('cammod/toggleShowCampaignLiveModal', newValue);
      }
    },
    campaignMoneyPool: {
      get: function get() {
        return this.$store.state.cammod.campaignMoneyPool;
      }
    },
    editedCampaignAvailableEligibleOrderTypes: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.availableEligibleOrderTypes;
      }
    },
    editedCampaignSelectedEligibleOrderTypes: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.eligibleOrderTypes;
      },
      set: function set(items) {
        this.$store.commit('cammod/updateEligibleOrderTypes', items);
      }
    },
    editedCampaignAvailableEligibleLensDesign: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.availableEligibleLensDesigns;
      }
    },
    editedCampaignSelectedEligibleLensDesign: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.eligibleLensDesigns;
      },
      set: function set(items) {
        this.$store.commit('cammod/updateEligibleLenseDesigns', items);
      }
    },
    editedCampaignAvailableEligibleLensIndex: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.availableEligibleLensIndexes;
      }
    },
    editedCampaignSelectedEligibleLensIndex: {
      get: function get() {
        return this.$store.state.cammod.editedCampaign.eligibleLensIndexes;
      },
      set: function set(items) {
        this.$store.commit('cammod/updateEligibleLensIndexes', items);
      }
    },
    selectedRowItemIsDemoCampaign: function selectedRowItemIsDemoCampaign() {
      if (this.selectedRowItem && this.selectedRowItem.hasOwnProperty('demo') && this.selectedRowItem.demo === true) {
        return true;
      }
      return false;
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.cammod.showLoadingAnimation;
    },
    updateFailMessage: function updateFailMessage() {
      return this.$store.state.cammod.loadingErrorMessage || 'Update failed';
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.cammod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.cammod.showNoResult;
    }
  },
  name: 'campaigns'
});

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(79);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'createcampaign',
  components: {
    DateTimePicker: __WEBPACK_IMPORTED_MODULE_0__components___["c" /* DateTimePicker */],
    MyModal: __WEBPACK_IMPORTED_MODULE_0__components___["f" /* MyModal */]
  },
  data: function data() {
    return {};
  },

  created: function created() {
    this.$store.dispatch('crtcammod/fetchAvailableOrderTypesFromFirestore');
    this.$store.dispatch('crtcammod/fetchAvailableLensDesignsFromFirestore');
    this.$store.dispatch('crtcammod/fetchAvailableLensIndexesFromFirestore');
  },
  methods: {
    createCampaign: function createCampaign() {
      this.$store.dispatch('crtcammod/createCampaignInFirebase');
    },
    updateCampaignStartDate: function updateCampaignStartDate(dateString) {
      this.$store.commit('crtcammod/updateCampaignStartDate', dateString);
    },
    updateCampaignEndDate: function updateCampaignEndDate(dateString) {
      this.$store.commit('crtcammod/updateCampaignEndDate', dateString);
    },
    updateInvoiceStartDate: function updateInvoiceStartDate(dateString) {
      this.$store.commit('crtcammod/updateInvoiceStartDate', dateString);
    },
    updateInvoiceEndDate: function updateInvoiceEndDate(dateString) {
      this.$store.commit('crtcammod/updateInvoiceEndDate', dateString);
    },
    closeModal: function closeModal() {
      this.$store.commit('crtcammod/toggleShowModal', false);
    },
    closeSuccessModal: function closeSuccessModal() {
      this.$store.commit('crtcammod/toggleShowCreateSuccessModal', false);
    },
    closeFailModal: function closeFailModal() {
      this.$store.commit('crtcammod/toggleShowCreateFailedModal', false);
    },
    closeValidationModal: function closeValidationModal() {
      this.$store.commit('crtcammod/toggleShowValidationModal', false);
    },
    addCustomNote: function addCustomNote() {
      this.$store.commit('crtcammod/addCustomNote');
    },
    removeCustomNote: function removeCustomNote(index) {
      this.$store.commit('crtcammod/removeCustomNote', index);
    },
    updatedCustomNote: function updatedCustomNote() {
      console.log('updatedCustomNote');
      this.$store.commit('crtcammod/updatedCustomNote');
    },
    campaignBannerChanged: function campaignBannerChanged(fileList) {
      var file = fileList && fileList.length > 0 ? fileList[0] : null;
      this.$store.commit('crtcammod/updateCampaignBannerFile', file);
    }
  },
  computed: {
    showModal: function showModal() {
      return this.$store.state.crtcammod.showModal;
    },
    showCreateSuccessModal: function showCreateSuccessModal() {
      return this.$store.state.crtcammod.showCreateSuccessModal;
    },
    showCreateFailedModal: function showCreateFailedModal() {
      return this.$store.state.crtcammod.showCreateFailedModal;
    },
    showValidationModal: function showValidationModal() {
      return this.$store.state.crtcammod.showValidationModal;
    },
    availableLensDesigns: function availableLensDesigns() {
      return this.$store.state.crtcammod.availableLensDesigns;
    },
    availableLensIndexes: function availableLensIndexes() {
      return this.$store.state.crtcammod.availableLensIndexes;
    },
    availableOrderTypes: function availableOrderTypes() {
      return this.$store.state.crtcammod.availableOrderTypes;
    },
    name: {
      get: function get() {
        return this.$store.state.crtcammod.name;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateName', newValue);
      }
    },
    isDemo: {
      get: function get() {
        return this.$store.state.crtcammod.isDemo;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/udpateIsDemo', newValue);
      }
    },
    description: {
      get: function get() {
        return this.$store.state.crtcammod.description;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateDescription', newValue);
      }
    },
    totalPrizeMoney: {
      get: function get() {
        return this.$store.state.crtcammod.totalPrizeMoney;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateTotalPrizeMoney', newValue);
      }
    },
    startDate: {
      get: function get() {
        return this.$store.getters['crtcammod/getStartDate'];
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateCampaignStartDate', newValue);
      }
    },
    endDate: {
      get: function get() {
        return this.$store.getters['crtcammod/getEndDate'];
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateCampaignEndDate', newValue);
      }
    },
    invoiceStartDate: {
      get: function get() {
        return this.$store.getters['crtcammod/getInvoiceStartDate'];
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateInvoiceStartDate', newValue);
      }
    },
    invoiceEndDate: {
      get: function get() {
        return this.$store.getters['crtcammod/getInvoiceEndDate'];
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateInvoiceEndDate', newValue);
      }
    },
    minimumInvoicePricePerPiece: {
      get: function get() {
        return this.$store.state.crtcammod.minimumInvoicePricePerPiece;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateMinimumInvoicePrice', newValue);
      }
    },
    eligibleLenseDesigns: {
      get: function get() {
        return this.$store.state.crtcammod.eligibleLenseDesigns;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateEligibleLenseDesigns', newValue);
      }
    },
    eligibleLensIndexes: {
      get: function get() {
        return this.$store.state.crtcammod.eligibleLensIndexes;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateEligibleLensIndexes', newValue);
      }
    },
    eligibleOrderTypes: {
      get: function get() {
        return this.$store.state.crtcammod.eligibleOrderTypes;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateEligibleOrderTypes', newValue);
      }
    },
    rm5Amount: {
      get: function get() {
        return this.$store.state.crtcammod.rm5Amount;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateRm5Amount', newValue);
      }
    },
    rm10Amount: {
      get: function get() {
        return this.$store.state.crtcammod.rm10Amount;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateRm10Amount', newValue);
      }
    },
    rm20Amount: {
      get: function get() {
        return this.$store.state.crtcammod.rm20Amount;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateRm20Amount', newValue);
      }
    },
    rm30Amount: {
      get: function get() {
        return this.$store.state.crtcammod.rm30Amount;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateRm30Amount', newValue);
      }
    },
    rm50Amount: {
      get: function get() {
        return this.$store.state.crtcammod.rm50Amount;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateRm50Amount', newValue);
      }
    },
    rm100Amount: {
      get: function get() {
        return this.$store.state.crtcammod.rm100Amount;
      },
      set: function set(newValue) {
        this.$store.commit('crtcammod/updateRm100Amount', newValue);
      }
    },
    sumOfAllNotes: {
      get: function get() {
        return this.$store.state.crtcammod.sumOfAllNotes;
      }
    },
    customRMAmount: {
      get: function get() {
        return this.$store.state.crtcammod.customRMAmount;
      }
    },
    validationMessage: {
      get: function get() {
        return this.$store.state.crtcammod.validationMessage;
      }
    }
  }
});

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var tncFile = __webpack_require__(763);
var ppFile = __webpack_require__(764);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    showTermsAndConditions: function showTermsAndConditions() {
      window.open(tncFile);
    },
    showPrivacyPolicy: function showPrivacyPolicy() {
      window.open(ppFile);
    }
  }
});

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(241);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    signIn: function signIn() {
      console.log('signing in...');
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        console.log('User had been signed in');
        self.$router.replace('invoices');
      }, function (err) {
        console.error('Error signing in: ' + err);
        alert('Error signing in: ' + err);
      });
    }
  }
});

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentPage: this.$store.state.claimmod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      filterModalShow: false,
      claimsCalculateModalShow: false,
      filterObject: {
        campaignDocId: '',
        claimEmail: '',
        prizeMoney: '',
        status: '',
        requestedTaxInvoice: '',
        hoyaAccountNumber: ''
      },
      calculateClaimsObject: {
        campaignDocId: '',
        claimEmail: ''
      }
    };
  },

  created: function created() {
    this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' });
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('claimmod/changePageNumber', this.currentPage);
      this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.claimmod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('claimmod/changePageNumber', this.currentPage);
        this.$store.commit('claimmod/setRowsPerPage', intRows);
        this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' });
      }
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);
      this.$store.commit('claimmod/selectTableRow', item.docId);
      this.selectedRowItem = item;
    },
    refreshTable: function refreshTable() {
      this.currentPage = 1;
      this.$store.commit('claimmod/changePageNumber', this.currentPage);
      this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' });
    },
    filterTable: function filterTable() {
      this.filterModalShow = false;
      this.$store.dispatch('claimmod/filterTable', this.filterObject);
    },
    clearFilters: function clearFilters() {
      var haveFilter = false;
      for (var i in this.filterObject) {
        if (!this.filterObject[i] || this.filterObject[i] === '') {
          haveFilter = true;
        }
        this.filterObject[i] = '';
      }
      if (!haveFilter) {
        return;
      }
      this.currentPage = 1;
      this.$store.commit('claimmod/changePageNumber', this.currentPage);
      this.$store.dispatch('claimmod/showAllClaims', { orderBys: 'createdDate' });
    },
    calculateClaims: function calculateClaims() {
      this.$store.dispatch('claimmod/calculateClaims', this.calculateClaimsObject);
    },
    searchStatusSelected: function searchStatusSelected(selectedStatus) {
      this.filterObject.status = selectedStatus;
    }
  },
  computed: {
    disabledPagination: function disabledPagination() {
      return this.$store.state.claimmod.disabledPagination;
    },
    tableRows: function tableRows() {
      return this.$store.state.claimmod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['claimmod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.claimmod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.claimmod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('claimmod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.claimmod.rowsPerPage;
    },
    calculatedObjects: function calculatedObjects() {
      return this.$store.state.claimmod.calculatedObjects;
    },
    calculatedTotalClaimedPrizeMoney: function calculatedTotalClaimedPrizeMoney() {
      return this.$store.state.claimmod.calculatedTotalClaimedPrizeMoney;
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.claimmod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.claimmod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.claimmod.showNoResult;
    }
  },
  name: 'Claims'
});

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(79);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MyModal: __WEBPACK_IMPORTED_MODULE_0__components___["f" /* MyModal */]
  },
  data: function data() {
    return {
      currentPage: this.$store.state.usrstomod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      searchModalShow: false,
      rejectReason: '',
      filterObject: {
        campaignId: '',
        requester: '',
        invoiceNumberOne: '',
        invoiceNumberTwo: '',
        status: ''
      }
    };
  },

  created: function created() {
    this.$store.dispatch('pairmod/showAllPairRequests', { orderBys: 'createdDate' });
  },
  updated: function updated() {
    var tableElement = document.getElementsByTagName('table')[0];
    var tableOriginalWidth = tableElement.offsetWidth;


    var tableHeaders = document.getElementsByTagName('th');

    var tableBodyCells = document.getElementsByTagName('td');

    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      var totalColumnWidth = 0;
      tableElement.style.width = tableOriginalWidth * 2 + 'px';
      tableElement.style.maxWidth = tableOriginalWidth * 2 + 'px';

      for (var i = 0; i < tableHeaders.length; i++) {
        var headerWidth = tableHeaders[i].offsetWidth;
        var cellWidth = tableBodyCells[i].offsetWidth;

        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth;
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px';
        tableElement.style.maxWidth = totalColumnWidth + 'px';
      }
    }
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('pairmod/changePageNumber', this.currentPage);
      this.$store.dispatch('pairmod/showAllPairRequests', { orderBys: 'createdDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.claimmod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('pairmod/changePageNumber', this.currentPage);
        this.$store.commit('pairmod/setRowsPerPage', intRows);
        this.$store.dispatch('pairmod/showAllPairRequests', { orderBys: 'createdDate' });
      }
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);
      this.$store.commit('pairmod/selectTableRow', item.pairRequestsDocId);
      this.selectedRowItem = item;
    },
    refreshTable: function refreshTable() {
      this.$store.dispatch('pairmod/showAllPairRequests', { orderBys: 'createdDate' });
    },
    filterTable: function filterTable() {
      this.searchModalShow = false;
      this.$store.dispatch('pairmod/filterTable', this.filterObject);
    },
    clearFilters: function clearFilters() {
      var haveFilter = false;
      for (var i in this.filterObject) {
        if (!this.filterObject[i] || this.filterObject[i] === '') {
          haveFilter = true;
        }
        this.filterObject[i] = '';
      }
      if (!haveFilter) {
        return;
      }
      this.$store.dispatch('pairmod/showAllPairRequests', { orderBys: 'createdDate' });
    },
    approveOrRejectRequest: function approveOrRejectRequest() {
      if (this.selectedRowItem) {
        this.$store.commit('pairmod/toggleshowApproveOrRejectModal', true);
      }
    },
    approveRequest: function approveRequest() {
      this.$store.dispatch('pairmod/approveRequest', {
        pairId: this.selectedRowItem.pairRequestsDocId,
        campaignId: this.selectedRowItem.campaignId,
        requester: this.selectedRowItem.requester,
        invoiceNumberOne: this.selectedRowItem.invoiceNumberOne,
        invoiceNumberTwo: this.selectedRowItem.invoiceNumberTwo,
        status: this.selectedRowItem.status,
        rejectReason: this.selectedRowItem.rejectReason
      });
    },
    rejectRequest: function rejectRequest() {
      this.$store.dispatch('pairmod/rejectRequest', {
        pairId: this.selectedRowItem.pairRequestsDocId,
        rejectReason: this.rejectReason
      });
    },
    closeUpdatingModal: function closeUpdatingModal() {
      this.$store.commit('pairmod/toogleShowUpdatingModal', false);
    },
    closeUpdateSuccessModal: function closeUpdateSuccessModal() {
      this.$store.commit('pairmod/toggleShowUpdateSuccessModal', false);
    },
    closeUpdateFailModal: function closeUpdateFailModal() {
      this.$store.commit('pairmod/toogleShowUpdateFailedModal', false);
    }
  },
  computed: {
    tableRows: function tableRows() {
      return this.$store.state.pairmod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['pairmod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.pairmod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.pairmod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('pairmod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.pairmod.rowsPerPage;
    },
    approveRejectModalShow: {
      get: function get() {
        return this.$store.state.pairmod.showApproveOrRejectModal;
      },
      set: function set(newValue) {
        this.$store.commit('pairmod/toggleshowApproveOrRejectModal', newValue);
      }
    },
    showUpdatingModal: {
      get: function get() {
        return this.$store.state.pairmod.showUpdatingModal;
      },
      set: function set(newValue) {
        this.$store.commit('pairmod/toggleShowUpdatingModal', newValue);
      }
    },
    showUpdateSuccessModal: {
      get: function get() {
        return this.$store.state.pairmod.showUpdateSuccessModal;
      },
      set: function set(newValue) {
        this.$store.commit('pairmod/toggleShowUpdateSuccessModal', newValue);
      }
    },
    showUpdateFailedModal: {
      get: function get() {
        return this.$store.state.pairmod.showUpdateFailedModal;
      },
      set: function set(newValue) {
        this.$store.commit('pairmod/toggleShowUpdateFailedModal', newValue);
      }
    },
    updateFailMessage: function updateFailMessage() {
      return this.$store.state.pairmod.updateFailMessage;
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.usrstomod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.usrstomod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.usrstomod.showNoResult;
    }
  },
  name: 'PairRequests'
});

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentPage: this.$store.state.usrstomod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null
    };
  },

  created: function created() {
    this.$store.dispatch('cusaccmod/showAllCustomerAccounts');
  },
  updated: function updated() {
    var tableElement = document.getElementsByTagName('table')[0];
    var tableOriginalWidth = tableElement.offsetWidth;


    var tableHeaders = document.getElementsByTagName('th');

    var tableBodyCells = document.getElementsByTagName('td');

    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      var totalColumnWidth = 0;
      tableElement.style.width = tableOriginalWidth * 2 + 'px';
      tableElement.style.maxWidth = tableOriginalWidth * 2 + 'px';

      for (var i = 0; i < tableHeaders.length; i++) {
        var headerWidth = tableHeaders[i].offsetWidth;
        var cellWidth = tableBodyCells[i].offsetWidth;

        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth;
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px';
        tableElement.style.maxWidth = totalColumnWidth + 'px';
      }
    }
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('cusaccmod/changePageNumber', this.currentPage);
      this.$store.dispatch('cusaccmod/showAllCustomerAccounts');
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.claimmod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('cusaccmod/changePageNumber', this.currentPage);
        this.$store.commit('cusaccmod/setRowsPerPage', intRows);
        this.$store.dispatch('cusaccmod/showAllCustomerAccounts');
      }
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);
      this.$store.commit('cusaccmod/selectTableRow', item.docId);
      this.selectedRowItem = item;
    },
    refreshTable: function refreshTable() {
      this.currentPage = 1;
      this.$store.commit('cusaccmod/changePageNumber', this.currentPage);
      this.$store.dispatch('cusaccmod/showAllCustomerAccounts');
    },
    showCreateModal: function showCreateModal() {
      this.$store.commit('cusaccmod/toggleShowCreateModal', true);
    },
    closeCreateModal: function closeCreateModal() {
      this.$store.commit('cusaccmod/toggleShowCreateModal', false);
    },
    addCustomerAccount: function addCustomerAccount() {
      this.$store.dispatch('cusaccmod/addCustomerAccount');
    },
    showSearchModal: function showSearchModal() {
      this.$store.commit('cusaccmod/toggleShowSearchModal', true);
    },
    closeSearchModal: function closeSearchModal() {
      this.$store.commit('cusaccmod/toggleShowSearchModal', false);
    },
    searchCustomer: function searchCustomer() {
      this.$store.dispatch('cusaccmod/searchCustomer');
    }
  },
  computed: {
    disabledPagination: function disabledPagination() {
      return this.$store.state.cusaccmod.disabledPagination;
    },
    tableRows: function tableRows() {
      return this.$store.state.cusaccmod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['cusaccmod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.cusaccmod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.cusaccmod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.cusaccmod.rowsPerPage;
    },
    showCreateModalRef: {
      get: function get() {
        return this.$store.state.cusaccmod.showCreateModal;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/toggleShowCreateModal', newValue);
      }
    },
    showSearchModalRef: {
      get: function get() {
        return this.$store.state.cusaccmod.showSearchModal;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/toggleShowSearchModal', newValue);
      }
    },
    newCustomerAccount: {
      get: function get() {
        return this.$store.state.cusaccmod.newCustomer.customerAccount;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/setNewCustomerAccount', newValue);
      }
    },
    newCustomerName: {
      get: function get() {
        return this.$store.state.cusaccmod.newCustomer.name;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/setNewCustomerName', newValue);
      }
    },
    newCustomerError: function newCustomerError() {
      return this.$store.state.cusaccmod.newCustomer.error;
    },
    searchCustomerAccount: {
      get: function get() {
        return this.$store.state.cusaccmod.searchCustomer.customerAccount;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/setSearchCustomerAccount', newValue);
      }
    },
    searchCustomerName: {
      get: function get() {
        return this.$store.state.cusaccmod.searchCustomer.name;
      },
      set: function set(newValue) {
        this.$store.commit('cusaccmod/setSearchCustomerName', newValue);
      }
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.cusaccmod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.cusaccmod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.cusaccmod.showNoResult;
    }
  },
  name: 'CustomerAccounts'
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(79);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customeraccountupload',
  components: {
    MyModal: __WEBPACK_IMPORTED_MODULE_1__components___["f" /* MyModal */]
  },
  data: function data() {
    return {
      fileToUpload: null,
      currentPage: 1,
      paginationButtonsLimit: 3
    };
  },

  created: function created() {
    this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' });
  },
  methods: {
    fileChange: function fileChange(files) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var eachFile = _step.value;

          console.log('file name: ' + eachFile.name);
          console.log('file size: ' + eachFile.size + 'bytes');
          console.log('file type: ' + eachFile.type);
          this.fileToUpload = eachFile;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    uploadFile: function uploadFile() {
      this.$store.dispatch('cauploadmod/uploadFileToFirebaseStorage', { file: this.fileToUpload });
    },
    closeUploadingModal: function closeUploadingModal() {
      this.$store.commit('cauploadmod/toggleUploadingModal', false);
    },
    closeUploadSuccessModal: function closeUploadSuccessModal() {
      this.$store.commit('cauploadmod/toggleUploadingSuccessModal', false);
      this.fileToUpload = null;
    },
    closeUploadFailModal: function closeUploadFailModal() {
      this.$store.commit('cauploadmod/toggleUploadingFailedModal', false);
    },
    closeImportingModal: function closeImportingModal() {},
    closeImportSuccessModal: function closeImportSuccessModal() {
      this.$store.commit('cauploadmod/toggleImportingSuccessModal', false);
    },
    closeImportFailModal: function closeImportFailModal() {
      this.$store.commit('cauploadmod/toggleImportingFailedModal', false);
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      var intRows = parseInt(rows);
      if (this.$store.state.cauploadmod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('cauploadmod/changePageNumber', this.currentPage);
        this.$store.commit('cauploadmod/setRowsPerPage', intRows);
        this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' });
      }
    },
    importFile: function importFile(docId, filename, status) {
      this.$store.dispatch('cauploadmod/importFile', { docId: docId, filename: filename, status: status });
    },
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      this.$store.commit('cauploadmod/changePageNumber', this.currentPage);
      this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' });
    },
    refreshTable: function refreshTable() {
      this.currentPage = 1;
      this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' });
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      this.$store.commit('cauploadmod/selectTableRow', item.docId);
      this.selectedRowItem = item;
    }
  },
  computed: {
    showUploadingModal: function showUploadingModal() {
      return this.$store.state.cauploadmod.showUploadingModal;
    },
    showUploadingSuccessModal: function showUploadingSuccessModal() {
      return this.$store.state.cauploadmod.showUploadingSuccessModal;
    },
    showUploadingFailedModal: function showUploadingFailedModal() {
      return this.$store.state.cauploadmod.showUploadingFailedModal;
    },
    uploadFailedMessage: function uploadFailedMessage() {
      return this.$store.state.cauploadmod.uploadFailedMessage || 'Upload Failed.';
    },
    showImportingModal: function showImportingModal() {
      return this.$store.state.cauploadmod.showImportingModal;
    },
    showImportingSuccessModal: function showImportingSuccessModal() {
      return this.$store.state.cauploadmod.showImportingSuccessModal;
    },
    showImportingFailedModal: function showImportingFailedModal() {
      return this.$store.state.cauploadmod.showImportingFailedModal;
    },
    importFailedMessage: function importFailedMessage() {
      return this.$store.state.cauploadmod.importFailedMessage;
    },
    tableRows: function tableRows() {
      return this.$store.state.cauploadmod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['cauploadmod/getHeaders'];
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.cauploadmod.rowsPerPage;
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.cauploadmod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.cauploadmod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('cauploadmod/setRowsPerPage', newValue);
      }
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.cauploadmod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.cauploadmod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.cauploadmod.showNoResult;
    },
    selectedFileName: function selectedFileName() {
      if (this.fileToUpload) {
        return this.fileToUpload.name;
      }
      return 'Choose .xls or .xlsx file';
    }
  }
});

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var printjs = __webpack_require__(786);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'email', 'accountNumber', 'bankName', 'bankAccountName', 'bankAccountNumber'],
  data: function data() {
    return {
      searchObject: {
        email: '',
        accountNumber: ''
      }
    };
  },

  created: function created() {
    this.$store.dispatch('ucrmod/fetchUserClaims', { email: this.email });
  },
  methods: {
    print: function print(param1, param2) {
      console.log('Print: ' + printjs);
      printjs.printJS(param1, param2);
    },
    refreshReport: function refreshReport(params) {
      this.$store.dispatch('ucrmod/fetchUserClaims', { email: this.email });
    }
  },
  computed: {
    emailAddress: function emailAddress() {
      return this.email;
    },
    groupedClaims: function groupedClaims() {
      return this.$store.state.ucrmod.groupedByMoneyTypeClaims;
    },
    totalPieces: function totalPieces() {
      return this.$store.state.ucrmod.totalPieces;
    },
    totalAmount: function totalAmount() {
      return this.$store.state.ucrmod.totalAmount;
    },
    capName: function capName() {
      return this.name;
    },
    capEmail: function capEmail() {
      return this.email;
    },
    capAccountNumber: function capAccountNumber() {
      return this.accountNumber;
    },
    capBankName: function capBankName() {
      return this.bankName;
    },
    capBankAccountName: function capBankAccountName() {
      return this.bankAccountName;
    },
    capBankAccountNumber: function capBankAccountNumber() {
      return this.bankAccountNumber;
    }
  },
  name: 'UserClaimReport'
});

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(79);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoiceupload',
  components: {
    MyModal: __WEBPACK_IMPORTED_MODULE_1__components___["f" /* MyModal */]
  },
  data: function data() {
    return {
      fileToUpload: null,
      currentPage: 1,
      paginationButtonsLimit: 3
    };
  },

  created: function created() {
    this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' });
  },
  updated: function updated() {
    var tableElement = document.getElementsByTagName('table')[0];
    var tableOriginalWidth = tableElement.offsetWidth;
    console.log('table width: ' + tableOriginalWidth);

    var tableHeaders = document.getElementsByTagName('th');

    var tableBodyCells = document.getElementsByTagName('td');

    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      var totalColumnWidth = 0;
      tableElement.style.width = tableOriginalWidth * 2 + 'px';
      tableElement.style.maxWidth = tableOriginalWidth * 2 + 'px';

      for (var i = 0; i < tableHeaders.length; i++) {
        var headerWidth = tableHeaders[i].offsetWidth;
        var cellWidth = tableBodyCells[i].offsetWidth;

        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth;
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px';

          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth;
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px';
        tableElement.style.maxWidth = totalColumnWidth + 'px';
      }
    }
  },
  methods: {
    fileChange: function fileChange(files) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var eachFile = _step.value;

          console.log('file name: ' + eachFile.name);
          console.log('file size: ' + eachFile.size + 'bytes');
          console.log('file type: ' + eachFile.type);

          this.fileToUpload = eachFile;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    uploadFile: function uploadFile() {
      this.$store.dispatch('iumod/uploadFileToFirebaseStorage', { file: this.fileToUpload });
    },
    closeUploadingModal: function closeUploadingModal() {
      this.$store.commit('iumod/toggleUploadingModal', false);
    },
    closeUploadSuccessModal: function closeUploadSuccessModal() {
      this.$store.commit('iumod/toggleUploadingSuccessModal', false);
      this.fileToUpload = null;
    },
    closeUploadFailModal: function closeUploadFailModal() {
      this.$store.commit('iumod/toggleUploadingFailedModal', false);
    },
    closeImportingModal: function closeImportingModal() {},
    closeImportSuccessModal: function closeImportSuccessModal() {
      this.$store.commit('iumod/toggleImportingSuccessModal', false);
    },
    closeImportFailModal: function closeImportFailModal() {
      this.$store.commit('iumod/toggleImportingFailedModal', false);
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.iumod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('iumod/changePageNumber', this.currentPage);
        this.$store.commit('iumod/setRowsPerPage', intRows);
        this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' });
      }
    },
    importFile: function importFile(docId, filename, status) {
      this.$store.dispatch('iumod/importFile', { docId: docId, filename: filename, status: status });
    },
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('iumod/changePageNumber', this.currentPage);
      this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' });
    },
    refreshTable: function refreshTable() {
      this.currentPage = 1;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' });
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked, index:' + index + ' item:' + item + ' event:' + event);

      this.$store.commit('iumod/selectTableRow', item.docId);
      this.selectedRowItem = item;
    }
  },
  computed: {
    uploadFileName: function uploadFileName() {
      return this.$store.state.iumod.uploadFileName;
    },
    showUploadingModal: function showUploadingModal() {
      return this.$store.state.iumod.showUploadingModal;
    },
    showUploadingSuccessModal: function showUploadingSuccessModal() {
      return this.$store.state.iumod.showUploadingSuccessModal;
    },
    showUploadingFailedModal: function showUploadingFailedModal() {
      return this.$store.state.iumod.showUploadingFailedModal;
    },
    showImportingModal: function showImportingModal() {
      return this.$store.state.iumod.showImportingModal;
    },
    showImportingSuccessModal: function showImportingSuccessModal() {
      return this.$store.state.iumod.showImportingSuccessModal;
    },
    showImportingFailedModal: function showImportingFailedModal() {
      return this.$store.state.iumod.showImportingFailedModal;
    },
    importFailedMessage: function importFailedMessage() {
      return this.$store.state.iumod.importFailedMessage;
    },
    tableRows: function tableRows() {
      return this.$store.state.iumod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['iumod/getHeaders'];
    },
    uploadingMessage: function uploadingMessage() {
      return 'Please wait' + this.$store.state.iumod.uploadProgress;
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.iumod.rowsPerPage;
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.iumod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.iumod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('iumod/setRowsPerPage', newValue);
      }
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.iumod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.iumod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.iumod.showNoResult;
    }
  }
});

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(79);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MyModal: __WEBPACK_IMPORTED_MODULE_0__components___["f" /* MyModal */]
  },
  data: function data() {
    return {
      currentPage: this.$store.state.gcrmod.currentPage,
      paginationButtonsLimit: 3
    };
  },

  created: function created() {
    this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' });
  },
  methods: {
    pageChanged: function pageChanged(pageNumber) {
      this.currentPage = pageNumber;
      console.log('User changed page to number: ' + this.currentPage);
      this.$store.commit('gcrmod/changePageNumber', this.currentPage);
      this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' });
    },
    rowsPerPageSelected: function rowsPerPageSelected(rows) {
      console.log('rowsPerPageSelected, rows: ' + rows);
      var intRows = parseInt(rows);
      if (this.$store.state.gcrmod.rowsPerPage !== intRows) {
        this.currentPage = 1;
        this.$store.commit('gcrmod/changePageNumber', this.currentPage);
        this.$store.commit('gcrmod/setRowsPerPage', intRows);
        this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' });
      }
    },
    tableRowClicked: function tableRowClicked(item, index, event) {
      console.log('Table row clicked');
      console.log('item: ' + item);
    },
    refreshTable: function refreshTable() {
      this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' });
    },
    generateClaims: function generateClaims() {
      this.$store.dispatch('gcrmod/generateClaimsReports');
    },
    downloadFileFromGCS: function downloadFileFromGCS(selectedJobNumber) {
      console.log('Download zip file from GCS, jobNumber: ' + selectedJobNumber);
      if (selectedJobNumber) {
        this.$store.dispatch('gcrmod/downloadFileFromGCS', { jobNumber: selectedJobNumber });
      }
    },
    closeGeneratingModal: function closeGeneratingModal() {
      this.$store.commit('gcrmod/toggleShowGeneratingModal', false);
    },
    closeGeneratingSuccessModal: function closeGeneratingSuccessModal() {
      this.$store.commit('gcrmod/toggleShowGeneratingSuccessModal', false);
    },
    closeGeneratingFailModal: function closeGeneratingFailModal() {
      this.$store.commit('gcrmod/toggleShowGeneratingFailedModal', false);
    },
    closeCannotGenerateModal: function closeCannotGenerateModal() {
      this.$store.commit('gcrmod/toggleShowCannotGenerateModal', false);
    }
  },
  computed: {
    tableRows: function tableRows() {
      return this.$store.state.gcrmod.all;
    },
    tableHeaders: function tableHeaders() {
      return this.$store.getters['gcrmod/getHeaders'];
    },
    totalRowsC: function totalRowsC() {
      return this.$store.state.gcrmod.totalRows;
    },
    rowsPerPageC: {
      get: function get() {
        return this.$store.state.gcrmod.rowsPerPage;
      },
      set: function set(newValue) {
        this.$store.commit('gcrmod/setRowsPerPage', newValue);
      }
    },
    rowsPerPageCText: function rowsPerPageCText() {
      return '' + this.$store.state.gcrmod.rowsPerPage;
    },
    showLoadingAnimation: function showLoadingAnimation() {
      return this.$store.state.gcrmod.showLoadingAnimation;
    },
    showLoadingError: function showLoadingError() {
      return this.$store.state.gcrmod.showLoadingError;
    },
    showNoResult: function showNoResult() {
      return this.$store.state.gcrmod.showNoResult;
    },
    showGeneratingModal: function showGeneratingModal() {
      return this.$store.state.gcrmod.showGeneratingModal;
    },
    showGeneratingSuccessModal: function showGeneratingSuccessModal() {
      return this.$store.state.gcrmod.showGeneratingSuccessModal;
    },
    showGeneratingFailedModal: function showGeneratingFailedModal() {
      return this.$store.state.gcrmod.showGeneratingFailedModal;
    },
    showCannotGenerateModal: function showCannotGenerateModal() {
      return this.$store.state.gcrmod.showCannotGenerateModal;
    }
  },
  name: 'generateclaimreports'
});

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Banners',
  data: function data() {
    return {
      fileToUpload: null,
      bannerForm: {
        title: '',
        description: '',
        article: '',
        sortOrder: 0,
        active: true
      }
    };
  },

  created: function created() {
    this.$store.dispatch('bannermod/fetchBanners');
  },
  computed: {
    multi: function multi() {
      return this.$store.state.bannermod.multi;
    },
    banners: function banners() {
      return this.$store.state.bannermod.banners;
    },
    allowImage: function allowImage() {
      return this.$store.state.bannermod.allowImage;
    },
    allowDetails: function allowDetails() {
      return this.$store.state.bannermod.allowDetails;
    },
    bannerFields: function bannerFields() {
      return this.$store.getters['bannermod/bannerFields'];
    },
    loading: function loading() {
      return this.$store.state.bannermod.loading;
    },
    uploadProgress: function uploadProgress() {
      return this.$store.state.bannermod.uploadProgress;
    },
    alertVariant: function alertVariant() {
      return this.$store.state.bannermod.alertVariant;
    },
    showDismissibleAlert: {
      get: function get() {
        return this.$store.state.bannermod.showDismissibleAlert;
      },
      set: function set(dismiss) {
        this.$store.commit('bannermod/closeDismissibleAlert', dismiss);
      }
    },
    message: function message() {
      return this.$store.state.bannermod.message;
    }
  },
  watch: {
    banners: function banners(_banners) {
      if (!this.multi && _banners && _banners.length > 0) {
        this.bannerForm.title = _banners[0].title || '';
      }
    }
  },
  methods: {
    fileChange: function fileChange(fileList) {
      this.fileToUpload = fileList && fileList.length > 0 ? fileList[0] : null;
    },
    uploadBanner: function uploadBanner() {
      if (!this.multi) {
        this.saveSingleBanner();
        return;
      }
      this.$store.dispatch('bannermod/uploadBanner', {
        title: this.bannerForm.title,
        description: this.bannerForm.description,
        article: this.bannerForm.article,
        sortOrder: this.bannerForm.sortOrder,
        active: this.bannerForm.active,
        file: this.fileToUpload
      });
      this.bannerForm.article = '';
      this.fileToUpload = null;
    },
    saveSingleBanner: function saveSingleBanner() {
      this.$store.dispatch('bannermod/saveSingleBanner', {
        title: this.bannerForm.title
      });
    },
    refreshTable: function refreshTable() {
      this.$store.dispatch('bannermod/fetchBanners');
    },
    updateBanner: function updateBanner(banner) {
      this.$store.dispatch('bannermod/updateBanner', banner);
    },
    toggleBannerVisibility: function toggleBannerVisibility(banner) {
      this.$store.dispatch('bannermod/updateBanner', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, banner, {
        active: !banner.active
      }));
    },
    deleteBanner: function deleteBanner(banner) {
      if (!this.multi) {
        return;
      }
      if (confirm('Delete this banner?')) {
        this.$store.dispatch('bannermod/deleteBanner', banner);
      }
    }
  }
});

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Notifications',
  data: function data() {
    return {
      selectedEmails: [],
      userCurrentPage: 1,
      usersPerPage: 10,
      logCurrentPage: 1,
      logsPerPage: 10,
      showConfirmModal: false,
      showLogDetailModal: false,
      selectedLog: null,
      responseFields: [{ key: 'email', label: 'Customer Email' }, { key: 'platform', label: 'Platform' }, { key: 'messageId', label: 'Message ID' }, { key: 'error', label: 'Error' }],
      userSearch: '',
      form: {
        title: '',
        body: '',
        blast: false
      },
      settingsForm: {
        enabled: false,
        title: '',
        body: ''
      }
    };
  },

  created: function created() {
    this.$store.dispatch('notifmod/fetchLogs');
    this.$store.dispatch('notifmod/fetchUsers');
    this.$store.dispatch('notifmod/fetchInvoiceEligibleSettings');
  },
  watch: {
    userSearch: function userSearch() {
      this.userCurrentPage = 1;
    },
    invoiceEligibleSettings: {
      handler: function handler(settings) {
        this.settingsForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, settings);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    users: function users() {
      return this.$store.state.notifmod.users;
    },
    userFields: function userFields() {
      return this.$store.getters['notifmod/userFields'];
    },
    filteredUsers: function filteredUsers() {
      var search = this.userSearch.trim().toLowerCase();
      var users = search ? this.users.filter(function (user) {
        return (user.companyName || '').toLowerCase().indexOf(search) !== -1 || (user.accountNumber || '').toLowerCase().indexOf(search) !== -1 || (user.email || '').toLowerCase().indexOf(search) !== -1 || (user.phoneNumber || '').toLowerCase().indexOf(search) !== -1 || (user.status || '').toLowerCase().indexOf(search) !== -1;
      }) : this.users;

      return users.map(function (user) {
        var row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, user);
        row._rowVariant = this.isUserSelected(user.email) ? 'info' : '';
        return row;
      }.bind(this));
    },
    pagedUsers: function pagedUsers() {
      var start = (this.userCurrentPage - 1) * this.usersPerPage;
      return this.filteredUsers.slice(start, start + this.usersPerPage);
    },
    selectedCustomerDetails: function selectedCustomerDetails() {
      var selectedMap = {};
      this.selectedEmails.forEach(function (email) {
        selectedMap[email] = true;
      });
      return this.users.filter(function (user) {
        return selectedMap[user.email];
      });
    },
    logs: function logs() {
      return this.$store.state.notifmod.logs;
    },
    invoiceEligibleSettings: function invoiceEligibleSettings() {
      return this.$store.state.notifmod.invoiceEligibleSettings;
    },
    pagedLogs: function pagedLogs() {
      var start = (this.logCurrentPage - 1) * this.logsPerPage;
      return this.logs.slice(start, start + this.logsPerPage);
    },
    successfulLogResponses: function successfulLogResponses() {
      if (!this.selectedLog || !this.selectedLog.responses) {
        return [];
      }
      return this.selectedLog.responses.filter(function (response) {
        return response.success === true;
      });
    },
    failedLogResponses: function failedLogResponses() {
      if (!this.selectedLog || !this.selectedLog.responses) {
        return [];
      }
      return this.selectedLog.responses.filter(function (response) {
        return response.success !== true;
      });
    },
    logFields: function logFields() {
      return this.$store.getters['notifmod/logFields'];
    },
    loading: function loading() {
      return this.$store.state.notifmod.loading;
    },
    alertVariant: function alertVariant() {
      return this.$store.state.notifmod.alertVariant;
    },
    showDismissibleAlert: {
      get: function get() {
        return this.$store.state.notifmod.showDismissibleAlert;
      },
      set: function set(dismiss) {
        this.$store.commit('notifmod/closeDismissibleAlert', dismiss);
      }
    },
    message: function message() {
      return this.$store.state.notifmod.message;
    }
  },
  methods: {
    isUserSelected: function isUserSelected(email) {
      return this.selectedEmails.indexOf(email) !== -1;
    },
    toggleUser: function toggleUser(user) {
      if (!user || !user.email) {
        return;
      }
      var index = this.selectedEmails.indexOf(user.email);
      if (index === -1) {
        this.selectedEmails.push(user.email);
      } else {
        this.selectedEmails.splice(index, 1);
      }
    },
    selectPageUsers: function selectPageUsers() {
      var selectedMap = {};
      this.selectedEmails.forEach(function (email) {
        selectedMap[email] = true;
      });
      this.pagedUsers.forEach(function (user) {
        if (user.email) {
          selectedMap[user.email] = true;
        }
      });
      this.selectedEmails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selectedMap);
    },
    clearSelectedUsers: function clearSelectedUsers() {
      this.selectedEmails = [];
    },
    sendNotification: function sendNotification() {
      var emails = this.selectedEmails.slice();

      if (!this.form.title || !this.form.body) {
        this.$store.commit('notifmod/showAlert', { variant: 'danger', message: 'Title and message are required.' });
        return;
      }

      if (!this.form.blast && emails.length === 0) {
        this.$store.commit('notifmod/showAlert', { variant: 'danger', message: 'Select at least one customer or choose Blast.' });
        return;
      }

      this.showConfirmModal = true;
    },
    confirmSendNotification: function confirmSendNotification() {
      var emails = this.selectedEmails.slice();
      this.$store.dispatch('notifmod/sendNotification', {
        title: this.form.title,
        body: this.form.body,
        blast: this.form.blast,
        emails: emails
      });
    },
    openLogDetail: function openLogDetail(log) {
      this.selectedLog = log;
      this.showLogDetailModal = true;
    },
    refreshUsers: function refreshUsers() {
      this.$store.dispatch('notifmod/fetchUsers');
    },
    refreshLogs: function refreshLogs() {
      this.$store.dispatch('notifmod/fetchLogs');
    },
    saveInvoiceEligibleSettings: function saveInvoiceEligibleSettings() {
      if (!this.settingsForm.title || !this.settingsForm.body) {
        this.$store.commit('notifmod/showAlert', { variant: 'danger', message: 'Invoice notification title and message are required.' });
        return;
      }
      this.$store.dispatch('notifmod/saveInvoiceEligibleSettings', this.settingsForm);
    }
  }
});

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Configuration',
  data: function data() {
    return {};
  },

  created: function created() {
    this.$store.dispatch('configmod/initialiseConfiguration');
  },
  computed: {
    availableInvoiceFields: {
      get: function get() {
        return this.$store.state.configmod.availableInvoiceFields;
      }
    },
    invoiceFieldsToDisplay: {
      get: function get() {
        return this.$store.state.configmod.invoiceFieldsToDisplay;
      },
      set: function set(newValues) {
        this.$store.commit('configmod/updateInvoiceFieldsToDisplay', newValues);
      }
    },
    alertVariant: {
      get: function get() {
        return this.$store.state.configmod.alertVariant;
      }
    },
    showDismissibleAlert: {
      get: function get() {
        return this.$store.state.configmod.showDismissibleAlert;
      },
      set: function set(dismiss) {
        this.$store.commit('configmod/closeDismissibleAlert', dismiss);
      }
    },
    message: {
      get: function get() {
        return this.$store.state.configmod.message;
      }
    }
  },
  methods: {
    saveInvoiceFieldsToDisplay: function saveInvoiceFieldsToDisplay() {
      this.$store.dispatch('configmod/saveInvoiceFieldsToDisplay');
    },
    resetInvoiceFieldsToDisplay: function resetInvoiceFieldsToDisplay() {
      this.$store.dispatch('configmod/resetInvoiceFieldsToDisplay');
    }
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(2);

var dateTimeFormats = ['DD/MM/YYYY', 'DD/MMM/YYYY', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY h:mm:ss', 'DD/MM/YYYY hh:mm:ss a', 'DD/MM/YYYY hh:mm:ss A', 'DD/MM/YYYY h:mm:ss a', 'DD/MM/YYYY h:mm:ss A', 'DD/MMM/YYYY HH:mm:ss', 'DD/MMM/YYYY h:mm:ss', 'DD/MMM/YYYY hh:mm:ss a', 'DD/MMM/YYYY hh:mm:ss A', 'DD/MMM/YYYY h:mm:ss a', 'DD/MMM/YYYY h:mm:ss A'];

exports.toJsDate = function toJsDate(value) {
  if (!value) {
    return value;
  }

  if (typeof value.toDate === 'function') {
    return value.toDate();
  }

  if (value.seconds) {
    return new Date(value.seconds * 1000);
  }

  return value;
};

exports.formatDate = function formatDate(value) {
  return moment(exports.toJsDate(value)).format('DD/MMM/YYYY');
};

exports.formatDateTime = function formatDateTime(value) {
  return moment(exports.toJsDate(value)).format('DD/MMM/YYYY hh:mm:ss a');
};

exports.parseDateTime = function parseDateTime(value) {
  return moment(exports.toJsDate(value), dateTimeFormats, true);
};

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_polyfill__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),

/***/ 691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f2d3ed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(695);
function injectStyle (ssrContext) {
  __webpack_require__(692)
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f2d3ed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 692:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5243c49b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(750);
function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5243c49b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5243c49b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 698:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Invoices',
    url: '/invoices',
    icon: 'icon-layers'
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-user'
  }, {
    name: 'Claims',
    url: '/claims',
    icon: 'icon-present'
  }, {
    name: 'Pair Requests',
    url: '/pairrequests',
    icon: 'icon-link'
  }, {
    name: 'Upload/Import',
    url: '/invoiceupload',
    icon: 'icon-cloud-upload'
  }, {
    name: 'Imports',
    url: '/invoiceimports',
    icon: 'icon-folder'
  }, {
    name: 'Customer Accounts',
    url: '/customeraccounts',
    icon: 'icon-speedometer'
  }, {
    name: 'Upload Customer Accounts',
    url: '/customeraccountupload',
    icon: 'icon-cloud-upload'
  }, {
    name: 'Campaigns',
    url: '/campaigns',
    icon: 'icon-trophy'
  }, {
    name: 'Create Campaign',
    url: '/createcampaign',
    icon: 'icon-game-controller'
  }, {
    name: 'Mobile APP Stuff',
    url: '/mobileappstuff',
    icon: 'icon-screen-smartphone'
  }, {
    name: 'Banners',
    url: '/banners',
    icon: 'icon-picture'
  }, {
    name: 'Notifications',
    url: '/notifications',
    icon: 'icon-bell'
  }, {
    name: 'Single Claim Report',
    url: '/userclaimreport',
    icon: 'icon-screen-tablet'
  }, {
    name: 'Claim Reports',
    url: '/generateclaimreports',
    icon: 'icon-grid'
  }, {
    name: 'Configuration',
    url: '/configuration',
    icon: 'icon-settings'
  }]
});

/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e191c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(701);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e191c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(703);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(425);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(705);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f37715fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(707);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f37715fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe52d3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(709);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe52d3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),(_vm.loggedInUser)?_c('div',{staticClass:"header-user"},[_c('span',[_vm._v(_vm._s(_vm.loggedInUser))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.logOut()}}},[_vm._v("Log Out")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6942f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(739);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6942f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 711:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba21578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(713);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba21578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89f823fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(715);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89f823fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c619eac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(717);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c619eac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1719c08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(719);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1719c08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afdaf6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(721);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afdaf6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_416a7c73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(724);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_416a7c73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547d9c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(736);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547d9c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d60a13a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(738);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d60a13a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}),0)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(449);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(741);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTimePicker_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e62ba3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__ = __webpack_require__(746);
function injectStyle (ssrContext) {
  __webpack_require__(743)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61e62ba3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTimePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e62ba3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 743:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 451,
	"./af.js": 451,
	"./ar": 452,
	"./ar-dz": 453,
	"./ar-dz.js": 453,
	"./ar-kw": 454,
	"./ar-kw.js": 454,
	"./ar-ly": 455,
	"./ar-ly.js": 455,
	"./ar-ma": 456,
	"./ar-ma.js": 456,
	"./ar-ps": 457,
	"./ar-ps.js": 457,
	"./ar-sa": 458,
	"./ar-sa.js": 458,
	"./ar-tn": 459,
	"./ar-tn.js": 459,
	"./ar.js": 452,
	"./az": 460,
	"./az.js": 460,
	"./be": 461,
	"./be.js": 461,
	"./bg": 462,
	"./bg.js": 462,
	"./bm": 463,
	"./bm.js": 463,
	"./bn": 464,
	"./bn-bd": 465,
	"./bn-bd.js": 465,
	"./bn.js": 464,
	"./bo": 466,
	"./bo.js": 466,
	"./br": 467,
	"./br.js": 467,
	"./bs": 468,
	"./bs.js": 468,
	"./ca": 469,
	"./ca.js": 469,
	"./cs": 470,
	"./cs.js": 470,
	"./cv": 471,
	"./cv.js": 471,
	"./cy": 472,
	"./cy.js": 472,
	"./da": 473,
	"./da.js": 473,
	"./de": 474,
	"./de-at": 475,
	"./de-at.js": 475,
	"./de-ch": 476,
	"./de-ch.js": 476,
	"./de.js": 474,
	"./dv": 477,
	"./dv.js": 477,
	"./el": 478,
	"./el.js": 478,
	"./en-au": 479,
	"./en-au.js": 479,
	"./en-ca": 480,
	"./en-ca.js": 480,
	"./en-gb": 481,
	"./en-gb.js": 481,
	"./en-ie": 482,
	"./en-ie.js": 482,
	"./en-il": 483,
	"./en-il.js": 483,
	"./en-in": 484,
	"./en-in.js": 484,
	"./en-nz": 485,
	"./en-nz.js": 485,
	"./en-sg": 486,
	"./en-sg.js": 486,
	"./eo": 487,
	"./eo.js": 487,
	"./es": 488,
	"./es-do": 489,
	"./es-do.js": 489,
	"./es-mx": 490,
	"./es-mx.js": 490,
	"./es-us": 491,
	"./es-us.js": 491,
	"./es.js": 488,
	"./et": 492,
	"./et.js": 492,
	"./eu": 493,
	"./eu.js": 493,
	"./fa": 494,
	"./fa.js": 494,
	"./fi": 495,
	"./fi.js": 495,
	"./fil": 496,
	"./fil.js": 496,
	"./fo": 497,
	"./fo.js": 497,
	"./fr": 498,
	"./fr-ca": 499,
	"./fr-ca.js": 499,
	"./fr-ch": 500,
	"./fr-ch.js": 500,
	"./fr.js": 498,
	"./fy": 501,
	"./fy.js": 501,
	"./ga": 502,
	"./ga.js": 502,
	"./gd": 503,
	"./gd.js": 503,
	"./gl": 504,
	"./gl.js": 504,
	"./gom-deva": 505,
	"./gom-deva.js": 505,
	"./gom-latn": 506,
	"./gom-latn.js": 506,
	"./gu": 507,
	"./gu.js": 507,
	"./he": 508,
	"./he.js": 508,
	"./hi": 509,
	"./hi.js": 509,
	"./hr": 510,
	"./hr.js": 510,
	"./hu": 511,
	"./hu.js": 511,
	"./hy-am": 512,
	"./hy-am.js": 512,
	"./id": 513,
	"./id.js": 513,
	"./is": 514,
	"./is.js": 514,
	"./it": 515,
	"./it-ch": 516,
	"./it-ch.js": 516,
	"./it.js": 515,
	"./ja": 517,
	"./ja.js": 517,
	"./jv": 518,
	"./jv.js": 518,
	"./ka": 519,
	"./ka.js": 519,
	"./kk": 520,
	"./kk.js": 520,
	"./km": 521,
	"./km.js": 521,
	"./kn": 522,
	"./kn.js": 522,
	"./ko": 523,
	"./ko.js": 523,
	"./ku": 524,
	"./ku-kmr": 525,
	"./ku-kmr.js": 525,
	"./ku.js": 524,
	"./ky": 526,
	"./ky.js": 526,
	"./lb": 527,
	"./lb.js": 527,
	"./lo": 528,
	"./lo.js": 528,
	"./lt": 529,
	"./lt.js": 529,
	"./lv": 530,
	"./lv.js": 530,
	"./me": 531,
	"./me.js": 531,
	"./mi": 532,
	"./mi.js": 532,
	"./mk": 533,
	"./mk.js": 533,
	"./ml": 534,
	"./ml.js": 534,
	"./mn": 535,
	"./mn.js": 535,
	"./mr": 536,
	"./mr.js": 536,
	"./ms": 537,
	"./ms-my": 538,
	"./ms-my.js": 538,
	"./ms.js": 537,
	"./mt": 539,
	"./mt.js": 539,
	"./my": 540,
	"./my.js": 540,
	"./nb": 541,
	"./nb.js": 541,
	"./ne": 542,
	"./ne.js": 542,
	"./nl": 543,
	"./nl-be": 544,
	"./nl-be.js": 544,
	"./nl.js": 543,
	"./nn": 545,
	"./nn.js": 545,
	"./oc-lnc": 546,
	"./oc-lnc.js": 546,
	"./pa-in": 547,
	"./pa-in.js": 547,
	"./pl": 548,
	"./pl.js": 548,
	"./pt": 549,
	"./pt-br": 550,
	"./pt-br.js": 550,
	"./pt.js": 549,
	"./ro": 551,
	"./ro.js": 551,
	"./ru": 552,
	"./ru.js": 552,
	"./sd": 553,
	"./sd.js": 553,
	"./se": 554,
	"./se.js": 554,
	"./si": 555,
	"./si.js": 555,
	"./sk": 556,
	"./sk.js": 556,
	"./sl": 557,
	"./sl.js": 557,
	"./sq": 558,
	"./sq.js": 558,
	"./sr": 559,
	"./sr-cyrl": 560,
	"./sr-cyrl.js": 560,
	"./sr.js": 559,
	"./ss": 561,
	"./ss.js": 561,
	"./sv": 562,
	"./sv.js": 562,
	"./sw": 563,
	"./sw.js": 563,
	"./ta": 564,
	"./ta.js": 564,
	"./te": 565,
	"./te.js": 565,
	"./tet": 566,
	"./tet.js": 566,
	"./tg": 567,
	"./tg.js": 567,
	"./th": 568,
	"./th.js": 568,
	"./tk": 569,
	"./tk.js": 569,
	"./tl-ph": 570,
	"./tl-ph.js": 570,
	"./tlh": 571,
	"./tlh.js": 571,
	"./tr": 572,
	"./tr.js": 572,
	"./tzl": 573,
	"./tzl.js": 573,
	"./tzm": 574,
	"./tzm-latn": 575,
	"./tzm-latn.js": 575,
	"./tzm.js": 574,
	"./ug-cn": 576,
	"./ug-cn.js": 576,
	"./uk": 577,
	"./uk.js": 577,
	"./ur": 578,
	"./ur.js": 578,
	"./uz": 579,
	"./uz-latn": 580,
	"./uz-latn.js": 580,
	"./uz.js": 579,
	"./vi": 581,
	"./vi.js": 581,
	"./x-pseudo": 582,
	"./x-pseudo.js": 582,
	"./yo": 583,
	"./yo.js": 583,
	"./zh-cn": 584,
	"./zh-cn.js": 584,
	"./zh-hk": 585,
	"./zh-hk.js": 585,
	"./zh-mo": 586,
	"./zh-mo.js": 586,
	"./zh-tw": 587,
	"./zh-tw.js": 587
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 745;

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datetime-picker",style:({width:_vm.width}),on:{"click":function($event){return _vm.calendarClicked($event)}}},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],attrs:{"type":"text","id":"tj-datetime-input","initialValue":_vm.initialValue,"autocomplete":"off"},domProps:{"value":(_vm.date)},on:{"click":_vm.toggleCal,"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"calender-div",class:{noDisplay: _vm.hideCal}},[_c('div',{class:{noDisplay: _vm.hideDate}},[_c('div',{staticClass:"year-month-wrapper"},[_c('div',{staticClass:"month-setter"},[_c('button',{staticClass:"nav-l",on:{"click":_vm.leftYear}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"year"},[_vm._v(_vm._s(_vm.year))]),_vm._v(" "),_c('button',{staticClass:"nav-r",on:{"click":_vm.rightYear}},[_vm._v(">")])]),_vm._v(" "),_c('div',{staticClass:"month-setter"},[_c('button',{staticClass:"nav-l",on:{"click":_vm.leftMonth}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"month"},[_vm._v(_vm._s(_vm.month))]),_vm._v(" "),_c('button',{staticClass:"nav-r",on:{"click":_vm.rightMonth}},[_vm._v(">")])])]),_vm._v(" "),_c('div',{staticClass:"headers"},_vm._l((_vm.days),function(port,index){return _c('span',{staticClass:"days"},[_vm._v(_vm._s(port))])}),0),_vm._v(" "),_c('div',_vm._l((_vm.ports),function(port,index){return _c('span',{staticClass:"port",class:{activePort: index === _vm.activePort},on:{"click":function($event){return _vm.setDay(index, port)}}},[_vm._v(_vm._s(port))])}),0)]),_vm._v(" "),_c('div',{staticClass:"time-picker",class:{noDisplay: _vm.hideTime}},[_c('div',{staticClass:"hour-selector"},[_c('div',{attrs:{"id":"j-hour"},on:{"click":_vm.showHourSelector}},[_vm._v(_vm._s(_vm.hour))]),_vm._v(" "),_c('div',{ref:"hourScrollerWrapper",staticClass:"scroll-hider",class:{showSelector: _vm.hourSelectorVisible}},[_c('ul',{ref:"hourScroller"},_vm._l((_vm.hours),function(h,index){return _c('li',{class:{active: index == _vm.hourIndex},on:{"click":function($event){return _vm.setHour(index, true)}}},[_vm._v(_vm._s(h))])}),0)])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"minute-selector"},[_c('div',{attrs:{"id":"j-minute"},on:{"click":_vm.showMinuteSelector}},[_vm._v(_vm._s(_vm.minute))]),_vm._v(" "),_c('div',{ref:"minuteScrollerWrapper",staticClass:"scroll-hider",class:{showSelector: _vm.minuteSelectorVisible}},[_c('ul',{ref:"minuteScroller"},_vm._l((_vm.minutes),function(m,index){return _c('li',{class:{active: index == _vm.minuteIndex},on:{"click":function($event){return _vm.setMinute(index, true)}}},[_vm._v(_vm._s(m))])}),0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"minute-selector"},[_c('div',{on:{"click":_vm.changePeriod}},[_vm._v(_vm._s(_vm.period))])])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"cancelButton",on:{"click":_vm.toggleCal}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"okButton",on:{"click":_vm.okButtonClicked}},[_vm._v("OK")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-separator"},[_c('span',[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-separator"},[_c('span',[_vm._v(":")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyModal_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e5ac9a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyModal_vue__ = __webpack_require__(749);
function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29e5ac9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e5ac9a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 748:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_vm._v("\n            "+_vm._s(_vm.headerTitle)+"\n          ")]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [_vm._v("\n            "+_vm._s(_vm.bodyMessage)+"\n          ")]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"modal-default-button",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n              CLOSE\n            ")])]})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.showAppChrome)?_c('AppHeader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-body",class:{ 'app-body-public': !_vm.showAppChrome }},[(_vm.showAppChrome)?_c('Sidebar',{attrs:{"navItems":_vm.nav}}):_vm._e(),_vm._v(" "),_c('main',{staticClass:"main",class:{ 'main-public': !_vm.showAppChrome }},[_c('div',{staticClass:"container-fluid backoffice-content"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc0008d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__ = __webpack_require__(753);
function injectStyle (ssrContext) {
  __webpack_require__(752)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc0008d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 752:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-btn',{on:{"click":function($event){_vm.searchModalShow = !_vm.searchModalShow}}},[_vm._v("Filter")]),_vm._v(" "),_c('span',[_vm._v(" By ")]),_vm._v(" "),(_vm.searchObject.taxInvoice.length > 0)?_c('span',[_vm._v("[tax invoice]: "+_vm._s(_vm.searchObject.taxInvoice)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.customerAccount.length > 0)?_c('span',[_vm._v("and [customer account]: "+_vm._s(_vm.searchObject.customerAccount)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.status.length > 0)?_c('span',[_vm._v("and [status]: "+_vm._s(_vm.searchObject.status)+" ")]):_vm._e(),_vm._v(" "),_c('b-btn',{on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Clear Filters")])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Filter"},model:{value:(_vm.searchModalShow),callback:function ($$v) {_vm.searchModalShow=$$v},expression:"searchModalShow"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"taxInvoiceInput"}},[_vm._v("Tax Invoice:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.taxInvoice),expression:"searchObject.taxInvoice"}],attrs:{"type":"text","id":"taxInvoiceInput","placeholder":""},domProps:{"value":(_vm.searchObject.taxInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "taxInvoice", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"filterCusAcc"}},[_vm._v("Customer Account:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.customerAccount),expression:"searchObject.customerAccount"}],attrs:{"type":"text","id":"filterCusAcc","placeholder":""},domProps:{"value":(_vm.searchObject.customerAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "customerAccount", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"filterStatus"}},[_vm._v("Status:")])]),_vm._v(" "),_c('b-col',[_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"filterStatus","text":_vm.searchObject.status}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('')}}}),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('NEW')}}},[_vm._v("NEW")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('CLAIMING')}}},[_vm._v("CLAIMING")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('CLAIMED')}}},[_vm._v("CLAIMED")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"filterFromOrderDate"}},[_vm._v("From Order Date (DD/MM/YYYY):")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.orderDate),expression:"searchObject.orderDate"}],attrs:{"type":"date","id":"filterFromOrderDate","placeholder":"DD/MM/YYYY"},domProps:{"value":(_vm.searchObject.orderDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "orderDate", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.search()}}},[_vm._v("\n        Filter\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.searchModalShow = !_vm.searchModalShow}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center","disabled":_vm.disabledPagination},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.generateInvoiceReport()}}},[_vm._v("Generate Invoice Report")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders},scopedSlots:_vm._u([{key:"cell(show_details)",fn:function(row){return [_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.showRowDetailClicked(row.item.taxInvoice, row.item.invoiceId)}}},[_vm._v("Details")])]}},{key:"cell(show_campaign_claims)",fn:function(row){return [_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.showCampaignClaims(row.item.taxInvoice, row.item.invoiceId)}}},[_vm._v("Campaign Claims")])]}},{key:"row-details",fn:function(row){return [_c('b-card-group',{staticStyle:{"overflow":"scroll"}},_vm._l((row.item.subTypes),function(subType){return _c('b-card',{key:subType.__id,staticStyle:{"min-width":"300px"},attrs:{"data":subType}},_vm._l((subType),function(eachProp,propName){return _c('b-row',{key:propName,attrs:{"data":eachProp}},[_c('b-col',[_c('b',[_vm._v(_vm._s(propName)+":")])]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(eachProp))])],1)}),1)}),1)]}}])}),_vm._v(" "),_c('b-modal',{attrs:{"id":"campaignClaimsModal","size":"xl","title":'Campaign Claims: ' + _vm.selectedClaimTaxInvoice},model:{value:(_vm.campaignClaimsModalShow),callback:function ($$v) {_vm.campaignClaimsModalShow=$$v},expression:"campaignClaimsModalShow"}},[_c('section',{staticClass:"campaign-claim-section"},[_c('h5',[_vm._v("Selected by customer")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("This invoice was chosen first by the customer.")]),_vm._v(" "),_c('div',{staticClass:"campaign-claim-table-wrap"},[_c('b-table',{staticClass:"invoice-claim-detail-table",attrs:{"small":"","bordered":"","show-empty":"","items":_vm.requestedClaimDetails,"fields":_vm.claimDetailHeaders},scopedSlots:_vm._u([{key:"cell(claimSubtypesText)",fn:function(data){return [_c('div',{staticClass:"claim-quantity-cell"},[_vm._v(_vm._s(data.value || '-'))])]}}])})],1)]),_vm._v(" "),_c('section',{staticClass:"campaign-claim-section"},[_c('h5',[_vm._v("Used as pairing invoice")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("This invoice supplied the second lens for another selected invoice.")]),_vm._v(" "),_c('div',{staticClass:"campaign-claim-table-wrap"},[_c('b-table',{staticClass:"invoice-claim-detail-table",attrs:{"small":"","bordered":"","show-empty":"","items":_vm.pairingClaimDetails,"fields":_vm.claimDetailHeaders},scopedSlots:_vm._u([{key:"cell(claimSubtypesText)",fn:function(data){return [_c('div',{staticClass:"claim-quantity-cell"},[_vm._v(_vm._s(data.value || '-'))])]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.campaignClaimsModalShow = false}}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    No Result\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3c33dae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(755);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3c33dae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-btn',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){_vm.filterModalShow = !_vm.filterModalShow}}},[_vm._v("Filter")]),_vm._v(" "),_c('span',[_vm._v(" By ")]),_vm._v(" "),(_vm.searchObject.email.length > 0)?_c('span',[_vm._v("[email]: "+_vm._s(_vm.searchObject.email)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.accountNumber.length > 0)?_c('span',[_vm._v("and [account number]: "+_vm._s(_vm.searchObject.accountNumber)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.status.length > 0)?_c('span',[_vm._v("and [status]: "+_vm._s(_vm.searchObject.status)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.phoneNumber.length > 0)?_c('span',[_vm._v("and [phone number]: "+_vm._s(_vm.searchObject.phoneNumber)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.createdDate.length > 0)?_c('span',[_vm._v("and [created date]: "+_vm._s(_vm.searchObject.createdDate)+" ")]):_vm._e(),_vm._v(" "),(_vm.searchObject.demo !== false)?_c('span',[_vm._v("and [isDemo]: "+_vm._s(_vm.searchObject.demo)+" ")]):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Clear Filters")])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Filter"},model:{value:(_vm.filterModalShow),callback:function ($$v) {_vm.filterModalShow=$$v},expression:"filterModalShow"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"emailInput"}},[_vm._v("Email:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.email),expression:"searchObject.email"}],attrs:{"type":"text","id":"emailInput","placeholder":""},domProps:{"value":(_vm.searchObject.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "email", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"hoyaAccNumberInput"}},[_vm._v("HOYA Account Number:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.accountNumber),expression:"searchObject.accountNumber"}],attrs:{"type":"text","id":"hoyaAccNumberInput","placeholder":""},domProps:{"value":(_vm.searchObject.accountNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "accountNumber", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"statusInput"}},[_vm._v("Status:")])]),_vm._v(" "),_c('b-col',[_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.searchObject.status}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('')}}}),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('WAITING_FOR_APPROVAL')}}},[_vm._v("WAITING_FOR_APPROVAL\n          ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('ACTIVE')}}},[_vm._v("ACTIVE")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('LOCK')}}},[_vm._v("LOCK")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"phoneNumberInput"}},[_vm._v("Phone Number:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.phoneNumber),expression:"searchObject.phoneNumber"}],attrs:{"type":"text","id":"phoneNumberInput","placeholder":""},domProps:{"value":(_vm.searchObject.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "phoneNumber", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"isDemoInput"}},[_vm._v("Demo:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.demo),expression:"searchObject.demo"}],attrs:{"type":"checkbox","id":"isDemoInput","placeholder":""},domProps:{"checked":Array.isArray(_vm.searchObject.demo)?_vm._i(_vm.searchObject.demo,null)>-1:(_vm.searchObject.demo)},on:{"change":function($event){var $$a=_vm.searchObject.demo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.searchObject, "demo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.searchObject, "demo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.searchObject, "demo", $$c)}}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"createdDateInput"}},[_vm._v("Created Date (DD/MM/YYYY):")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchObject.createdDate),expression:"searchObject.createdDate"}],attrs:{"type":"text","id":"createdDateInput","placeholder":""},domProps:{"value":(_vm.searchObject.createdDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchObject, "createdDate", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.filter()}}},[_vm._v("\n        Filter\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.filterModalShow = !_vm.filterModalShow}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center","disabled":_vm.disabledPagination},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.showModifyUserModal()}}},[_vm._v("Edit\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.generateClaimsReport()}}},[_vm._v("\n    Generate Claims Report\n  ")]),_vm._v(" "),_c('b-table',{attrs:{"hover":"","small":"","bordered":"","items":_vm.tableRows,"fields":_vm.tableHeaders},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"approved",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.approved))]),_vm._v(" "),(row.item.approved == false)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.showApproveModal()}}},[_vm._v("\n        Approve\n      ")]):_vm._e()]}},{key:"status",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.status))]),_vm._v(" "),(row.item.status != 'WAITING_FOR_APPROVAL')?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.showChangeStatusModal()}}},[_vm._v("Change\n      ")]):_vm._e()]}}])}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    No Result\n  ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Confirm Approve"},model:{value:(_vm.showConfirmApproveModal),callback:function ($$v) {_vm.showConfirmApproveModal=$$v},expression:"showConfirmApproveModal"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('span',[_c('b',[_vm._v("Confirm approve the user : "+_vm._s(_vm.selectedRowItem == null ? '' : _vm.selectedRowItem.email))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("*User cannot draw if status not approved yet")])])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.approveUser()}}},[_vm._v("\n        Confirm Approve\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeApproveModal()}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Change User Status"},model:{value:(_vm.showChangeUserStatusModal),callback:function ($$v) {_vm.showChangeUserStatusModal=$$v},expression:"showChangeUserStatusModal"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('span',[_c('b',[_vm._v("Change status for user: "+_vm._s(_vm.selectedRowItem == null ? '' : _vm.selectedRowItem.email))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("*User cannot draw if status is NOT ACTIVE")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"newCampaignStatus"}},[_vm._v("New Status:")])]),_vm._v(" "),_c('b-col',[_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.newStatus}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newStatusSelected('ACTIVE')}}},[_vm._v("ACTIVE")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newStatusSelected('LOCK')}}},[_vm._v("LOCK")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.changeStatus()}}},[_vm._v("\n        Change\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeChangeStatusModal()}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal3","title":"Edit User"},model:{value:(_vm.showEditUserModal),callback:function ($$v) {_vm.showEditUserModal=$$v},expression:"showEditUserModal"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedName"}},[_vm._v("Name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedUserName),expression:"editedUserName"}],staticClass:"form-control",attrs:{"type":"text","id":"editedName","placeholder":"","required":""},domProps:{"value":(_vm.editedUserName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedUserName=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedEmail"}},[_vm._v("Email:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedEmail),expression:"editedEmail"}],staticClass:"form-control",attrs:{"type":"text","id":"editedEmail","placeholder":"","disabled":""},domProps:{"value":(_vm.editedEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedEmail=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedAccNum"}},[_vm._v("Account Number:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedAccountNumber),expression:"editedAccountNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"editedAccNum","placeholder":"","required":""},domProps:{"value":(_vm.editedAccountNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedAccountNumber=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedPhoneNum"}},[_vm._v("Phone Number:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedPhoneNumber),expression:"editedPhoneNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"editedPhoneNum","placeholder":""},domProps:{"value":(_vm.editedPhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedPhoneNumber=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedCompanyName"}},[_vm._v("Company Name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCompanyName),expression:"editedCompanyName"}],staticClass:"form-control",attrs:{"type":"text","id":"editedCompanyName","placeholder":""},domProps:{"value":(_vm.editedCompanyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedCompanyName=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedCompanyRegisNum"}},[_vm._v("Company Registration Number:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCompanyRegistrationNumber),expression:"editedCompanyRegistrationNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"editedCompanyRegisNum","placeholder":""},domProps:{"value":(_vm.editedCompanyRegistrationNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedCompanyRegistrationNumber=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedBankName"}},[_vm._v("Bank Name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedBankName),expression:"editedBankName"}],staticClass:"form-control",attrs:{"type":"text","id":"editedBankName","placeholder":""},domProps:{"value":(_vm.editedBankName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedBankName=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedBankAccName"}},[_vm._v("Bank Account Name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedBankAccountName),expression:"editedBankAccountName"}],staticClass:"form-control",attrs:{"type":"text","id":"editedBankAccName","placeholder":""},domProps:{"value":(_vm.editedBankAccountName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedBankAccountName=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"editedBankAccNum"}},[_vm._v("Bank Account Number:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedBankAccountNumber),expression:"editedBankAccountNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"editedBankAccNum","placeholder":""},domProps:{"value":(_vm.editedBankAccountNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedBankAccountNumber=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{staticClass:"col-form-label",attrs:{"for":"isDemoAccount"}},[_vm._v("Is Demo Account:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedIsDemoAccount),expression:"editedIsDemoAccount"}],staticClass:"form-control",attrs:{"type":"checkbox","id":"isDemoAccount","placeholder":"","name":"Is Demo Account"},domProps:{"checked":Array.isArray(_vm.editedIsDemoAccount)?_vm._i(_vm.editedIsDemoAccount,null)>-1:(_vm.editedIsDemoAccount)},on:{"change":function($event){var $$a=_vm.editedIsDemoAccount,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editedIsDemoAccount=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editedIsDemoAccount=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editedIsDemoAccount=$$c}}}})])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.updateUser()}}},[_vm._v("\n        Change\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeEditUserModal()}}},[_vm._v("\n        Close\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceImports_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5d80a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceImports_vue__ = __webpack_require__(757);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceImports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5d80a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceImports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders},on:{"row-clicked":_vm.tableRowClicked}}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  No Result\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f3489cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__ = __webpack_require__(759);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f3489cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.showChangeStatus()}}},[_vm._v("Change\n    Status\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.showEditCampaign()}}},[_vm._v("Edit\n  ")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders,"id":"campaignTable"},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"cell(status)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.status))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showCampaignLivePool(row.item.campaignId)}}},[_vm._v("Live")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showDetailRow(row.item.campaignId)}}},[_vm._v("Detail")])]}},{key:"row-details",fn:function(row){return [_c('b-card-group',[_c('b-card',_vm._l((row.item.notesPool),function(note,index){return _c('b-row',{key:note.rewardId || note.noteType + '-' + index,attrs:{"data":note}},[_c('b-col',[_c('b',[_vm._v(_vm._s(_vm.getRewardLabel(note))+" has "+_vm._s(_vm.getRewardQuantity(note))+" piece(s)")]),_vm._v(" "),(_vm.getRewardValue(note) > 0)?_c('span',[_vm._v(" - RM "+_vm._s(_vm.getRewardValue(note))+" value each")]):_vm._e()])],1)}),1),_vm._v(" "),_c('b-card',[(row.item.campaignImageUrl)?_c('b-row',[_c('b-col',[_c('b',[_vm._v("Campaign Banner")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"height":"110px","max-width":"260px","object-fit":"cover","border-radius":"4px"},attrs:{"src":row.item.campaignImageUrl,"alt":"Campaign banner"}})])],1):_vm._e()],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',[_c('b',[_vm._v("Order Types: "+_vm._s(row.item.orderTypes))])])],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',[_c('b',[_vm._v("Lens Designs: "+_vm._s(row.item.lensDesigns))])])],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',[_c('b',[_vm._v("Lens Indexes: "+_vm._s(row.item.lensIndexes))])])],1)],1)],1)]}}])}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    No Result\n  ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Change Campaign Status"},model:{value:(_vm.showChangeStatusModal),callback:function ($$v) {_vm.showChangeStatusModal=$$v},expression:"showChangeStatusModal"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('span',[_c('b',[_vm._v("Campaign: "+_vm._s(_vm.selectedRowItem == null ? '' : _vm.selectedRowItem.name))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"newCampaignStatus"}},[_vm._v("New Status:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newStatus),expression:"newStatus"}],attrs:{"type":"text","id":"newCampaignStatus","placeholder":""},domProps:{"value":(_vm.newStatus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newStatus=$event.target.value}}}),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.newStatus}},[(_vm.selectedRowItemIsDemoCampaign === false)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newStatusSelected('ACTIVE')}}},[_vm._v("ACTIVE\n          ")]):_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newStatusSelected('DEMO_ACTIVE')}}},[_vm._v("DEMO_ACTIVE")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newStatusSelected('HOLD')}}},[_vm._v("HOLD")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newStatusSelected('CLOSED')}}},[_vm._v("CLOSED")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.changeStatus()}}},[_vm._v("\n        Change\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeShowChangeStatusModal()}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),(_vm.showUpdatingStatusModal)?_c('MyModal',{attrs:{"headerTitle":"Updating...","bodyMessage":"Please wait"},on:{"close":function($event){return _vm.closeUpdatingStatusModal()}}}):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal2","title":"Edit Campaign","size":"lg"},model:{value:(_vm.showEditCampaignModal),callback:function ($$v) {_vm.showEditCampaignModal=$$v},expression:"showEditCampaignModal"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignname"}},[_vm._v("New name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCampaignName),expression:"editedCampaignName"}],staticStyle:{"width":"100%"},attrs:{"type":"text","id":"editedCampaignname","placeholder":""},domProps:{"value":(_vm.editedCampaignName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedCampaignName=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"editedCampaigndescription"}},[_vm._v("New Description:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCampaignDescription),expression:"editedCampaignDescription"}],staticStyle:{"width":"100%"},attrs:{"type":"text","id":"editedCampaigndescription","placeholder":""},domProps:{"value":(_vm.editedCampaignDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedCampaignDescription=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignBanner"}},[_vm._v("Campaign Banner:")])]),_vm._v(" "),_c('b-col',[(_vm.editedCampaignImageUrl)?_c('div',{staticClass:"mb-2"},[_c('img',{staticStyle:{"height":"110px","max-width":"260px","object-fit":"cover","border-radius":"4px"},attrs:{"src":_vm.editedCampaignImageUrl,"alt":"Campaign banner"}})]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"editedCampaignBanner","accept":"image/*"},on:{"change":function($event){return _vm.editedCampaignBannerChanged($event.target.files)}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Choose a new file only when replacing the current banner.")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignStartDate"}},[_vm._v("New Start Date:")])]),_vm._v(" "),_c('b-col',[_c('DateTimePicker',{ref:"editCampaignStartDateRef",attrs:{"format":"DD/MM/YYYY h:i:s","id":"editedCampaignStartDate"},on:{"update:date-value":_vm.updateCampaignStartDate}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignEndDate"}},[_vm._v("New End Date:")])]),_vm._v(" "),_c('b-col',[_c('DateTimePicker',{ref:"editCampaignEndDateRef",attrs:{"format":"DD/MM/YYYY h:i:s","id":"editedCampaignEndDate"},on:{"update:date-value":_vm.updateCampaignEndDate}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignInvoiceStartDate"}},[_vm._v("New Invoice Start Date:")])]),_vm._v(" "),_c('b-col',[_c('DateTimePicker',{ref:"editCampaignStartInvoiceDateRef",attrs:{"format":"DD/MM/YYYY h:i:s","id":"editedCampaignInvoiceStartDate"},on:{"update:date-value":_vm.updateInvoiceStartDate}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignInvoiceEndDate"}},[_vm._v("New Invoice End Date:")])]),_vm._v(" "),_c('b-col',[_c('DateTimePicker',{ref:"editCampaignEndInvoiceDateRef",attrs:{"format":"DD/MM/YYYY h:i:s","id":"editedCampaignInvoiceEndDate"},on:{"update:date-value":_vm.updateInvoiceEndDate}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"editedCampaignMinimumPrice"}},[_vm._v("New Minimum Price:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCampaignMinimumInvoicePerPiece),expression:"editedCampaignMinimumInvoicePerPiece"}],attrs:{"type":"number","id":"editedCampaignMinimumPrice","placeholder":""},domProps:{"value":(_vm.editedCampaignMinimumInvoicePerPiece)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editedCampaignMinimumInvoicePerPiece=$event.target.value}}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"isDemoAccount"}},[_vm._v("Is Demo Campaign:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedIsDemoAccount),expression:"editedIsDemoAccount"}],attrs:{"type":"checkbox","id":"isDemoAccount","placeholder":"","name":"Is Demo Account"},domProps:{"checked":Array.isArray(_vm.editedIsDemoAccount)?_vm._i(_vm.editedIsDemoAccount,null)>-1:(_vm.editedIsDemoAccount)},on:{"change":function($event){var $$a=_vm.editedIsDemoAccount,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editedIsDemoAccount=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editedIsDemoAccount=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editedIsDemoAccount=$$c}}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n        Order Types"),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-group",staticStyle:{"max-height":"200px","overflow-y":"auto"},attrs:{"id":"editedCampaignEligibleOrderTypes"}},_vm._l((_vm.editedCampaignAvailableEligibleOrderTypes),function(item){return _c('li',{staticClass:"list-group-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCampaignSelectedEligibleOrderTypes),expression:"editedCampaignSelectedEligibleOrderTypes"}],attrs:{"type":"checkbox","name":item},domProps:{"value":item,"checked":Array.isArray(_vm.editedCampaignSelectedEligibleOrderTypes)?_vm._i(_vm.editedCampaignSelectedEligibleOrderTypes,item)>-1:(_vm.editedCampaignSelectedEligibleOrderTypes)},on:{"change":function($event){var $$a=_vm.editedCampaignSelectedEligibleOrderTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editedCampaignSelectedEligibleOrderTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editedCampaignSelectedEligibleOrderTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editedCampaignSelectedEligibleOrderTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)]),_vm._v(" "),_c('b-col',[_vm._v("\n        Lens Design"),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-group",staticStyle:{"max-height":"200px","overflow-y":"auto"},attrs:{"id":"editedCampaignEligibleLensDesigns"}},_vm._l((_vm.editedCampaignAvailableEligibleLensDesign),function(item){return _c('li',{staticClass:"list-group-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCampaignSelectedEligibleLensDesign),expression:"editedCampaignSelectedEligibleLensDesign"}],attrs:{"type":"checkbox","name":item},domProps:{"value":item,"checked":Array.isArray(_vm.editedCampaignSelectedEligibleLensDesign)?_vm._i(_vm.editedCampaignSelectedEligibleLensDesign,item)>-1:(_vm.editedCampaignSelectedEligibleLensDesign)},on:{"change":function($event){var $$a=_vm.editedCampaignSelectedEligibleLensDesign,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editedCampaignSelectedEligibleLensDesign=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editedCampaignSelectedEligibleLensDesign=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editedCampaignSelectedEligibleLensDesign=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)]),_vm._v(" "),_c('b-col',[_vm._v("\n        Lens Index"),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-group",staticStyle:{"max-height":"200px","overflow-y":"auto"},attrs:{"id":"editedCampaignEligibleLensIndexes"}},_vm._l((_vm.editedCampaignAvailableEligibleLensIndex),function(item){return _c('li',{staticClass:"list-group-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCampaignSelectedEligibleLensIndex),expression:"editedCampaignSelectedEligibleLensIndex"}],attrs:{"type":"checkbox","name":item},domProps:{"value":item,"checked":Array.isArray(_vm.editedCampaignSelectedEligibleLensIndex)?_vm._i(_vm.editedCampaignSelectedEligibleLensIndex,item)>-1:(_vm.editedCampaignSelectedEligibleLensIndex)},on:{"change":function($event){var $$a=_vm.editedCampaignSelectedEligibleLensIndex,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editedCampaignSelectedEligibleLensIndex=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editedCampaignSelectedEligibleLensIndex=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editedCampaignSelectedEligibleLensIndex=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-card',[_c('b-row',{staticClass:"mb-2 align-items-center"},[_c('b-col',[_c('b',[_vm._v("Rewards")]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Quantity cannot be reduced below the claimed amount. Claimed rewards cannot be deleted.")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addEditedCampaignReward()}}},[_vm._v("Add Reward")])],1)],1),_vm._v(" "),_vm._l((_vm.editedCampaignRewards),function(reward,index){return _c('b-row',{key:reward.rewardId || index,staticClass:"mb-2 align-items-end"},[_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Reward Name / Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(reward.rewardLabel),expression:"reward.rewardLabel"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RM 10, Sensity voucher"},domProps:{"value":(reward.rewardLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(reward, "rewardLabel", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":reward.rewardType}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Cash Value")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":reward.rewardValue}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(reward.totalQuantity),expression:"reward.totalQuantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(reward.totalQuantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(reward, "totalQuantity", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('label',[_vm._v("Claimed")]),_vm._v(" "),_c('div',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.getRewardClaimedQuantity(reward)))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-btn',{attrs:{"size":"sm","variant":"danger","disabled":_vm.getRewardClaimedQuantity(reward) > 0},on:{"click":function($event){return _vm.removeEditedCampaignReward(index)}}},[_vm._v("Remove")])],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.editCampaign()}}},[_vm._v("\n        Change\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeEditCampaignModal()}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),(_vm.showUpdateSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Updated successfully"},on:{"close":function($event){return _vm.closeUpdateSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUpdateFailModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":_vm.updateFailMessage},on:{"close":function($event){return _vm.closeUpdateFailModal()}}}):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal3","title":_vm.campaignLiveModalTitle,"size":"lg"},model:{value:(_vm.showCampaignLiveModal),callback:function ($$v) {_vm.showCampaignLiveModal=$$v},expression:"showCampaignLiveModal"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('span',[_c('b',[_vm._v("Campaign: "+_vm._s(_vm.selectedRowItem == null ? '' : _vm.selectedRowItem.name))])])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('span',[_vm._v("Monetary Summary: RM "+_vm._s(_vm.campaignMoneyPool.totalPrizeMoney))])]),_vm._v(" "),_c('b-col',[_c('span',[_vm._v("Monetary Claimed: RM "+_vm._s(_vm.campaignMoneyPool.claimedPrizeMoney))])]),_vm._v(" "),_c('b-col',[_c('span',[_vm._v("Monetary Remaining: RM "+_vm._s(_vm.campaignMoneyPool.totalPrizeMoney - _vm.campaignMoneyPool.claimedPrizeMoney))])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.campaignMoneyPool.notesPool),function(note,index){return _c('b-row',{key:note.rewardId || note.noteType + '-' + index},[_c('b-col',[_c('span',[_vm._v("Total: "+_vm._s(_vm.getRewardQuantity(note))+" piece(s) of "+_vm._s(_vm.getRewardLabel(note)))])]),_vm._v(" "),_c('b-col',[_c('span',[_vm._v("Claimed: "+_vm._s(_vm.getRewardClaimedQuantity(note))+" piece(s)")])]),_vm._v(" "),_c('b-col',[_c('span',[_vm._v("Remaining: "+_vm._s(_vm.getRewardQuantity(note) - _vm.getRewardClaimedQuantity(note))+" piece(s)")])]),_vm._v(" "),_c('br')],1)}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeCampaignLiveModal()}}},[_vm._v("\n        Close\n      ")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCampaign_vue__ = __webpack_require__(593);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_242a29f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCampaign_vue__ = __webpack_require__(761);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCampaign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_242a29f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCampaign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"campaignNameInput"}},[_vm._v("*Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","id":"campaignNameInput","placeholder":"Enter Name","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"isDemo"}},[_vm._v("Is Demo:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isDemo),expression:"isDemo"}],staticClass:"form-control",attrs:{"type":"checkbox","id":"isDemo","placeholder":"Is Demo"},domProps:{"checked":Array.isArray(_vm.isDemo)?_vm._i(_vm.isDemo,null)>-1:(_vm.isDemo)},on:{"change":function($event){var $$a=_vm.isDemo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isDemo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isDemo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isDemo=$$c}}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"campaignDescInput"}},[_vm._v("*Description:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"type":"text","id":"campaignDescInput","placeholder":"Enter Description","required":""},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"campaignBannerInput"}},[_vm._v("Campaign Banner:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"file","id":"campaignBannerInput","accept":"image/*"},on:{"change":function($event){return _vm.campaignBannerChanged($event.target.files)}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Optional. This image will be shown on the mobile campaign card.")])])]),_vm._v(" "),_c('b-card',[_c('p',[_c('b',[_vm._v("Reward Pool")])]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Add each reward that can be won. Cash value is optional and used only for reporting totals.")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.addCustomNote()}}},[_vm._v("Add Reward")])])]),_vm._v(" "),_vm._l((_vm.customRMAmount),function(item,index){return _c('div',{key:index,staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"col-form-label"},[_vm._v("*Reward Name / Amount:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.rewardLabel),expression:"item.rewardLabel"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RM 10, Free lenses, Sensity voucher"},domProps:{"value":(item.rewardLabel)},on:{"keyup":_vm.updatedCustomNote,"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "rewardLabel", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Reward Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.rewardType),expression:"item.rewardType"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "rewardType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatedCustomNote]}},[_c('option',{attrs:{"value":"MONEY"}},[_vm._v("Money")]),_vm._v(" "),_c('option',{attrs:{"value":"VOUCHER"}},[_vm._v("Voucher")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Cash Value (MYR):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.rewardValue),expression:"item.rewardValue"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"0","min":"0"},domProps:{"value":(item.rewardValue)},on:{"keyup":_vm.updatedCustomNote,"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "rewardValue", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2"},[_c('label',{staticClass:"col-form-label"},[_vm._v("*Quantity:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.totalQuantity),expression:"item.totalQuantity"}],staticClass:"form-control",attrs:{"type":"number","id":"item.noteAmount","placeholder":"How many?","min":"0"},domProps:{"value":(item.totalQuantity)},on:{"keyup":_vm.updatedCustomNote,"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "totalQuantity", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-1"},[_c('label',{staticClass:"col-form-label"},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger form-control",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeCustomNote(index)}}},[_vm._v("Remove")])])])}),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_c('b',[_vm._v("Monetary Summary: RM "+_vm._s(_vm.sumOfAllNotes))])])])])],2),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"campaignStartDateInput"}},[_vm._v("*Campaign Start Date:")]),_vm._v(" "),_c('DateTimePicker',{attrs:{"format":"DD/MM/YYYY h:i:s","id":"campaignStartDateInput"},on:{"update:date-value":_vm.updateCampaignStartDate}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"campaignEndDateInput"}},[_vm._v("*Campaign End Date:")]),_vm._v(" "),_c('DateTimePicker',{attrs:{"format":"DD/MM/YYYY h:i:s","id":"campaignEndDateInput"},on:{"update:date-value":_vm.updateCampaignEndDate}})],1)]),_vm._v(" "),_c('b-card',[_c('p',[_c('b',[_vm._v("Invoices Eligibility Conditions:")])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"invoiceStartDateInput"}},[_vm._v("*Invoice Start Date:")]),_vm._v(" "),_c('DateTimePicker',{attrs:{"format":"DD/MM/YYYY h:i:s","id":"invoiceStartDateInput"},on:{"update:date-value":_vm.updateInvoiceStartDate}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"invoiceEndDateInput"}},[_vm._v("*Invoice End Date:")]),_vm._v(" "),_c('DateTimePicker',{attrs:{"format":"DD/MM/YYYY h:i:s","id":"invoiceEndDateInput"},on:{"update:date-value":_vm.updateInvoiceEndDate}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"minInvoicePriceInput"}},[_vm._v("*Minimum Invoice Price Per Piece:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.minimumInvoicePricePerPiece),expression:"minimumInvoicePricePerPiece"}],staticClass:"form-control",attrs:{"type":"text","id":"minInvoicePriceInput","placeholder":"Enter Price","required":""},domProps:{"value":(_vm.minimumInvoicePricePerPiece)},on:{"input":function($event){if($event.target.composing){ return; }_vm.minimumInvoicePricePerPiece=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"eligibleOrderTypesInput"}},[_vm._v("*Eligible Order Types:")]),_vm._v(" "),_c('ul',{staticClass:"list-group",attrs:{"id":"eligibleOrderTypesInput"}},_vm._l((_vm.availableOrderTypes),function(item){return _c('li',{staticClass:"list-group-item",staticStyle:{"max-height":"200px","overflow-y":"auto"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibleOrderTypes),expression:"eligibleOrderTypes"}],attrs:{"type":"checkbox","name":item},domProps:{"value":item,"checked":Array.isArray(_vm.eligibleOrderTypes)?_vm._i(_vm.eligibleOrderTypes,item)>-1:(_vm.eligibleOrderTypes)},on:{"change":function($event){var $$a=_vm.eligibleOrderTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eligibleOrderTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eligibleOrderTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eligibleOrderTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"eligibleLensDesignsInput"}},[_vm._v("*Eligible Lens Designs:")]),_vm._v(" "),_c('ul',{staticClass:"list-group",staticStyle:{"max-height":"200px","overflow-y":"auto"},attrs:{"id":"eligibleLensDesignsInput"}},_vm._l((_vm.availableLensDesigns),function(item){return _c('li',{staticClass:"list-group-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibleLenseDesigns),expression:"eligibleLenseDesigns"}],attrs:{"type":"checkbox","name":item},domProps:{"value":item,"checked":Array.isArray(_vm.eligibleLenseDesigns)?_vm._i(_vm.eligibleLenseDesigns,item)>-1:(_vm.eligibleLenseDesigns)},on:{"change":function($event){var $$a=_vm.eligibleLenseDesigns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eligibleLenseDesigns=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eligibleLenseDesigns=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eligibleLenseDesigns=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"eligibleLensIndexesInput"}},[_vm._v("*Eligible Lens Indexes:")]),_vm._v(" "),_c('ul',{staticClass:"list-group",staticStyle:{"max-height":"200px","overflow-y":"auto"},attrs:{"id":"eligibleLensIndexesInput"}},_vm._l((_vm.availableLensIndexes),function(item){return _c('li',{staticClass:"list-group-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibleLensIndexes),expression:"eligibleLensIndexes"}],attrs:{"type":"checkbox","name":item},domProps:{"value":item,"checked":Array.isArray(_vm.eligibleLensIndexes)?_vm._i(_vm.eligibleLensIndexes,item)>-1:(_vm.eligibleLensIndexes)},on:{"change":function($event){var $$a=_vm.eligibleLensIndexes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eligibleLensIndexes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eligibleLensIndexes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eligibleLensIndexes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.createCampaign()}}},[_vm._v("Create")]),_vm._v(" "),(_vm.showModal)?_c('MyModal',{attrs:{"headerTitle":"Creating...","bodyMessage":"Please wait"},on:{"close":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.showCreateSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Campaign created. Available at campaigns screen."},on:{"close":function($event){return _vm.closeSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showCreateFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":"Could not create the campaign, please try again."},on:{"close":function($event){return _vm.closeFailModal()}}}):_vm._e(),_vm._v(" "),(_vm.showValidationModal)?_c('MyModal',{attrs:{"headerTitle":"Error","bodyMessage":_vm.validationMessage},on:{"close":function($event){return _vm.closeValidationModal()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileAppStuff_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b152b4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileAppStuff_vue__ = __webpack_require__(765);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileAppStuff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b152b4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileAppStuff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 763:
/***/ (function(module, exports) {

module.exports = "../../static/pages/AppTermsAndConditions.html";

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

module.exports = "../../static/pages/AppPrivacyPolicy.html";

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.showTermsAndConditions()}}},[_vm._v("App's Terms And Conditions")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.showPrivacyPolicy()}}},[_vm._v("App's Privacy Policy")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4bbbe26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4bbbe26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4bbbe26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 767:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h2',[_vm._v("E-Surprise BO")]),_vm._v(" "),_c('h3',[_vm._v("Sign In")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_c('br'),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.signIn()}}},[_vm._v("Sign In")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Claims_vue__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e43da8aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Claims_vue__ = __webpack_require__(772);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e43da8aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Claims_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e43da8aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Claims_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-button',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){_vm.filterModalShow = !_vm.filterModalShow}}},[_vm._v("Filter")]),_vm._v(" "),_c('span',[_vm._v(" By ")]),_vm._v(" "),(_vm.filterObject.campaignDocId.length > 0)?_c('span',[_vm._v("[Campaign id]: "+_vm._s(_vm.filterObject.campaignDocId)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.claimEmail.length > 0)?_c('span',[_vm._v("and [Email]: "+_vm._s(_vm.filterObject.claimEmail)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.prizeMoney.length > 0)?_c('span',[_vm._v("and [prize money]: "+_vm._s(_vm.filterObject.prizeMoney)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.status.length > 0)?_c('span',[_vm._v("and [status]: "+_vm._s(_vm.filterObject.status)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.requestedTaxInvoice.length > 0)?_c('span',[_vm._v("and [tax invoice]: "+_vm._s(_vm.filterObject.requestedTaxInvoice)+" ")]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Clear Filters")])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Filter"},model:{value:(_vm.filterModalShow),callback:function ($$v) {_vm.filterModalShow=$$v},expression:"filterModalShow"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"campaignName"}},[_vm._v("Campaign id:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.campaignDocId),expression:"filterObject.campaignDocId"}],attrs:{"type":"text","id":"campaignName","placeholder":""},domProps:{"value":(_vm.filterObject.campaignDocId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "campaignDocId", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"email"}},[_vm._v("Email:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.claimEmail),expression:"filterObject.claimEmail"}],attrs:{"type":"text","id":"email","placeholder":""},domProps:{"value":(_vm.filterObject.claimEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "claimEmail", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"prizeMoney"}},[_vm._v("Prize Money:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.prizeMoney),expression:"filterObject.prizeMoney"}],attrs:{"type":"text","id":"prizeMoney","placeholder":""},domProps:{"value":(_vm.filterObject.prizeMoney)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "prizeMoney", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status:")])]),_vm._v(" "),_c('b-col',[_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.filterObject.status}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('')}}}),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('CLAIMING')}}},[_vm._v("CLAIMING")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.searchStatusSelected('CLAIMED')}}},[_vm._v("CLAIMED")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"taxInvoice"}},[_vm._v("Tax Invoice:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.requestedTaxInvoice),expression:"filterObject.requestedTaxInvoice"}],attrs:{"type":"text","id":"taxInvoice","placeholder":""},domProps:{"value":(_vm.filterObject.requestedTaxInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "requestedTaxInvoice", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.filterTable()}}},[_vm._v("\n          Filter\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.filterModalShow = !_vm.filterModalShow}}},[_vm._v("\n          Close\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center","disabled":_vm.disabledPagination},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('b-btn',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){_vm.claimsCalculateModalShow = !_vm.claimsCalculateModalShow}}},[_vm._v("Calculate Claims")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-table',{staticClass:"claims-table",attrs:{"small":"","bordered":"","hover":"","responsive":"","striped":"","show-empty":"","items":_vm.tableRows,"fields":_vm.tableHeaders},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"cell(drawRecords)",fn:function(data){return [_c('div',{staticClass:"draw-records-cell"},[_vm._v(_vm._s(data.value || '-'))])]}}])}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    Loading error:\n    ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    No Result\n    ")]):_vm._e(),_vm._v("\nx\n    "),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal2","title":"Calculate Claims"},model:{value:(_vm.claimsCalculateModalShow),callback:function ($$v) {_vm.claimsCalculateModalShow=$$v},expression:"claimsCalculateModalShow"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"campaignName"}},[_vm._v("Campaign id:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.calculateClaimsObject.campaignDocId),expression:"calculateClaimsObject.campaignDocId"}],attrs:{"type":"text","id":"campaignName","placeholder":""},domProps:{"value":(_vm.calculateClaimsObject.campaignDocId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.calculateClaimsObject, "campaignDocId", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"email"}},[_vm._v("Email:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.calculateClaimsObject.claimEmail),expression:"calculateClaimsObject.claimEmail"}],attrs:{"type":"text","id":"email","placeholder":""},domProps:{"value":(_vm.calculateClaimsObject.claimEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.calculateClaimsObject, "claimEmail", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',[_c('b',[_vm._v("Total Claimed Money: RM "+_vm._s(_vm.calculatedTotalClaimedPrizeMoney))])])])],1),_vm._v(" "),_vm._l((_vm.calculatedObjects),function(calculatedObject){return _c('b-row',{key:calculatedObject.id,attrs:{"data":calculatedObject}},[_c('b-col',[_c('label',[_vm._v("Email: "+_vm._s(calculatedObject.claimEmail))])]),_vm._v(" "),_c('b-col',[_c('label',[_vm._v("Money Claimed: RM "+_vm._s(calculatedObject.prizeMoney))])]),_vm._v(" "),_c('b-col',[_c('label',[_vm._v("Voucher / Other Rewards: "+_vm._s(calculatedObject.rewardSummary || '-'))])])],1)}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.calculateClaims()}}},[_vm._v("\n          Calculate\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.claimsCalculateModalShow = !_vm.claimsCalculateModalShow}}},[_vm._v("\n          Close\n        ")])],1)],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"claims-legend"},[_c('b',[_vm._v("Claim Mode")]),_vm._v(" shows whether one invoice was used alone or paired with another invoice.\n      "),_c('b',[_vm._v("Requested Qty")]),_vm._v(" is the lens quantity used from the invoice selected by the customer.\n      "),_c('b',[_vm._v("Pairing Qty")]),_vm._v(" is the lens quantity used from the second invoice in a paired claim.\n      "),_c('b',[_vm._v("Subtype")]),_vm._v(" is the invoice item/subtype row id. "),_c('b',[_vm._v("Lenses")]),_vm._v(" is the quantity used from that row.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PairRequests_vue__ = __webpack_require__(597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8388815e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PairRequests_vue__ = __webpack_require__(774);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PairRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8388815e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PairRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-btn',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){_vm.searchModalShow = !_vm.searchModalShow}}},[_vm._v("Filter")]),_vm._v(" "),_c('span',[_vm._v(" By ")]),_vm._v(" "),(_vm.filterObject.campaignId.length > 0)?_c('span',[_vm._v("[Campaign id]: "+_vm._s(_vm.filterObject.campaignId)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.requester.length > 0)?_c('span',[_vm._v("and [Email]: "+_vm._s(_vm.filterObject.requester)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.invoiceNumberOne.length > 0)?_c('span',[_vm._v("and [invoiceNumberOne]: "+_vm._s(_vm.filterObject.invoiceNumberOne)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.invoiceNumberTwo.length > 0)?_c('span',[_vm._v("and [invoiceNumberTwo]: "+_vm._s(_vm.filterObject.invoiceNumberTwo)+" ")]):_vm._e(),_vm._v(" "),(_vm.filterObject.status.length > 0)?_c('span',[_vm._v("and [tax invoice]: "+_vm._s(_vm.filterObject.status)+" ")]):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Clear Filters")])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Filter"},model:{value:(_vm.searchModalShow),callback:function ($$v) {_vm.searchModalShow=$$v},expression:"searchModalShow"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"campaignName"}},[_vm._v("Campaign id:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.campaignId),expression:"filterObject.campaignId"}],attrs:{"type":"text","id":"campaignName","placeholder":""},domProps:{"value":(_vm.filterObject.campaignId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "campaignId", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"email"}},[_vm._v("Email:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.requester),expression:"filterObject.requester"}],attrs:{"type":"text","id":"email","placeholder":""},domProps:{"value":(_vm.filterObject.requester)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "requester", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"invoiceNumberOne"}},[_vm._v("Invoice Number One:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.invoiceNumberOne),expression:"filterObject.invoiceNumberOne"}],attrs:{"type":"text","id":"invoiceNumberOne","placeholder":""},domProps:{"value":(_vm.filterObject.invoiceNumberOne)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "invoiceNumberOne", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.status),expression:"filterObject.status"}],attrs:{"type":"text","id":"status","placeholder":""},domProps:{"value":(_vm.filterObject.status)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "status", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"invoiceNumberTwo"}},[_vm._v("Invoice Number Two:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterObject.invoiceNumberTwo),expression:"filterObject.invoiceNumberTwo"}],attrs:{"type":"text","id":"invoiceNumberTwo","placeholder":""},domProps:{"value":(_vm.filterObject.invoiceNumberTwo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "invoiceNumberTwo", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.filterTable()}}},[_vm._v("\n        Filter\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.searchModalShow = !_vm.searchModalShow}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh\n  ")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"status",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.status))]),_vm._v(" "),(row.item.status == 'WAITING')?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.approveOrRejectRequest()}}},[_vm._v("Decide\n      ")]):_vm._e()]}}])}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    No Result\n  ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Decide"},model:{value:(_vm.approveRejectModalShow),callback:function ($$v) {_vm.approveRejectModalShow=$$v},expression:"approveRejectModalShow"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[(_vm.selectedRowItem)?_c('label',[_vm._v("Choose to Approve or Reject the pairing request of\n        "+_vm._s(_vm.selectedRowItem.invoiceNumberOne)+" and "+_vm._s(_vm.selectedRowItem.invoiceNumberTwo)+" by\n        "+_vm._s(_vm.selectedRowItem.requester))]):_vm._e()])],1),_vm._v(" "),_c('b-tabs',[_c('b-tab',{attrs:{"title":"APPROVE","active":""}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',[_c('b',[_vm._v("NOTE: Once approved, request cannot be rejected")])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.approveRequest()}}},[_vm._v("Approve")])])],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"REJECT"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',[_c('b',[_vm._v("NOTE: Once rejected, request cannot be approved")])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"rejectReason"}},[_vm._v("Reject Reason:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rejectReason),expression:"rejectReason"}],attrs:{"type":"text","id":"rejectReason","placeholder":""},domProps:{"value":(_vm.rejectReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rejectReason=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectRequest()}}},[_vm._v("Reject")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.approveRejectModalShow = !_vm.approveRejectModalShow}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),(_vm.showUpdatingModal)?_c('MyModal',{attrs:{"headerTitle":"Updating...","bodyMessage":"Please wait"},on:{"close":function($event){return _vm.closeUpdatingModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUpdateSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Update Success."},on:{"close":function($event){return _vm.closeUpdateSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUpdateFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":_vm.updateFailMessage},on:{"close":function($event){return _vm.closeUpdateFailModal()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerAccounts_vue__ = __webpack_require__(598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bec1d5f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerAccounts_vue__ = __webpack_require__(776);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bec1d5f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center","disabled":_vm.disabledPagination},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.showCreateModal()}}},[_vm._v("New")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.showSearchModal()}}},[_vm._v("Search")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders},on:{"row-clicked":_vm.tableRowClicked}}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  No Result\n  ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Add New Customer Account"},model:{value:(_vm.showCreateModalRef),callback:function ($$v) {_vm.showCreateModalRef=$$v},expression:"showCreateModalRef"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"newCustomerAccount"}},[_vm._v("Customer Account:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCustomerAccount),expression:"newCustomerAccount"}],attrs:{"type":"text","id":"newCustomerAccount","placeholder":""},domProps:{"value":(_vm.newCustomerAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newCustomerAccount=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"newCustomerName"}},[_vm._v("Name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCustomerName),expression:"newCustomerName"}],attrs:{"type":"text","id":"newCustomerName","placeholder":""},domProps:{"value":(_vm.newCustomerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newCustomerName=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{staticStyle:{"color":"red"},attrs:{"for":"newCustomerError"}},[_vm._v(_vm._s(_vm.newCustomerError))])])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addCustomerAccount()}}},[_vm._v("\n        Add\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeCreateModal()}}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Search"},model:{value:(_vm.showSearchModalRef),callback:function ($$v) {_vm.showSearchModalRef=$$v},expression:"showSearchModalRef"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"searchCustomerAccount"}},[_vm._v("Customer Account:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCustomerAccount),expression:"searchCustomerAccount"}],attrs:{"type":"text","id":"searchCustomerAccount","placeholder":""},domProps:{"value":(_vm.searchCustomerAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchCustomerAccount=$event.target.value}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('label',{attrs:{"for":"searchCustomerName"}},[_vm._v("Name:")])]),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCustomerName),expression:"searchCustomerName"}],attrs:{"type":"text","id":"searchCustomerName","placeholder":""},domProps:{"value":(_vm.searchCustomerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchCustomerName=$event.target.value}}})])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.searchCustomer()}}},[_vm._v("\n        Search\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.closeSearchModal()}}},[_vm._v("\n        Close\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerAccountUpload_vue__ = __webpack_require__(599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbdc5614_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerAccountUpload_vue__ = __webpack_require__(784);
function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbdc5614"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerAccountUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbdc5614_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerAccountUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 778:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn customer-account-upload"},[_c('div',{staticClass:"page-header"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")])]),_vm._v(" "),_c('section',{staticClass:"upload-panel"},[_c('div',{staticClass:"upload-content"},[_c('div',{staticClass:"upload-title"},[_vm._v("Excel file")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"upload-controls"},[_c('label',{staticClass:"file-picker"},[_c('input',{attrs:{"type":"file","accept":".xls,.XLS,.xlsx,.XLSX"},on:{"change":function($event){return _vm.fileChange($event.target.files)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedFileName))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.fileToUpload},on:{"click":function($event){return _vm.uploadFile()}}},[_vm._v("Upload")])])])]),_vm._v(" "),(_vm.showUploadingModal)?_c('MyModal',{attrs:{"headerTitle":"Uploading...","bodyMessage":"Please wait"},on:{"close":function($event){return _vm.closeUploadingModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUploadingSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Upload Success."},on:{"close":function($event){return _vm.closeUploadSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUploadingFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":_vm.uploadFailedMessage},on:{"close":function($event){return _vm.closeUploadFailModal()}}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"table-panel"},[_c('div',{staticClass:"table-toolbar"},[_c('div',{staticClass:"toolbar-group"},[_c('span',[_vm._v("Rows Per Page")]),_vm._v(" "),_c('b-dropdown',{attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"size":"sm"}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")])],1)],1),_vm._v(" "),_c('div',{staticClass:"toolbar-pagination"},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"toolbar-total"},[_vm._v("\n        Total Rows "+_vm._s(_vm.totalRowsC)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"table-wrap"},[_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders,"id":"uploadedCustomerAccountsTable"},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"cell(status)",fn:function(row){return [_c('span',{staticClass:"status-text"},[_vm._v(_vm._s(row.item.status))]),_vm._v(" "),(row.item.status == 'NEW')?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.importFile(row.item.docId, row.item.fileName, row.item.status)}}},[_vm._v("Import")]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticClass:"empty-state"},[_vm._v("Loading error")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticClass:"empty-state"},[_vm._v("No Result")]):_vm._e()]),_vm._v(" "),(_vm.showImportingModal)?_c('MyModal',{attrs:{"headerTitle":"Importing...","bodyMessage":"Do not navigate away from this screen, please wait..."},on:{"close":function($event){return _vm.closeImportingModal()}}}):_vm._e(),_vm._v(" "),(_vm.showImportingSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Import Completed."},on:{"close":function($event){return _vm.closeImportSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showImportingFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":_vm.importFailedMessage},on:{"close":function($event){return _vm.closeImportFailModal()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Upload Customer Accounts")]),_vm._v(" "),_c('p',[_vm._v("Excel import for customer account master data.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-requirements"},[_vm._v("\n        Required columns: "),_c('strong',[_vm._v("Customer Account")]),_vm._v(", "),_c('strong',[_vm._v("Customer Name")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserClaimReport_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eb64441_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserClaimReport_vue__ = __webpack_require__(787);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserClaimReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eb64441_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserClaimReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Claim report for email: "+_vm._s(_vm.emailAddress)+" and HOYA account number: "+_vm._s(_vm.accountNumber))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.refreshReport()}}},[_vm._v("\n        Refresh report\n      ")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid black","padding":"20px"}},[_c('div',{attrs:{"id":"printableWindow"}},[_c('h2',{attrs:{"align":"center"}},[_vm._v("MALAYSIAN HOYA LENS SDN. BHD.")]),_vm._v(" "),_c('p',{staticStyle:{"text-decoration":"underline"}},[_vm._v("E-SURPRISE REWARD")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col"},[_vm._v("\n          Hoya A/C No:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col",staticStyle:{"border-bottom":"1px solid black"}},[_vm._v("\n          "+_vm._s(_vm.capAccountNumber)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col"},[_vm._v("\n          Customer:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col",staticStyle:{"border-bottom":"1px solid black"}},[_vm._v("\n          "+_vm._s(_vm.capName)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          Vouchers\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          QTY (PCS)\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          TOTAL AMT (RM)\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border":"1px solid black"}},[_vm._v("\n          Remark\n        ")])],1),_vm._v(" "),_vm._l((_vm.groupedClaims),function(claims){return _c('b-row',{key:claims.moneyType,attrs:{"v:bind:data":"claims"}},[_c('b-col',{staticStyle:{"border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          RM"+_vm._s(claims.moneyType)+"\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          "+_vm._s(claims.pieces)+"\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          "+_vm._s(claims.totalAmount)+"\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border":"1px solid black"}})],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"margin-bottom":"10px","border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          TOTAL\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"margin-bottom":"10px","border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          "+_vm._s(_vm.totalPieces)+"\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"margin-bottom":"10px","border":"1px solid black"},attrs:{"sm":"2"}},[_vm._v("\n          "+_vm._s(_vm.totalAmount)+"\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"margin-bottom":"10px","border":"1px solid black"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_vm._v("\n          Acknowledged by:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"},attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n          (Customer/ECP)\n        ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_vm._v("\n          Name:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"},attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_vm._v("\n          Company Stamp:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"}})],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"border-bottom":"1px dashed black"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{attrs:{"align":"center"}},[_vm._v("GIRO Bank Info")]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-bottom":"10px"}},[_c('b-col',[_vm._v("\n          Payee Bank:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"}},[_vm._v("\n          "+_vm._s(_vm.capBankName)+"\n        ")]),_vm._v(" "),_c('b-col',[_vm._v("\n          Bank Account Name:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"}},[_vm._v("\n          "+_vm._s(_vm.capBankAccountName)+"\n        ")])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-bottom":"10px"}},[_c('b-col',[_vm._v("\n          Payee Bank Branch:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"}}),_vm._v(" "),_c('b-col',[_vm._v("\n          Bank Account No:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"}},[_vm._v("\n          "+_vm._s(_vm.capBankAccountNumber)+"\n        ")])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-bottom":"10px"}},[_c('b-col'),_vm._v(" "),_c('b-col'),_vm._v(" "),_c('b-col',[_vm._v("\n          Payee Email Address:\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"border-bottom":"1px solid black"}},[_vm._v("\n          "+_vm._s(_vm.capEmail)+"\n        ")])],1)],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","onclick":"printJS('printableWindow', 'html')"}},[_vm._v("\n        Print report\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col"},[_vm._v("\n          Date of Collection:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col",staticStyle:{"border-bottom":"1px solid black"}}),_vm._v(" "),_c('div',{staticClass:"col"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col"},[_vm._v("\n          Hoya Sales Rep Name:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col",staticStyle:{"border-bottom":"1px solid black"}}),_vm._v(" "),_c('div',{staticClass:"col"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceUpload_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72341ad1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceUpload_vue__ = __webpack_require__(789);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72341ad1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticStyle:{"border":"1px dashed black","margin":"10px"}},[_c('b-col',{staticStyle:{"padding":"10px"}},[_c('form',{attrs:{"enctype":"multipart/form-data"}},[_c('input',{attrs:{"type":"file","accept":".csv,.CSV,.xls,.XLS,.xlsx,.XLSX"},on:{"change":function($event){return _vm.fileChange($event.target.files)}}}),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.uploadFile()}}},[_vm._v("Upload")])])])],1),_vm._v(" "),(_vm.showUploadingModal)?_c('MyModal',{attrs:{"headerTitle":"Uploading...","bodyMessage":"Please wait"},on:{"close":function($event){return _vm.closeUploadingModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUploadingSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Upload Success."},on:{"close":function($event){return _vm.closeUploadSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showUploadingFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":"Upload Failed."},on:{"close":function($event){return _vm.closeUploadFailModal()}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.tableRows,"fields":_vm.tableHeaders,"id":"uploadedInvoicesTable"},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"cell(status)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.status))]),_vm._v(" "),(row.item.status == 'NEW')?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.importFile(row.item.docId, row.item.fileName, row.item.status)}}},[_vm._v("Import")]):_vm._e()]}}])}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  No Result\n  ")]):_vm._e(),_vm._v(" "),(_vm.showImportingModal)?_c('MyModal',{attrs:{"headerTitle":"Importing...","bodyMessage":"Do not navigate away from this screen, import should not take more than 9 minutes, please wait..."},on:{"close":function($event){return _vm.closeImportingModal()}}}):_vm._e(),_vm._v(" "),(_vm.showImportingSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Import Completed."},on:{"close":function($event){return _vm.closeImportSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showImportingFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":_vm.importFailedMessage},on:{"close":function($event){return _vm.closeImportFailModal()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateTimePicker_vue__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MyModal_vue__ = __webpack_require__(747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__DateTimePicker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__MyModal_vue__["a"]; });












/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateClaimReports_vue__ = __webpack_require__(603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d851394_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateClaimReports_vue__ = __webpack_require__(791);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateClaimReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d851394_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateClaimReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"overflow-y":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(" Rows Per Page:")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-md-1",attrs:{"id":"ddown3","text":_vm.rowsPerPageCText,"disabled":_vm.showLoadingAnimation}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(10)}}},[_vm._v("10")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(20)}}},[_vm._v("20")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(50)}}},[_vm._v("50")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(100)}}},[_vm._v("100")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(150)}}},[_vm._v("150")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(200)}}},[_vm._v("200")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(500)}}},[_vm._v("500")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.rowsPerPageSelected(1000)}}},[_vm._v("1000")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"center"}},[_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalRowsC,"per-page":_vm.rowsPerPageC,"hide-ellipsis":"","limit":_vm.paginationButtonsLimit,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"align":"right"}},[_c('span',[_vm._v("Total Rows "+_vm._s(_vm.totalRowsC))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.showLoadingAnimation},on:{"click":function($event){return _vm.generateClaims()}}},[_vm._v("Generate")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","responsive":"true","items":_vm.tableRows,"fields":_vm.tableHeaders},on:{"row-clicked":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"cell(jobNumber)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.jobNumber))]),_vm._v(" "),(row.item.status === 'READY_FOR_DOWNLOAD')?_c('input',{staticStyle:{"margin-left":"5px","margin-right":"5px","width":"28px","height":"28px"},attrs:{"type":"image","src":"static/img/download-button.png","alt":"download"},on:{"click":function($event){return _vm.downloadFileFromGCS(row.item.jobNumber)}}}):_vm._e(),_vm._v(" "),(row.item.downloadUrl && row.item.downloadUrl.length > 0)?_c('a',{attrs:{"href":row.item.downloadUrl}},[_vm._v("Click here to download")]):_vm._e()]}}])}),_vm._v(" "),(_vm.showLoadingAnimation)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e(),_vm._v(" "),(_vm.showLoadingError)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  Loading error:\n  ")]):_vm._e(),_vm._v(" "),(_vm.showNoResult)?_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n  No Result\n  ")]):_vm._e(),_vm._v(" "),(_vm.showGeneratingModal)?_c('MyModal',{attrs:{"headerTitle":"Generating Reports in Background...","bodyMessage":"Reports are being generated in server, it will take a few minutes...You may close this message and refresh the page a few minutes later."},on:{"close":function($event){return _vm.closeGeneratingModal()}}}):_vm._e(),_vm._v(" "),(_vm.showCannotGenerateModal)?_c('MyModal',{attrs:{"headerTitle":"Cannot Generate Report","bodyMessage":"Cannot have more than 1 report generation at a time, please wait for that to finish and generate again"},on:{"close":function($event){return _vm.closeCannotGenerateModal()}}}):_vm._e(),_vm._v(" "),(_vm.showGeneratingSuccessModal)?_c('MyModal',{attrs:{"headerTitle":"Success","bodyMessage":"Report is still ongoing...Once it is finsihed, the job status will change to READY_TO_DOWNLOAD."},on:{"close":function($event){return _vm.closeGeneratingSuccessModal()}}}):_vm._e(),_vm._v(" "),(_vm.showGeneratingFailedModal)?_c('MyModal',{attrs:{"headerTitle":"Failed","bodyMessage":_vm.importFailedMessage},on:{"close":function($event){return _vm.closeGeneratingFailModal()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banners_vue__ = __webpack_require__(604);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f8d037_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banners_vue__ = __webpack_require__(796);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f8d037_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-alert',{attrs:{"variant":_vm.alertVariant,"dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),(_vm.multi || !_vm.banners || _vm.banners.length === 0)?_c('b-row',{staticStyle:{"border":"1px dashed black","margin":"10px"}},[_c('b-col',{staticStyle:{"padding":"10px"}},[_c('h5',[_vm._v(_vm._s(_vm.multi ? 'Upload Banner' : 'Banner Announcement'))]),_vm._v(" "),(_vm.multi)?[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bannerForm.title),expression:"bannerForm.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bannerForm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bannerForm, "title", $event.target.value)}}})]),_vm._v(" "),(_vm.allowDetails)?_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bannerForm.description),expression:"bannerForm.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bannerForm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bannerForm, "description", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.allowDetails)?_c('b-col',{staticStyle:{"margin-top":"10px"},attrs:{"md":"12"}},[_c('label',[_vm._v("Article")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.bannerForm.article),expression:"bannerForm.article"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.bannerForm.article)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bannerForm, "article", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Sort Order")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bannerForm.sortOrder),expression:"bannerForm.sortOrder"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.bannerForm.sortOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bannerForm, "sortOrder", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('label',[_vm._v("Active")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bannerForm.active),expression:"bannerForm.active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.bannerForm.active)?_vm._i(_vm.bannerForm.active,null)>-1:(_vm.bannerForm.active)},on:{"change":function($event){var $$a=_vm.bannerForm.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.bannerForm, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.bannerForm, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.bannerForm, "active", $$c)}}}})])]),_vm._v(" "),(_vm.allowImage)?_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Image")]),_vm._v(" "),_c('input',{staticClass:"form-control-file",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.fileChange($event.target.files)}}})]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.uploadBanner()}}},[_vm._v("Upload")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")]),_vm._v(" "),(_vm.uploadProgress > 0)?_c('span',[_vm._v(" Upload "+_vm._s(_vm.uploadProgress)+"%")]):_vm._e()]:[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bannerForm.title),expression:"bannerForm.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bannerForm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bannerForm, "title", $event.target.value)}}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.saveSingleBanner()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.refreshTable()}}},[_vm._v("Refresh")])]],2)],1):_vm._e(),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.banners,"fields":_vm.bannerFields},scopedSlots:_vm._u([{key:"cell(preview)",fn:function(row){return [_c('img',{staticStyle:{"height":"70px","max-width":"180px","object-fit":"cover"},attrs:{"src":row.item.imageUrl,"alt":"Banner"}})]}},{key:"cell(title)",fn:function(row){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.item.title),expression:"row.item.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(row.item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.item, "title", $event.target.value)}}})]}},{key:"cell(description)",fn:function(row){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.item.description),expression:"row.item.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(row.item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.item, "description", $event.target.value)}}})]}},{key:"cell(article)",fn:function(row){return [_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(row.item.article),expression:"row.item.article"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(row.item.article)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.item, "article", $event.target.value)}}})]}},{key:"cell(sortOrder)",fn:function(row){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.item.sortOrder),expression:"row.item.sortOrder"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(row.item.sortOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.item, "sortOrder", $event.target.value)}}})]}},{key:"cell(active)",fn:function(row){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.item.active),expression:"row.item.active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(row.item.active)?_vm._i(row.item.active,null)>-1:(row.item.active)},on:{"change":function($event){var $$a=row.item.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(row.item, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(row.item, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(row.item, "active", $$c)}}}})]}},{key:"cell(actions)",fn:function(row){return [_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.updateBanner(row.item)}}},[_vm._v("Save")]),_vm._v(" "),(!_vm.multi)?_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.toggleBannerVisibility(row.item)}}},[_vm._v("\n        "+_vm._s(row.item.active ? 'Hide' : 'Show')+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.multi)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.deleteBanner(row.item)}}},[_vm._v("Delete")]):_vm._e()]}}])}),_vm._v(" "),(_vm.loading)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__(605);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ac349a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__(803);
function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ac349a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 798:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-alert',{attrs:{"variant":_vm.alertVariant,"dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('b-row',{staticStyle:{"border":"1px dashed black","margin":"10px"}},[_c('b-col',{staticStyle:{"padding":"10px"}},[_c('h5',[_vm._v("Send Push Notification")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('label',[_vm._v("Message")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.body),expression:"form.body"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "body", $event.target.value)}}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Blast")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.blast),expression:"form.blast"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.blast)?_vm._i(_vm.form.blast,null)>-1:(_vm.form.blast)},on:{"change":function($event){var $$a=_vm.form.blast,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "blast", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "blast", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "blast", $$c)}}}})])]),_vm._v(" "),_c('b-col',{attrs:{"md":"10"}},[_c('label',[_vm._v("Search Customer/User")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userSearch),expression:"userSearch"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.form.blast,"placeholder":"Search company, customer account, email, phone, or status"},domProps:{"value":(_vm.userSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userSearch=$event.target.value}}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.form.blast)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"notification-selection-bar"},[_c('span',[_vm._v(_vm._s(_vm.selectedEmails.length)+" selected")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button","disabled":_vm.loading || _vm.pagedUsers.length === 0},on:{"click":function($event){return _vm.selectPageUsers()}}},[_vm._v("\n              Select Page\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button","disabled":_vm.loading || _vm.selectedEmails.length === 0},on:{"click":function($event){return _vm.clearSelectedUsers()}}},[_vm._v("\n              Clear\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.refreshUsers()}}},[_vm._v("\n              Refresh Users\n            ")])]),_vm._v(" "),_c('b-table',{staticClass:"notification-user-table",attrs:{"small":"","bordered":"","hover":"","items":_vm.pagedUsers,"fields":_vm.userFields},on:{"row-clicked":_vm.toggleUser}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.filteredUsers.length,"per-page":_vm.usersPerPage,"align":"right"},model:{value:(_vm.userCurrentPage),callback:function ($$v) {_vm.userCurrentPage=$$v},expression:"userCurrentPage"}})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.sendNotification()}}},[_vm._v("Send")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.refreshLogs()}}},[_vm._v("Refresh Logs")])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"border":"1px dashed black","margin":"10px"}},[_c('b-col',{staticStyle:{"padding":"10px"}},[_c('h5',[_vm._v("Invoice Upload Notification Settings")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"2"}},[_c('label',[_vm._v("Enabled")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingsForm.enabled),expression:"settingsForm.enabled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingsForm.enabled)?_vm._i(_vm.settingsForm.enabled,null)>-1:(_vm.settingsForm.enabled)},on:{"change":function($event){var $$a=_vm.settingsForm.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.settingsForm, "enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.settingsForm, "enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.settingsForm, "enabled", $$c)}}}})])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingsForm.title),expression:"settingsForm.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.settingsForm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settingsForm, "title", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('label',[_vm._v("Message")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingsForm.body),expression:"settingsForm.body"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.settingsForm.body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settingsForm, "body", $event.target.value)}}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.saveInvoiceEligibleSettings()}}},[_vm._v("Save Settings")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirm Push Notification"},on:{"ok":_vm.confirmSendNotification},model:{value:(_vm.showConfirmModal),callback:function ($$v) {_vm.showConfirmModal=$$v},expression:"showConfirmModal"}},[_c('p',[_c('b',[_vm._v("Title:")]),_vm._v(" "+_vm._s(_vm.form.title))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Message:")]),_vm._v(" "+_vm._s(_vm.form.body))]),_vm._v(" "),(_vm.form.blast)?_c('p',[_c('b',[_vm._v("Send To:")]),_vm._v(" All registered notification devices")]):_c('div',[_c('p',[_c('b',[_vm._v("Send To:")]),_vm._v(" "+_vm._s(_vm.selectedCustomerDetails.length)+" customer(s)")]),_vm._v(" "),_c('div',{staticClass:"notification-confirm-list"},_vm._l((_vm.selectedCustomerDetails),function(customer){return _c('div',{key:customer.email},[_vm._v("\n          "+_vm._s(customer.companyName || '-')+" / "+_vm._s(customer.accountNumber || '-')+" / "+_vm._s(customer.email)+"\n        ")])}),0)])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Notification Log Details","size":"lg","ok-only":""},model:{value:(_vm.showLogDetailModal),callback:function ($$v) {_vm.showLogDetailModal=$$v},expression:"showLogDetailModal"}},[(_vm.selectedLog)?_c('div',[_c('p',[_c('b',[_vm._v("Created:")]),_vm._v(" "+_vm._s(_vm.selectedLog.createdDate))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Title:")]),_vm._v(" "+_vm._s(_vm.selectedLog.title))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Message:")]),_vm._v(" "+_vm._s(_vm.selectedLog.body))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status:")]),_vm._v(" "+_vm._s(_vm.selectedLog.status))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Success:")]),_vm._v(" "+_vm._s(_vm.selectedLog.successCount)+" "),_c('b',[_vm._v("Failure:")]),_vm._v(" "+_vm._s(_vm.selectedLog.failureCount))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sent To:")]),_vm._v(" "+_vm._s(_vm.selectedLog.recipients || '-'))]),_vm._v(" "),(_vm.selectedLog.responses && _vm.selectedLog.responses.length > 0)?_c('div',[_c('h6',[_vm._v("Successful Recipients")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","items":_vm.successfulLogResponses,"fields":_vm.responseFields}}),_vm._v(" "),_c('h6',[_vm._v("Failed Recipients")]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","items":_vm.failedLogResponses,"fields":_vm.responseFields}})],1):_c('div',[_c('p',[_vm._v("This log was created before per-recipient response details were stored, or no tokens were found.")])])]):_vm._e()]),_vm._v(" "),_c('b-table',{attrs:{"small":"","bordered":"","hover":"","items":_vm.pagedLogs,"fields":_vm.logFields},scopedSlots:_vm._u([{key:"details",fn:function(row){return [_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openLogDetail(row.item)}}},[_vm._v("View")])]}}])}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.logs.length,"per-page":_vm.logsPerPage,"align":"right"},model:{value:(_vm.logCurrentPage),callback:function ($$v) {_vm.logCurrentPage=$$v},expression:"logCurrentPage"}}),_vm._v(" "),(_vm.loading)?_c('img',{staticStyle:{"margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/img/Rolling.svg","alt":"Loading data..."}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configuration_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1a39600_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configuration_vue__ = __webpack_require__(805);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configuration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1a39600_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configuration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('b-alert',{attrs:{"variant":_vm.alertVariant,"dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")]),_vm._v(" "),_c('label',{staticClass:"col-form-label",attrs:{"for":"invoiceFieldsCheckbox"}},[_vm._v("Select Auto-load Invoice Fields to Display")]),_vm._v(" "),_c('ul',{staticClass:"list-group",attrs:{"id":"invoiceFieldsCheckbox"}},_vm._l((_vm.availableInvoiceFields),function(item){return _c('li',{staticClass:"list-group-item",staticStyle:{"max-height":"200px","overflow-y":"auto"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceFieldsToDisplay),expression:"invoiceFieldsToDisplay"}],attrs:{"type":"checkbox","name":item.name},domProps:{"value":item.value,"checked":Array.isArray(_vm.invoiceFieldsToDisplay)?_vm._i(_vm.invoiceFieldsToDisplay,item.value)>-1:(_vm.invoiceFieldsToDisplay)},on:{"change":function($event){var $$a=_vm.invoiceFieldsToDisplay,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.invoiceFieldsToDisplay=$$a.concat([$$v]))}else{$$i>-1&&(_vm.invoiceFieldsToDisplay=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.invoiceFieldsToDisplay=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.saveInvoiceFieldsToDisplay()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.resetInvoiceFieldsToDisplay()}}},[_vm._v("Reset")]),_vm._v(" "),_c('br')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_firestore__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_storage__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_index__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__invoicesstoremodule__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__usersstoremodule__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__invoiceimportsstoremodule__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__createcampaignstoremodule__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaignstoremodule__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__claimsstoremodule__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pairrequestsstoremodule__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__customeraccountsstoremodule__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__customeraccountuploadstoremodule__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__userclaimreportstoremodule_js__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__invoiceuploadstoremodule__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__generateclaimreportsmodule__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__bannerstoremodule__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__notificationsstoremodule__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__configurationstoremodule__ = __webpack_require__(858);



























var config = {
  apiKey: 'AIzaSyALPpAdKPWL4QiUH6lG0cvzxLWtqa1UYWw',
  authDomain: 'hoya-e-surprise.firebaseapp.com',
  databaseURL: 'https://hoya-e-surprise-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'hoya-e-surprise',
  storageBucket: 'hoya-e-surprise.firebasestorage.app',
  messagingSenderId: '411242157418',
  appId: '1:411242157418:web:047633d556fa341c678113',
  measurementId: 'G-55YHGCJV6P'
};
__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].initializeApp(config);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().onAuthStateChanged(function (user) {
  state.currentUser = user;
  console.log('user: ' + user);
  console.log('router: ' + __WEBPACK_IMPORTED_MODULE_7__router_index__["a" /* default */].currentRoute.path);
  if (__WEBPACK_IMPORTED_MODULE_7__router_index__["a" /* default */].currentRoute.path === '/login') {
    __WEBPACK_IMPORTED_MODULE_7__router_index__["a" /* default */].push('invoices');
  }
});

var state = {
  firebase: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */],
  firestoreDB: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore(),
  realtimeDb: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].database(),
  fbStorage: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].storage(),
  currentUser: null
};

var mutations = {
  logOut: function logOut(state) {
    __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().signOut().then(function () {
      __WEBPACK_IMPORTED_MODULE_7__router_index__["a" /* default */].push('login');
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  modules: {
    invstomod: __WEBPACK_IMPORTED_MODULE_8__invoicesstoremodule__["a" /* default */],
    usrstomod: __WEBPACK_IMPORTED_MODULE_9__usersstoremodule__["a" /* default */],
    invimpmod: __WEBPACK_IMPORTED_MODULE_10__invoiceimportsstoremodule__["a" /* default */],
    crtcammod: __WEBPACK_IMPORTED_MODULE_11__createcampaignstoremodule__["a" /* default */],
    cammod: __WEBPACK_IMPORTED_MODULE_12__campaignstoremodule__["a" /* default */],
    claimmod: __WEBPACK_IMPORTED_MODULE_13__claimsstoremodule__["a" /* default */],
    pairmod: __WEBPACK_IMPORTED_MODULE_14__pairrequestsstoremodule__["a" /* default */],
    cusaccmod: __WEBPACK_IMPORTED_MODULE_15__customeraccountsstoremodule__["a" /* default */],
    cauploadmod: __WEBPACK_IMPORTED_MODULE_16__customeraccountuploadstoremodule__["a" /* default */],
    ucrmod: __WEBPACK_IMPORTED_MODULE_17__userclaimreportstoremodule_js__["a" /* default */],
    iumod: __WEBPACK_IMPORTED_MODULE_18__invoiceuploadstoremodule__["a" /* default */],
    gcrmod: __WEBPACK_IMPORTED_MODULE_19__generateclaimreportsmodule__["a" /* default */],
    bannermod: __WEBPACK_IMPORTED_MODULE_20__bannerstoremodule__["a" /* default */],
    notifmod: __WEBPACK_IMPORTED_MODULE_21__notificationsstoremodule__["a" /* default */],

    configmod: __WEBPACK_IMPORTED_MODULE_22__configurationstoremodule__["a" /* default */]
  }
}));

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);

var state = {
  all: [],
  headers: ['show_details', 'show_campaign_claims', 'taxInvoice', 'customerAccount', 'orderDate', 'status', 'createdDate', 'createdBy', 'updatedDate', 'updatedBy'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  selectedTaxInvoice: '',
  detailAll: [],
  detailHeaders: ['lensDesign', 'lensIndex', 'orderType', 'quantity', 'netAmount', 'status', 'createdDate', 'createdBy', 'updatedDate', 'updatedBy'],
  claimDetails: {
    requested: [],
    pairing: []
  },
  claimDetailHeaders: [{ key: 'campaignDocId', label: 'Campaign ID', sortable: true }, { key: 'status', label: 'Status', sortable: true }, { key: 'paired', label: 'Paired?', sortable: true }, { key: 'requestedTaxInvoice', label: 'Requested Invoice', sortable: true }, { key: 'pairingTaxInvoice', label: 'Pairing Invoice', sortable: true }, { key: 'claimSubtypesText', label: 'Quantity Used', sortable: true }, { key: 'totalQuantityUsed', label: 'Total Lenses Used', sortable: true }, { key: 'drawRecordsCount', label: 'Draw Count', sortable: true }, { key: 'remainingDrawTimes', label: 'Draws Left', sortable: true }, { key: 'createdDate', label: 'Created Date', sortable: true }, { key: 'updatedDate', label: 'Updated Date', sortable: true }],
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
};

function formatClaimSubtypes(subtypes) {
  if (!Array.isArray(subtypes) || subtypes.length === 0) {
    return '-';
  }

  return subtypes.map(function (eachType) {
    var quantity = Number(eachType.claimQuantity || 0);
    return 'Subtype: ' + (eachType.docId || eachType.subTypeDocId || '-') + '\nLenses: ' + quantity;
  }).join('\n\n');
}

function sumClaimSubtypes(subtypes) {
  if (!Array.isArray(subtypes)) {
    return 0;
  }

  return subtypes.reduce(function (total, eachType) {
    return total + Number(eachType.claimQuantity || 0);
  }, 0);
}

function formatDateTime(value) {
  if (!value) {
    return '';
  }

  return moment(dateutils.toJsDate(value)).format('DD/MMM/YYYY hh:mm:ss a');
}

function buildClaimDetailRow(doc, direction) {
  var data = doc.data();
  var claimSubtypes = direction === 'pairing' ? data.pairingClaimSubtypes || data.pairedClaimSubtypes || [] : data.requestedClaimSubtypes || [];

  return {
    docId: doc.id,
    campaignDocId: data.campaignDocId || '',
    claimEmail: data.claimEmail || '',
    status: data.status || '',
    paired: data.paired === true ? 'Yes' : 'No',
    requestedTaxInvoice: data.requestedTaxInvoice || '',
    pairingTaxInvoice: data.pairingTaxInvoice || data.pairedTaxInvoice || '',
    claimSubtypesText: formatClaimSubtypes(claimSubtypes),
    totalQuantityUsed: sumClaimSubtypes(claimSubtypes),
    drawRecordsCount: Array.isArray(data.drawRecords) ? data.drawRecords.length : 0,
    remainingDrawTimes: data.remainingDrawTimes || 0,
    createdDate: formatDateTime(data.createdDate),
    updatedDate: formatDateTime(data.updatedDate)
  };
}

function pushUniqueClaimDetail(rows, row) {
  var found = rows.find(function (eachRow) {
    return eachRow.docId === row.docId;
  });

  if (!found) {
    rows.push(row);
  }
}

var mutations = {
  updateFromOrderDate: function updateFromOrderDate(state, dateString) {
    console.log('Updating from order date to: ' + dateString);
    var m = moment(dateString, 'DD/MM/YYYY');
    state.searchObject.orderDate = m;
    console.log('Updated from order date to: ' + state.searchObject.orderDate);
  },
  updateToOrderDate: function updateToOrderDate(state, dateString) {
    console.log('Updating to order date to: ' + dateString);
    var m = moment(dateString, 'DD/MM/YYYY hh:mm:ss a');
    state.searchObject.orderDate = m;
    console.log('Updated to order date to: ' + state.searchObject.orderDate);
  },
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  updatedSelectedTaxInvoice: function updatedSelectedTaxInvoice(state, selectedTaxInvoice) {
    state.selectedTaxInvoice = selectedTaxInvoice;
  },
  selectTableRow: function selectTableRow(state, invoiceId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].invoiceId === invoiceId) {
        state.all[i]._rowVariant = 'info';
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  toggleDisabledPagination: function toggleDisabledPagination(state, show) {
    state.disabledPagination = show;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  },
  getDetailHeaders: function getDetailHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.detailHeaders.length; i++) {
      var eachHeader = state.detailHeaders[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  },
  getClaimDetailHeaders: function getClaimDetailHeaders(state, getters, rootState) {
    return state.claimDetailHeaders;
  }
};

var actions = {
  generateInvoiceReport: function generateInvoiceReport(context, payload) {
    context.state.all = [];
    console.log('Generating invoice report...');
    var startTime = performance.now();
    var startM = moment('14/12/2018 00:00:00', 'DD/MM/YYYY HH:mm:ss');
    var endM = moment('28/02/2019 23:59:59', 'DD/MM/YYYY HH:mm:ss');
    var docQuery = context.rootState.firestoreDB.collection('invoices').where('orderDate', '>=', startM.toDate()).where('orderDate', '<=', endM.toDate());
    if (!docQuery) {
      return;
    }
    docQuery.get().then(function (querySnapshot) {
      console.log('query result: ' + querySnapshot.size);
      var endTime = performance.now();
      console.log('Time spent: ' + (endTime - startTime) / 60000 + ' mins.');
    });
  },
  showAllInvoices: function showAllInvoices(context, payload) {
    context.state.all = [];

    context.commit('toggleDisabledPagination', true);

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.rootState.realtimeDb.ref('invoices').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount));
      } else {
        var calculatedTotalRows = 0;
        var firstQuery = context.rootState.firestoreDB.collection('imports');
        firstQuery.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            calculatedTotalRows = calculatedTotalRows + Number(doc.data().importedNewInvoices) + Number(doc.data().importedUpdateInvoices);

            context.commit('updateTotalRows', calculatedTotalRows);
          });
        });
      }
    });

    console.log('Last shown page:' + context.state.lastShown.lastShownPage);
    console.log('Rows per page: ' + context.state.rowsPerPage);
    console.log('Total pages:' + Math.ceil(context.state.totalRows / context.state.rowsPerPage));
    console.log('Last shown row:' + context.state.lastShown.lastRowShown);
    console.log('First shown row:' + context.state.lastShown.firstRowShown);

    var collectionName = 'invoices';
    var flippedSorting = void 0;
    var docQuery = void 0;
    var jumpedPage = void 0;
    var jumpedLimit = void 0;
    console.log('currentPage: ' + context.state.currentPage);
    if (context.state.currentPage === 1) {
      console.log('Show first page');
      docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'desc').limit(context.state.rowsPerPage);
    } else if (context.state.currentPage === Math.ceil(context.state.totalRows / context.state.rowsPerPage)) {
      console.log('Show last page');
      var limit = context.state.totalRows % context.state.rowsPerPage;
      if (limit === 0) {
        limit = context.state.rowsPerPage;
      }
      flippedSorting = true;
      docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'asc').limit(limit);
    } else if (context.state.currentPage - context.state.lastShown.lastShownPage === 1) {
      console.log('Show next page');
      docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'desc').startAfter(context.state.lastShown.lastRowShown).limit(context.state.rowsPerPage);
    } else if (context.state.currentPage - context.state.lastShown.lastShownPage === -1) {
      console.log('Show previous page');
      flippedSorting = true;
      docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'asc').startAfter(context.state.lastShown.firstRowShown).limit(context.state.rowsPerPage);
    } else if (context.state.currentPage > 1 && context.state.currentPage === context.state.lastShown.lastShownPage) {
      console.log('Re-Show not first page');
      docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'desc').startAt(context.state.lastShown.firstRowShown).limit(context.state.rowsPerPage);
    } else {
      if (context.state.currentPage > context.state.lastShown.lastShownPage) {
        console.log('Jumped forward page');
        var _limit = (context.state.currentPage - context.state.lastShown.lastShownPage) * context.state.rowsPerPage;
        jumpedPage = true;
        jumpedLimit = _limit;
        docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'desc').startAfter(context.state.lastShown.lastRowShown).limit(_limit);
      } else if (context.state.currentPage < context.state.lastShown.lastShownPage) {
        console.log('Jumped backward page');
        var _limit2 = (context.state.lastShown.lastShownPage - context.state.currentPage) * context.state.rowsPerPage;
        jumpedPage = true;
        jumpedLimit = _limit2;
        flippedSorting = true;
        docQuery = context.rootState.firestoreDB.collection(collectionName).orderBy(payload.orderBys, 'asc').startAfter(context.state.lastShown.firstRowShown).limit(_limit2);
      } else {
        console.error('Unsupported page navigation');
        context.commit('toggleDisabledPagination', false);
        return;
      }
    }

    var flippedResult = [];
    docQuery.get().then(function (querySnapshot) {
      var index = 0;
      var jumpIndex = 0;
      querySnapshot.forEach(function (doc) {
        if (jumpedPage && jumpIndex < jumpedLimit - context.state.rowsPerPage) {
          jumpIndex++;
          return;
        }
        if (index === 0) {
          context.state.lastShown.firstRowShown = doc;
        }
        index++;

        var documentData = doc.data();
        var invoiceObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'orderDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = m.format('DD/MMM/YYYY');
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m2 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
          } else {
            invoiceObject[propName] = doc.data()[eachProp];
          }
        }
        invoiceObject['_showDetails'] = false;
        invoiceObject.invoiceId = doc.id;
        invoiceObject._rowVariant = '';
        if (flippedSorting === true) {
          flippedResult.push(invoiceObject);
        } else {
          context.state.all.push(invoiceObject);
        }
        context.state.lastShown.lastShownPage = context.state.currentPage;
        context.state.lastShown.lastRowShown = doc;
      });
      if (flippedSorting === true) {
        flippedResult.reverse();
        flippedResult.forEach(function (value) {
          context.state.all.push(value);
        });
        var tempHolder = context.state.lastShown.firstRowShown;
        context.state.lastShown.firstRowShown = context.state.lastShown.lastRowShown;
        context.state.lastShown.lastRowShown = tempHolder;
      }
      context.commit('toggleShowLoadingAnimation', false);
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true);
      }
      context.commit('toggleDisabledPagination', false);
    }).catch(function (err) {
      context.commit('toggleDisabledPagination', false);
      console.log('Error while fetching documents in invoice collection: ' + err);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
    });
  },
  fetchInvoiceDetails: function fetchInvoiceDetails(context, payload) {
    for (var i = 0; i < context.state.all.length; i++) {
      if (context.state.all[i].taxInvoice === payload.taxInvoice && context.state.all[i]._showDetails === true) {
        context.state.all[i]._showDetails = false;
        return;
      }
    }

    console.log('fetch invoice details for ' + payload.taxInvoice);
    context.state.detailAll = [];
    var invoicesCollectionName = 'invoices';
    var invoiceSubtypesCollectionName = 'subtypes';
    var docQuery = context.rootState.firestoreDB.collection(invoicesCollectionName).doc(payload.taxInvoice).collection(invoiceSubtypesCollectionName);
    docQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();
        var invoiceSubTypesObject = {};
        invoiceSubTypesObject['__id'] = doc.id;
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'createdDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceSubTypesObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m3 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceSubTypesObject[propName] = _m3.format('DD/MMM/YYYY hh:mm:ss a');
          } else {
            invoiceSubTypesObject[propName] = doc.data()[eachProp];
          }
        }
        context.state.detailAll.push(invoiceSubTypesObject);
        for (var _i = 0; _i < context.state.all.length; _i++) {
          if (context.state.all[_i].taxInvoice === payload.taxInvoice) {
            context.state.all[_i].subTypes = context.state.detailAll;

            context.state.all[_i]._showDetails = true;
          }
        }
      });
    });
  },
  fetchInvoiceClaimDetails: function fetchInvoiceClaimDetails(context, payload) {
    if (!payload || !payload.taxInvoice) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }

    context.state.claimDetails = {
      requested: [],
      pairing: []
    };

    var claimsCollectionName = 'claims';
    var requestedQuery = context.rootState.firestoreDB.collection(claimsCollectionName).where('requestedTaxInvoice', '==', payload.taxInvoice).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.state.claimDetails.requested.push(buildClaimDetailRow(doc, 'requested'));
      });
    });

    var pairingQuery = context.rootState.firestoreDB.collection(claimsCollectionName).where('pairingTaxInvoice', '==', payload.taxInvoice).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        pushUniqueClaimDetail(context.state.claimDetails.pairing, buildClaimDetailRow(doc, 'pairing'));
      });
    });

    var legacyPairedQuery = context.rootState.firestoreDB.collection(claimsCollectionName).where('pairedTaxInvoice', '==', payload.taxInvoice).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        pushUniqueClaimDetail(context.state.claimDetails.pairing, buildClaimDetailRow(doc, 'pairing'));
      });
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([requestedQuery, pairingQuery, legacyPairedQuery]);
  },
  searchInvoices: function searchInvoices(context, payload) {
    if (!payload.taxInvoice && !payload.customerAccount && !payload.status && !payload.orderDate) {
      return;
    }
    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);
    context.state.all = [];
    context.state.detailAll = [];
    context.commit('updateTotalRows', 0);

    var invoicesCollectionName = 'invoices';
    var docQuery = context.rootState.firestoreDB.collection(invoicesCollectionName);
    console.log('filter by invoice: ' + payload.taxInvoice);
    if (payload.taxInvoice && payload.taxInvoice.length > 0) {
      docQuery = docQuery.where('taxInvoice', '==', payload.taxInvoice);
    }
    console.log('filter by customer acc: ' + payload.customerAccount);
    if (payload.customerAccount && payload.customerAccount.length > 0) {
      docQuery = docQuery.where('customerAccount', '==', payload.customerAccount);
    }
    console.log('filter by status: ' + payload.status);
    if (payload.status && payload.status.length > 0) {
      docQuery = docQuery.where('status', '==', payload.status);
    }
    console.log('filter by order date: ' + payload.orderDate);
    if (payload.orderDate && payload.orderDate.length > 0) {
      var startM = moment(payload.orderDate + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss');
      var endM = moment(payload.orderDate + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss');
      docQuery = docQuery.where('orderDate', '>=', startM.toDate()).where('orderDate', '<=', endM.toDate());
    }

    if (!docQuery) {
      return;
    }

    docQuery = docQuery.limit(context.state.rowsPerPage);

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size);
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();
        var invoiceObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'orderDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = m.format('DD/MMM/YYYY');
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            var _m4 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m4.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m5 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m5.format('DD/MMM/YYYY hh:mm:ss a');
          } else {
            invoiceObject[propName] = doc.data()[eachProp];
          }
        }
        invoiceObject['_showDetails'] = false;
        invoiceObject.invoiceId = doc.id;
        invoiceObject._rowVariant = '';
        context.state.all.push(invoiceObject);
      });
      context.commit('toggleShowLoadingAnimation', false);
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true);
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in invoice collection: ' + err);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);
var firestoretable = __webpack_require__(129);

var state = {
  all: [],
  headers: ['name', 'email', 'accountNumber', 'phoneNumber', 'phoneVerified', 'smsVerificationCode', 'status', 'approved', 'companyName', 'companyRegistrationNumber', 'bankName', 'bankAccountName', 'bankAccountNumber', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'demo'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showConfirmApproveModal: false,
  showChangeUserStatusModal: false,
  showEditUserModal: false,
  editedUser: {
    name: '',
    email: '',
    accountNumber: '',
    phoneNumber: '',
    companyName: '',
    companyRegistrationNumber: '',
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    isDemoAccount: ''
  },
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
};

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  toggleShowConfirmApproveModal: function toggleShowConfirmApproveModal(state, show) {
    state.showConfirmApproveModal = show;
  },
  toggleShowChangeUserStatusModal: function toggleShowChangeUserStatusModal(state, show) {
    state.showChangeUserStatusModal = show;
  },
  selectTableRow: function selectTableRow(state, email) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].email === email) {
        state.all[i]._rowVariant = 'info';
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowEditUserModal: function toggleShowEditUserModal(state, show) {
    state.showEditUserModal = show;
  },
  setEditedName: function setEditedName(state, newName) {
    state.editedUser.name = newName;
  },
  setEditedEmail: function setEditedEmail(state, newEmail) {
    state.editedUser.email = newEmail;
  },
  setEditedAccountNumber: function setEditedAccountNumber(state, newAccountNumber) {
    state.editedUser.accountNumber = newAccountNumber;
  },
  setEditedPhoneNumber: function setEditedPhoneNumber(state, newPhoneNumber) {
    state.editedUser.phoneNumber = newPhoneNumber;
  },
  setEditedCompanyName: function setEditedCompanyName(state, newCompanyName) {
    state.editedUser.companyName = newCompanyName;
  },
  setEditedCompanyRegistrationNumber: function setEditedCompanyRegistrationNumber(state, newRegisNum) {
    state.editedUser.companyRegistrationNumber = newRegisNum;
  },
  setEditedBankName: function setEditedBankName(state, newBankName) {
    state.editedUser.bankName = newBankName;
  },
  setEditedBankAccountName: function setEditedBankAccountName(state, newBankAccName) {
    state.editedUser.bankAccountName = newBankAccName;
  },
  setEditedBankAccountNumber: function setEditedBankAccountNumber(state, newBankAccNumber) {
    state.editedUser.bankAccountNumber = newBankAccNumber;
  },
  setIsDemoAccount: function setIsDemoAccount(state, isDemoAccount) {
    state.editedUser.isDemoAccount = isDemoAccount;
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  toggleDisabledPagination: function toggleDisabledPagination(state, show) {
    state.disabledPagination = show;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var actions = {
  showAllInvoices: function showAllInvoices(context, payload) {
    context.state.all = [];


    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.commit('toggleDisabledPagination', true);

    var queryParameters = {
      collectionName: 'users',
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'desc',
      orderByFlippedDirection: 'asc'
    };

    var docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters);

    firestoretable.queryCollection(docQuery, context, queryParameters, false);

    context.rootState.realtimeDb.ref('users').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount));
      } else {
        var firstQuery = context.rootState.firestoreDB.collection('users');
        firstQuery.get().then(function (querySnapshot) {
          context.commit('updateTotalRows', querySnapshot.docs.length);
        });
      }
    });
  },

  approveUser: function approveUser(context, payload) {
    var email = payload.email;
    var docRef = context.rootState.firestoreDB.collection('users').doc(email);

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, { approved: true, status: 'ACTIVE' });
        }
      });
    }).then(function () {
      console.log('user approved');
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' });
      context.commit('toggleShowConfirmApproveModal', false);
    }).catch(function (err) {
      console.error('Exception: ' + err);
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' });
      context.commit('toggleShowConfirmApproveModal', false);
    });
  },
  changeUserStatus: function changeUserStatus(context, payload) {
    var email = payload.email;
    var newStatus = payload.newStatus;

    var docRef = context.rootState.firestoreDB.collection('users').doc(email);

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, { status: newStatus });
        }
      });
    }).then(function () {
      console.log('user status changed');
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' });
      context.commit('toggleShowChangeUserStatusModal', false);
    }).catch(function (err) {
      console.error('Exception: ' + err);
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' });
      context.commit('toggleShowChangeUserStatusModal', false);
    });
  },
  updateUser: function updateUser(context, payload) {
    console.log('Edited user, name: ' + context.state.editedUser.name + ' email:' + context.state.editedUser.email + ' accountNumber:' + context.state.editedUser.accountNumber + ' phoneNumber:' + context.state.editedUser.phoneNumber + ' companyName:' + context.state.editedUser.companyName + ' companyRegistrationNumber:' + context.state.editedUser.companyRegistrationNumber + ' bankName:' + context.state.editedUser.bankName + ' bankAccountName:' + context.state.editedUser.bankAccountName + ' bankAccountNumber:' + context.state.editedUser.bankAccountNumber);

    var docRef = context.rootState.firestoreDB.collection('users').doc(context.state.editedUser.email);

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, {
            name: context.state.editedUser.name,
            email: context.state.editedUser.email,
            accountNumber: context.state.editedUser.accountNumber,
            phoneNumber: context.state.editedUser.phoneNumber,
            companyName: context.state.editedUser.companyName,
            companyRegistrationNumber: context.state.editedUser.companyRegistrationNumber,
            bankName: context.state.editedUser.bankName,
            bankAccountName: context.state.editedUser.bankAccountName,
            bankAccountNumber: context.state.editedUser.bankAccountNumber,
            updatedDate: new Date(),
            updatedBy: 'admin',
            demo: context.state.editedUser.isDemoAccount
          });
        }
      });
    }).then(function () {
      console.log('user updated');
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' });
      context.commit('toggleShowEditUserModal', false);
    }).catch(function (err) {
      console.error('Exception: ' + err);
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' });
      context.commit('toggleShowEditUserModal', false);
    });
  },
  filterTable: function filterTable(context, payload) {
    if (!payload.email && !payload.accountNumber && !payload.status && !payload.phoneNumber && !payload.createdDate && payload.demo === false) {
      return;
    }
    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);
    context.state.all = [];
    context.state.detailAll = [];
    context.commit('updateTotalRows', 0);

    var docQuery = context.rootState.firestoreDB.collection('users');
    for (var i in payload) {
      if (payload[i]) {
        console.log('where ' + i + '==' + payload[i]);
        if (i === 'demo' && payload[i] === true) {
          docQuery = docQuery.where(i, '==', true);
        } else if (i === 'createdDate') {
          var startM = moment(payload.createdDate + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss');
          var endM = moment(payload.createdDate + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss');
          docQuery = docQuery.where('createdDate', '>=', startM.toDate()).where('createdDate', '<=', endM.toDate());
        } else if (payload[i].length > 0) {
          docQuery = docQuery.where(i, '==', payload[i]);
        }
      }
    }

    if (!docQuery) {
      return;
    }

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size);
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();
        var invoiceObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'orderDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = m.format('DD/MMM/YYYY');
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m2 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
          } else {
            invoiceObject[propName] = doc.data()[eachProp];
          }
        }
        invoiceObject._rowVariant = '';
        context.state.all.push(invoiceObject);
      });
      context.commit('toggleShowLoadingAnimation', false);
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true);
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in invoice collection: ' + err);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);

var state = {
  all: [],
  headers: ['fileName', 'imported', 'error', 'importDate', 'finishImportDate', 'totalRows', 'totalInvoices', 'importedNewInvoices', 'importedUpdateInvoices', 'warns'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false
};

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var actions = {
  showAllInvoices: function showAllInvoices(context, payload) {
    context.state.all = [];


    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    var importsCollectionName = 'imports';

    var firstQuery = context.rootState.firestoreDB.collection(importsCollectionName);
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length);
    });

    if (context.state.currentPage === 1) {
      var docQuery = context.rootState.firestoreDB.collection(importsCollectionName).orderBy(payload.orderBys, 'desc').limit(context.state.rowsPerPage);
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var documentData = doc.data();
          var invoiceObject = {};
          for (var eachProp in documentData) {
            var propName = eachProp;

            if (propName === 'importDate' && doc.data()[eachProp]) {
              var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = m.format('DD/MMM/YYYY');
            } else if (propName === 'finishImportDate' && doc.data()[eachProp]) {
              var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
            } else {
              invoiceObject[propName] = doc.data()[eachProp];
            }
          }
          context.state.all.push(invoiceObject);
        });
        context.commit('toggleShowLoadingAnimation', false);
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true);
        }
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    } else {
      var lastRowShown = void 0;
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage;
      } else {
        lastRowShown = (context.state.currentPage - 1) * context.state.rowsPerPage;
      }
      console.log('lastRowShown: ' + lastRowShown);
      var _docQuery = context.rootState.firestoreDB.collection(importsCollectionName).orderBy(payload.orderBys, 'desc');
      _docQuery.get().then(function (querySnapshot) {
        var lastVisibleSnapshot = querySnapshot.docs[lastRowShown];

        var docSubQuery = context.rootState.firestoreDB.collection(importsCollectionName).orderBy(payload.orderBys).startAt(lastVisibleSnapshot).limit(context.state.rowsPerPage);
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            var documentData = subDoc.data();
            var invoiceObject = {};
            for (var eachProp in documentData) {
              var propName = eachProp;

              if (propName === 'importDate' && subDoc.data()[eachProp]) {
                var m = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = m.format('DD/MMM/YYYY');
              } else if (propName === 'finishImportDate' && subDoc.data()[eachProp]) {
                var _m2 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp];
              }
            }
            context.state.all.push(invoiceObject);
          });
          context.commit('toggleShowLoadingAnimation', false);
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true);
          }
        });
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var moment = __webpack_require__(2);

function getRewardValue(reward) {
  return Number(reward.rewardValue || reward.noteType || 0);
}

function getRewardQuantity(reward) {
  return Number(reward.totalQuantity || reward.noteAmount || 0);
}

function getRewardLabel(reward) {
  if (reward.rewardLabel && reward.rewardLabel.length > 0) {
    return reward.rewardLabel;
  }
  var rewardValue = getRewardValue(reward);
  return rewardValue > 0 ? 'RM ' + rewardValue : '';
}

function recalculateRewardPoolTotal(state) {
  state.sumOfAllNotes = 0;
  for (var i = 0; i < state.customRMAmount.length; i++) {
    var rewardValue = getRewardValue(state.customRMAmount[i]);
    var rewardQuantity = getRewardQuantity(state.customRMAmount[i]);
    if (rewardQuantity > 0) {
      state.sumOfAllNotes = Number(state.sumOfAllNotes) + Number(rewardValue * rewardQuantity);
    }
  }
}

function normalizeLensIndex(lensIndex) {
  if (lensIndex === undefined || lensIndex === null) {
    return '';
  }

  var value = String(lensIndex).trim();
  if (value.length === 0) {
    return '';
  }

  var numericValue = Number(value);
  return isNaN(numericValue) ? value : numericValue.toFixed(2);
}

function normalizeLensIndexes(lensIndexes) {
  var normalised = [];
  if (!lensIndexes) {
    return normalised;
  }

  for (var i = 0; i < lensIndexes.length; i++) {
    var lensIndex = normalizeLensIndex(lensIndexes[i]);
    if (lensIndex.length > 0 && normalised.indexOf(lensIndex) === -1) {
      normalised.push(lensIndex);
    }
  }
  return normalised;
}

function cleanFileName(fileName) {
  return fileName.replace(/[^a-zA-Z0-9._-]/g, '_');
}

function uploadCampaignBanner(context) {
  if (!context.state.bannerFile) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
      campaignImageUrl: '',
      campaignImageStoragePath: ''
    });
  }

  var fileName = Date.now() + '_' + cleanFileName(context.state.bannerFile.name);
  var storagePath = 'campaignBanners/' + fileName;
  var storageRef = context.rootState.fbStorage.ref().child(storagePath);

  return storageRef.put(context.state.bannerFile).then(function (snapshot) {
    return snapshot.ref.getDownloadURL();
  }).then(function (downloadURL) {
    return {
      campaignImageUrl: downloadURL,
      campaignImageStoragePath: storagePath
    };
  });
}

var state = {
  availableOrderTypes: [],
  availableLensDesigns: [],
  availableLensIndexes: [],
  name: '',
  isDemo: false,
  description: '',
  campaignImageUrl: '',
  campaignImageStoragePath: '',
  bannerFile: null,
  totalPrizeMoney: 0,
  startDate: '',
  endDate: '',
  invoiceStartDate: '',
  invoiceEndDate: '',
  minimumInvoicePricePerPiece: 0,
  eligibleLenseDesigns: [],
  eligibleLensIndexes: [],
  eligibleOrderTypes: [],
  showModal: false,
  showCreateSuccessModal: false,
  showCreateFailedModal: false,

  rm5Amount: 0,
  rm10Amount: 0,
  rm20Amount: 0,
  rm30Amount: 0,
  rm50Amount: 0,
  rm100Amount: 0,
  customRMAmount: [],
  sumOfAllNotes: 0,

  showValidationModal: false,
  validationMessage: ''
};

var mutations = {
  addOrderType: function addOrderType(state, orderType) {
    state.availableOrderTypes.push(orderType);
  },
  addLensDesign: function addLensDesign(state, lensDesign) {
    state.availableLensDesigns.push(lensDesign);
  },
  addLensIndex: function addLensIndex(state, lensIndex) {
    var normalisedLensIndex = normalizeLensIndex(lensIndex);
    if (normalisedLensIndex.length > 0 && state.availableLensIndexes.indexOf(normalisedLensIndex) === -1) {
      state.availableLensIndexes.push(normalisedLensIndex);
    }
  },
  updateCampaignStartDate: function updateCampaignStartDate(state, dateString) {
    var m = moment(dateString, 'DD/MM/YYYY hh:mm:ss');
    state.startDate = m;
  },
  updateCampaignEndDate: function updateCampaignEndDate(state, dateString) {
    var m = moment(dateString, 'DD/MM/YYYY hh:mm:ss');
    state.endDate = m;
  },
  updateInvoiceStartDate: function updateInvoiceStartDate(state, dateString) {
    var m = moment(dateString, 'DD/MM/YYYY hh:mm:ss');
    state.invoiceStartDate = m;
  },
  updateInvoiceEndDate: function updateInvoiceEndDate(state, dateString) {
    var m = moment(dateString, 'DD/MM/YYYY hh:mm:ss');
    state.invoiceEndDate = m;
  },
  updateName: function updateName(state, newName) {
    state.name = newName;
  },
  udpateIsDemo: function udpateIsDemo(state, isDemo) {
    state.isDemo = isDemo;
  },
  updateDescription: function updateDescription(state, newDescription) {
    state.description = newDescription;
  },
  updateCampaignBannerFile: function updateCampaignBannerFile(state, file) {
    state.bannerFile = file;
  },
  updateTotalPrizeMoney: function updateTotalPrizeMoney(state, newTotalPrizeMoney) {
    state.totalPrizeMoney = newTotalPrizeMoney;
  },
  updateMinimumInvoicePrice: function updateMinimumInvoicePrice(state, newMinimum) {
    state.minimumInvoicePricePerPiece = newMinimum;
  },
  updateEligibleLenseDesigns: function updateEligibleLenseDesigns(state, newValues) {
    state.eligibleLenseDesigns = newValues;
  },
  updateEligibleOrderTypes: function updateEligibleOrderTypes(state, newValues) {
    state.eligibleOrderTypes = newValues;
  },
  updateEligibleLensIndexes: function updateEligibleLensIndexes(state, newValues) {
    state.eligibleLensIndexes = newValues;
  },
  toggleShowModal: function toggleShowModal(state, show) {
    state.showModal = show;
  },
  toggleShowCreateSuccessModal: function toggleShowCreateSuccessModal(state, show) {
    state.showCreateSuccessModal = show;
  },
  toggleShowCreateFailedModal: function toggleShowCreateFailedModal(state, show) {
    state.showCreateFailedModal = show;
  },
  toggleShowValidationModal: function toggleShowValidationModal(state, show) {
    state.showValidationModal = show;
  },
  resetAllFields: function resetAllFields(state) {
    state.name = '';
    state.description = '';
    state.campaignImageUrl = '';
    state.campaignImageStoragePath = '';
    state.bannerFile = null;
    state.totalPrizeMoney = 0;
    state.startDate = '';
    state.endDate = '';
    state.invoiceStartDate = '';
    state.invoiceEndDate = '';
    state.minimumInvoicePricePerPiece = 0;
    state.eligibleLenseDesigns = [];
    state.eligibleLensIndexes = [];
    state.eligibleOrderTypes = [];
    state.rm5Amount = 0;
    state.rm10Amount = 0;
    state.rm20Amount = 0;
    state.rm30Amount = 0;
    state.rm50Amount = 0;
    state.rm100Amount = 0;
    state.customRMAmount = [];
    state.sumOfAllNotes = 0;
  },
  updateRm5Amount: function updateRm5Amount(state, newValue) {
    state.rm5Amount = Number(newValue);

    recalculateRewardPoolTotal(state);
  },
  updateRm10Amount: function updateRm10Amount(state, newValue) {
    state.rm10Amount = Number(newValue);

    recalculateRewardPoolTotal(state);
  },
  updateRm20Amount: function updateRm20Amount(state, newValue) {
    state.rm20Amount = Number(newValue);

    recalculateRewardPoolTotal(state);
  },
  updateRm30Amount: function updateRm30Amount(state, newValue) {
    state.rm30Amount = Number(newValue);

    recalculateRewardPoolTotal(state);
  },
  updateRm50Amount: function updateRm50Amount(state, newValue) {
    state.rm50Amount = Number(newValue);

    recalculateRewardPoolTotal(state);
  },
  updateRm100Amount: function updateRm100Amount(state, newValue) {
    state.rm100Amount = Number(newValue);

    recalculateRewardPoolTotal(state);
  },
  addCustomNote: function addCustomNote(state) {
    state.customRMAmount.push({
      rewardLabel: '',
      rewardType: 'VOUCHER',
      rewardValue: 0,
      totalQuantity: 0,
      noteType: 0,
      noteAmount: 0
    });
  },
  removeCustomNote: function removeCustomNote(state, index) {
    state.customRMAmount.splice(index, 1);
    recalculateRewardPoolTotal(state);
  },
  updatedCustomNote: function updatedCustomNote(state) {
    recalculateRewardPoolTotal(state);
  }
};

var getters = {
  getName: function getName(state, getters, rootState) {
    return state.name;
  },
  getDescription: function getDescription(state, getters, rootState) {
    return state.description;
  },
  getTotalPrizeMoney: function getTotalPrizeMoney(state, getters, rootState) {
    return state.totalPrizeMoney;
  },
  getStartDate: function getStartDate(state, getters, rootState) {
    var dateString = state.startDate.format('DD/MM/YYYY hh:mm:ss');
    return dateString;
  },
  getEndDate: function getEndDate(state, getters, rootState) {
    var dateString = state.endDate.format('DD/MM/YYYY hh:mm:ss');
    return dateString;
  },
  getInvoiceStartDate: function getInvoiceStartDate(state, getters, rootState) {
    var dateString = state.invoiceStartDate.format('DD/MM/YYYY hh:mm:ss');
    return dateString;
  },
  getInvoiceEndDate: function getInvoiceEndDate(state, getters, rootState) {
    var dateString = state.invoiceEndDate.format('DD/MM/YYYY hh:mm:ss');
    return dateString;
  },
  getMinimumInvoicePricePerPiece: function getMinimumInvoicePricePerPiece(state, getters, rootState) {
    return state.minimumInvoicePricePerPiece;
  },
  getEligibleLenseDesigns: function getEligibleLenseDesigns(state, getters, rootState) {
    return state.eligibleLenseDesigns;
  },
  getEligibleOrderTypes: function getEligibleOrderTypes(state, getters, rootState) {
    return state.eligibleOrderTypes;
  },
  getAvailableLensDesigns: function getAvailableLensDesigns(state, getters, rootState) {
    return state.availableLensDesigns;
  },
  getAvailableLensIndexes: function getAvailableLensIndexes(state, getters, rootState) {
    return state.availableLensIndexes;
  },
  getAvailableOrderTypes: function getAvailableOrderTypes(state, getters, rootState) {
    return state.availableOrderTypes;
  }
};

var actions = {
  fetchAvailableOrderTypesFromFirestore: function fetchAvailableOrderTypesFromFirestore(context) {
    context.state.availableOrderTypes = [];

    var firstQuery = context.rootState.firestoreDB.collection('orderTypes').orderBy('orderType');
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.commit('addOrderType', doc.data().orderType);
      });
    });
  },
  fetchAvailableLensDesignsFromFirestore: function fetchAvailableLensDesignsFromFirestore(context) {
    context.state.availableLensDesigns = [];

    var firstQuery = context.rootState.firestoreDB.collection('lensDesigns').orderBy('lensDesign');
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.commit('addLensDesign', doc.data().lensDesign);
      });
    });
  },
  fetchAvailableLensIndexesFromFirestore: function fetchAvailableLensIndexesFromFirestore(context) {
    context.state.availableLensIndexes = [];

    var firstQuery = context.rootState.firestoreDB.collection('lensIndexes').orderBy('lensIndex');
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.commit('addLensIndex', doc.data().lensIndex);
      });
    });
  },
  createCampaignInFirebase: function createCampaignInFirebase(context) {
    if (context.state.name.length < 1) {
      context.state.validationMessage = 'Campaign name cannot be empty';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.description.length < 1) {
      context.state.validationMessage = 'Campaign description cannot be empty';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (!context.state.startDate) {
      context.state.validationMessage = 'You need to set a CAMPAIGN START date';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (!context.state.endDate) {
      context.state.validationMessage = 'You need to set a CAMPAIGN END date';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.startDate >= context.state.endDate) {
      context.state.validationMessage = 'CAMPAIGN END date need to be LATER than CAMPAIGN START date';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (!context.state.invoiceStartDate) {
      context.state.validationMessage = 'You need to set the INVOICE START date';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (!context.state.invoiceEndDate) {
      context.state.validationMessage = 'You need to set the INVOICE END date';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.invoiceStartDate >= context.state.invoiceEndDate) {
      context.state.validationMessage = 'INVOICE END date need to be LATER than INVOICE START date';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.minimumInvoicePricePerPiece < 0) {
      context.state.validationMessage = 'Minimum invoice price per piece cannot be less than 0';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.eligibleLenseDesigns.length === 0) {
      context.state.validationMessage = 'Please select at least one eligible lense design';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.eligibleOrderTypes.length === 0) {
      context.state.validationMessage = 'Please select at least one eligible order type';
      context.commit('toggleShowValidationModal', true);
      return;
    }
    if (context.state.eligibleLensIndexes.length === 0) {
      context.state.validationMessage = 'Please select at least one eligible lens index';
      context.commit('toggleShowValidationModal', true);
      return;
    }

    var notesPool = [];
    for (var i = 0; i < context.state.customRMAmount.length; i++) {
      var reward = context.state.customRMAmount[i];
      var rewardLabel = getRewardLabel(reward);
      var rewardValue = getRewardValue(reward);
      var rewardQuantity = getRewardQuantity(reward);

      if (rewardQuantity > 0 && rewardLabel.length > 0) {
        notesPool.push({
          rewardId: rewardLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + i,
          rewardLabel: rewardLabel,
          rewardType: reward.rewardType || (rewardValue > 0 ? 'MONEY' : 'VOUCHER'),
          rewardValue: rewardValue,
          totalQuantity: rewardQuantity,
          claimedQuantity: 0,
          noteType: String(rewardValue),
          noteAmount: rewardQuantity,
          claimedAmount: 0
        });
      }
    }
    if (notesPool.length === 0) {
      context.state.validationMessage = 'Please specify at least one reward name and quantity';
      context.commit('toggleShowValidationModal', true);
      return;
    }

    context.commit('toggleShowModal', true);
    var campaignsCollection = context.rootState.firestoreDB.collection('campaigns');

    uploadCampaignBanner(context).then(function (bannerInfo) {
      var objToAdd = {
        name: context.state.name,
        demo: context.state.isDemo,
        description: context.state.description,
        campaignImageUrl: bannerInfo.campaignImageUrl,
        campaignImageStoragePath: bannerInfo.campaignImageStoragePath,
        totalPrizeMoney: Number(context.state.sumOfAllNotes),
        startDate: context.state.startDate.toDate(),
        endDate: context.state.endDate.toDate(),
        invoiceStartDate: context.state.invoiceStartDate.toDate(),
        invoiceEndDate: context.state.invoiceEndDate.toDate(),
        minimumPrice: context.state.minimumInvoicePricePerPiece,
        orderTypes: context.state.eligibleOrderTypes,
        lensDesigns: context.state.eligibleLenseDesigns,
        lensIndexes: normalizeLensIndexes(context.state.eligibleLensIndexes),
        status: 'NEW',
        createdDate: new Date(),
        createdBy: '',
        updatedDate: null,
        updatedBy: '',
        notesPool: notesPool
      };

      return campaignsCollection.add(objToAdd);
    }).then(function (docRef) {
      console.log('Created campaign');

      context.commit('resetAllFields');
      context.commit('toggleShowModal', false);
      context.commit('toggleShowCreateSuccessModal', true);
      context.commit('toggleShowValidationModal', false);
    }).catch(function (err) {
      console.error('Error creating campaign: ' + err);
      context.commit('resetAllFields');
      context.commit('toggleShowModal', false);
      context.commit('toggleShowCreateFailedModal', true);
      context.commit('toggleShowValidationModal', false);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);

var state = {
  all: [],
  headers: ['status', 'name', 'totalPrizeMoney', 'startDate', 'endDate', 'invoiceStartDate', 'invoiceEndDate', 'minimumPrice', 'description', 'campaignImageUrl', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'campaignId', 'demo'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showUpdatingStatusModal: false,
  showChangeStatusModal: false,
  showUpdateSuccessModal: false,
  showUpdateFailModal: false,
  showEditCampaignModal: false,
  editedCampaign: {
    campaignId: '',
    name: '',
    description: '',
    campaignImageUrl: '',
    campaignImageStoragePath: '',
    bannerFile: null,
    campaignStartDate: null,
    campaignEndDate: null,
    invoiceStartDate: null,
    invoiceEndDate: null,
    minimumInvoicePerPiece: 0,
    eligibleOrderTypes: [],
    availableEligibleOrderTypes: [],
    eligibleLensDesigns: [],
    availableEligibleLensDesigns: [],
    eligibleLensIndexes: [],
    availableEligibleLensIndexes: [],
    notesPool: [],
    editedIsDemoAccount: false
  },
  showCampaignLiveModal: false,
  campaignMoneyPool: {
    claimedPrizeMoney: 0,
    totalPrizeMoney: 0,
    notesPool: []
  },
  realtimeCampaignRef: null,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false
};

function getRewardValue(reward) {
  return Number(reward && (reward.rewardValue || reward.noteType) || 0);
}

function getRewardQuantity(reward) {
  return Number(reward && (reward.totalQuantity || reward.noteAmount) || 0);
}

function getRewardLabel(reward) {
  if (!reward) {
    return 'Voucher';
  }
  if (reward.rewardLabel && reward.rewardLabel.length > 0) {
    return reward.rewardLabel;
  }
  var rewardValue = getRewardValue(reward);
  return rewardValue > 0 ? 'RM ' + rewardValue : 'Voucher';
}

function getRewardClaimedQuantity(reward) {
  return Number(reward && (reward.claimedQuantity || reward.claimedAmount) || 0);
}

function getRewardId(reward, index) {
  if (reward && reward.rewardId && String(reward.rewardId).length > 0) {
    return reward.rewardId;
  }
  var rewardLabel = getRewardLabel(reward);
  return rewardLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + index;
}

function normaliseReward(reward, index) {
  var rewardValue = getRewardValue(reward);
  var rewardQuantity = getRewardQuantity(reward);
  var claimedQuantity = getRewardClaimedQuantity(reward);
  var rewardLabel = getRewardLabel(reward);
  return {
    rewardId: getRewardId(reward, index),
    rewardLabel: rewardLabel,
    rewardType: reward && reward.rewardType ? reward.rewardType : rewardValue > 0 ? 'MONEY' : 'VOUCHER',
    rewardValue: rewardValue,
    totalQuantity: rewardQuantity,
    claimedQuantity: claimedQuantity,
    noteType: String(rewardValue),
    noteAmount: rewardQuantity,
    claimedAmount: claimedQuantity
  };
}

function normaliseRewards(rewards) {
  var notesPool = [];
  if (!rewards) {
    return notesPool;
  }
  for (var i = 0; i < rewards.length; i++) {
    notesPool.push(normaliseReward(rewards[i], i));
  }
  return notesPool;
}

function calculateRewardTotal(notesPool) {
  var total = 0;
  for (var i = 0; i < notesPool.length; i++) {
    total += Number(notesPool[i].rewardValue || 0) * Number(notesPool[i].totalQuantity || 0);
  }
  return total;
}

function validateRewards(editedRewards, liveRewards) {
  if (!editedRewards || editedRewards.length === 0) {
    return 'Please add at least one reward.';
  }

  var liveById = {};
  if (liveRewards) {
    for (var i = 0; i < liveRewards.length; i++) {
      var liveReward = normaliseReward(liveRewards[i], i);
      liveById[liveReward.rewardId] = liveReward;
    }
  }

  var editedById = {};
  for (var _i = 0; _i < editedRewards.length; _i++) {
    var reward = editedRewards[_i];
    if (!reward.rewardLabel || String(reward.rewardLabel).trim().length === 0) {
      return 'Reward name cannot be empty.';
    }
    if (Number(reward.rewardValue) < 0 || isNaN(Number(reward.rewardValue))) {
      return 'Reward cash value must be 0 or more.';
    }
    if (Number(reward.totalQuantity) < 0 || isNaN(Number(reward.totalQuantity))) {
      return 'Reward quantity must be 0 or more.';
    }

    var _liveReward = liveById[reward.rewardId];
    if (_liveReward) {
      reward.rewardType = _liveReward.rewardType;
      reward.rewardValue = _liveReward.rewardValue;
      reward.noteType = _liveReward.noteType;
      reward.claimedQuantity = getRewardClaimedQuantity(_liveReward);
      reward.claimedAmount = reward.claimedQuantity;
      if (Number(reward.totalQuantity) < Number(reward.claimedQuantity)) {
        return 'Reward "' + reward.rewardLabel + '" already has ' + reward.claimedQuantity + ' claimed piece(s). Quantity cannot be lower than claimed.';
      }
    }
    editedById[reward.rewardId] = reward;
  }

  for (var rewardId in liveById) {
    if (liveById.hasOwnProperty(rewardId) && Number(liveById[rewardId].claimedQuantity) > 0 && !editedById[rewardId]) {
      return 'Reward "' + liveById[rewardId].rewardLabel + '" has claims already. It cannot be deleted.';
    }
  }

  return '';
}

function normalizeLensIndex(lensIndex) {
  if (lensIndex === undefined || lensIndex === null) {
    return '';
  }

  var value = String(lensIndex).trim();
  if (value.length === 0) {
    return '';
  }

  var numericValue = Number(value);
  return isNaN(numericValue) ? value : numericValue.toFixed(2);
}

function normalizeLensIndexes(lensIndexes) {
  var normalised = [];
  if (!lensIndexes) {
    return normalised;
  }

  for (var i = 0; i < lensIndexes.length; i++) {
    var lensIndex = normalizeLensIndex(lensIndexes[i]);
    if (lensIndex.length > 0 && normalised.indexOf(lensIndex) === -1) {
      normalised.push(lensIndex);
    }
  }
  return normalised;
}

function cleanFileName(fileName) {
  return fileName.replace(/[^a-zA-Z0-9._-]/g, '_');
}

function uploadEditedCampaignBanner(context) {
  if (!context.state.editedCampaign.bannerFile) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
      campaignImageUrl: context.state.editedCampaign.campaignImageUrl || '',
      campaignImageStoragePath: context.state.editedCampaign.campaignImageStoragePath || ''
    });
  }

  var fileName = Date.now() + '_' + cleanFileName(context.state.editedCampaign.bannerFile.name);
  var storagePath = 'campaignBanners/' + fileName;
  var storageRef = context.rootState.fbStorage.ref().child(storagePath);

  return storageRef.put(context.state.editedCampaign.bannerFile).then(function (snapshot) {
    return snapshot.ref.getDownloadURL();
  }).then(function (downloadURL) {
    return {
      campaignImageUrl: downloadURL,
      campaignImageStoragePath: storagePath
    };
  });
}

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
    console.log('CHanged state page number to: ' + state.currentPage);
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
    console.log('Mutated totalRows to: ' + state.totalRows);
  },
  selectTableRow: function selectTableRow(state, selectedCampaignId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].campaignId === selectedCampaignId) {
        state.all[i]._rowVariant = 'info';
        console.log('selected selectedCampaignId:' + selectedCampaignId);
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowUpdatingStatusModal: function toggleShowUpdatingStatusModal(state, show) {
    state.showUpdatingStatusModal = show;
  },
  toggleShowChangeStatusModal: function toggleShowChangeStatusModal(state, show) {
    state.showChangeStatusModal = show;
    console.log('showChangeStatusModal: ' + state.showChangeStatusModal);
  },
  toggleshowUpdateSuccessModal: function toggleshowUpdateSuccessModal(state, show) {
    state.showUpdateSuccessModal = show;
  },
  toggleShowUpdateFailModal: function toggleShowUpdateFailModal(state, show) {
    state.showUpdateFailModal = show;
  },
  toggleShowEditCampaignModal: function toggleShowEditCampaignModal(state, show) {
    state.showEditCampaignModal = show;
  },
  updateNewCampaignId: function updateNewCampaignId(state, newId) {
    state.editedCampaign.campaignId = newId;
  },
  updateNewCampaignName: function updateNewCampaignName(state, newName) {
    state.editedCampaign.name = newName;
  },
  updateNewCampaignDescription: function updateNewCampaignDescription(state, newDescription) {
    state.editedCampaign.description = newDescription;
  },
  updateNewCampaignImageUrl: function updateNewCampaignImageUrl(state, newImageUrl) {
    state.editedCampaign.campaignImageUrl = newImageUrl || '';
  },
  updateNewCampaignImageStoragePath: function updateNewCampaignImageStoragePath(state, newStoragePath) {
    state.editedCampaign.campaignImageStoragePath = newStoragePath || '';
  },
  updateEditedCampaignBannerFile: function updateEditedCampaignBannerFile(state, file) {
    state.editedCampaign.bannerFile = file;
  },
  updateNewCampaignStartDate: function updateNewCampaignStartDate(state, dateString) {
    console.debug('Updating campaign start date to: ' + dateString);
    var m = dateutils.parseDateTime(dateString);
    state.editedCampaign.campaignStartDate = m;
    console.debug('Updated campaign start date to: ' + state.editedCampaign.campaignStartDate.toDate());
  },
  updateNewCampaignEndDate: function updateNewCampaignEndDate(state, dateString) {
    console.debug('Updating campaign end date to: ' + dateString);
    var m = dateutils.parseDateTime(dateString);
    state.editedCampaign.campaignEndDate = m;
    console.debug('Updated campaign end date to: ' + state.editedCampaign.campaignEndDate.toDate());
  },
  updateNewInvoiceStartDate: function updateNewInvoiceStartDate(state, dateString) {
    console.debug('Updating invoice start date to: ' + dateString);
    var m = dateutils.parseDateTime(dateString);
    state.editedCampaign.invoiceStartDate = m;
    console.debug('Updated invoice start date to: ' + state.editedCampaign.invoiceStartDate.toDate());
  },
  updateNewInvoiceEndDate: function updateNewInvoiceEndDate(state, dateString) {
    console.debug('Updating invoice end date to: ' + dateString);
    var m = dateutils.parseDateTime(dateString);
    state.editedCampaign.invoiceEndDate = m;
    console.debug('Updated invoice end date to: ' + state.editedCampaign.invoiceEndDate.toDate());
  },
  updateminimumInvoicePerPiece: function updateminimumInvoicePerPiece(state, newMinimumInvoicePerPiece) {
    state.editedCampaign.minimumInvoicePerPiece = newMinimumInvoicePerPiece;
  },
  updateEligibleLenseDesigns: function updateEligibleLenseDesigns(state, newValues) {
    state.editedCampaign.eligibleLensDesigns = newValues;
  },
  updateEligibleOrderTypes: function updateEligibleOrderTypes(state, newValues) {
    state.editedCampaign.eligibleOrderTypes = newValues;
  },
  updateEligibleLensIndexes: function updateEligibleLensIndexes(state, newValues) {
    state.editedCampaign.eligibleLensIndexes = newValues;
  },
  updateEditedCampaignRewards: function updateEditedCampaignRewards(state, notesPool) {
    state.editedCampaign.notesPool = normaliseRewards(notesPool || []);
  },
  addEditedCampaignReward: function addEditedCampaignReward(state) {
    state.editedCampaign.notesPool.push(normaliseReward({
      rewardLabel: '',
      rewardType: 'VOUCHER',
      rewardValue: 0,
      totalQuantity: 1,
      claimedQuantity: 0
    }, state.editedCampaign.notesPool.length));
  },
  removeEditedCampaignReward: function removeEditedCampaignReward(state, index) {
    state.editedCampaign.notesPool.splice(index, 1);
  },
  updateEditedIsDemoAccount: function updateEditedIsDemoAccount(state, editedIsDemoAccount) {
    state.editedCampaign.editedIsDemoAccount = editedIsDemoAccount;
  },
  toggleShowCampaignLiveModal: function toggleShowCampaignLiveModal(state, show) {
    state.showCampaignLiveModal = show;
  },
  turnOffLiveCampignListener: function turnOffLiveCampignListener(state) {
    if (state.realtimeCampaignRef) {
      state.realtimeCampaignRef.off();
    }
  },
  updateLiveCampaignObject: function updateLiveCampaignObject(state, snapshotValue) {
    state.campaignMoneyPool.claimedPrizeMoney = snapshotValue.claimedPrizeMoney;
    state.campaignMoneyPool.totalPrizeMoney = snapshotValue.totalPrizeMoney;
    state.campaignMoneyPool.notesPool = snapshotValue.notesPool;
  },
  toggleShowHideRowDetail: function toggleShowHideRowDetail(state, campaignId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].campaignId === campaignId) {
        if (state.all[i]._showDetails === true) {
          state.all[i]._showDetails = false;
        } else {
          state.all[i]._showDetails = true;
        }
      }
    }
  },
  addOrderType: function addOrderType(state, orderType) {
    state.editedCampaign.availableEligibleOrderTypes.push(orderType);
  },
  addLensDesign: function addLensDesign(state, lensDesign) {
    state.editedCampaign.availableEligibleLensDesigns.push(lensDesign);
  },
  addLensIndex: function addLensIndex(state, lensIndex) {
    var normalisedLensIndex = normalizeLensIndex(lensIndex);
    if (normalisedLensIndex.length > 0 && state.editedCampaign.availableEligibleLensIndexes.indexOf(normalisedLensIndex) === -1) {
      state.editedCampaign.availableEligibleLensIndexes.push(normalisedLensIndex);
    }
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  },
  getEditedCampaignStartDate: function getEditedCampaignStartDate(state, getters, rootState) {
    if (!state.editedCampaign.campaignStartDate) {
      return '';
    }
    var dateString = state.editedCampaign.campaignStartDate.format('DD/MMM/YYYY hh:mm:ss a');
    return dateString;
  },
  getEditedCampaignEndDate: function getEditedCampaignEndDate(state, getters, rootState) {
    if (!state.editedCampaign.campaignEndDate) {
      return '';
    }
    var dateString = state.editedCampaign.campaignEndDate.format('DD/MMM/YYYY hh:mm:ss a');
    return dateString;
  },
  getEditedCampaignInvoiceStartDate: function getEditedCampaignInvoiceStartDate(state, getters, rootState) {
    if (!state.editedCampaign.invoiceStartDate) {
      return '';
    }
    var dateString = state.editedCampaign.invoiceStartDate.format('DD/MMM/YYYY hh:mm:ss a');
    return dateString;
  },
  getEditedCampaignInvoiceEndDate: function getEditedCampaignInvoiceEndDate(state, getters, rootState) {
    if (!state.editedCampaign.invoiceEndDate) {
      return '';
    }
    var dateString = state.editedCampaign.invoiceEndDate.format('DD/MMM/YYYY hh:mm:ss a');
    return dateString;
  }
};

var actions = {
  fetchAvailableOrderTypesFromFirestore: function fetchAvailableOrderTypesFromFirestore(context) {
    context.state.editedCampaign.availableEligibleOrderTypes = [];

    var firstQuery = context.rootState.firestoreDB.collection('orderTypes').orderBy('orderType');
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.commit('addOrderType', doc.data().orderType);
      });
    });
  },
  fetchAvailableLensDesignsFromFirestore: function fetchAvailableLensDesignsFromFirestore(context) {
    context.state.editedCampaign.availableEligibleLensDesigns = [];

    var firstQuery = context.rootState.firestoreDB.collection('lensDesigns').orderBy('lensDesign');
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.commit('addLensDesign', doc.data().lensDesign);
      });
    });
  },
  fetchAvailableLensIndexesFromFirestore: function fetchAvailableLensIndexesFromFirestore(context) {
    context.state.editedCampaign.availableEligibleLensIndexes = [];

    var firstQuery = context.rootState.firestoreDB.collection('lensIndexes').orderBy('lensIndex');
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        context.commit('addLensIndex', doc.data().lensIndex);
      });
    });
  },
  showAllCampaigns: function showAllCampaigns(context, payload) {
    context.state.all = [];


    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    var firstQuery = context.rootState.firestoreDB.collection('campaigns');
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length);
    });

    if (context.state.currentPage === 1) {
      var docQuery = context.rootState.firestoreDB.collection('campaigns').orderBy(payload.orderBys).limit(context.state.rowsPerPage);
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.id + '=>' + doc.data());
          var documentData = doc.data();
          var invoiceObject = {};
          for (var eachProp in documentData) {
            var propName = eachProp;

            if (propName === 'startDate' && doc.data()[eachProp]) {
              var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'endDate' && doc.data()[eachProp]) {
              var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'invoiceStartDate' && doc.data()[eachProp]) {
              var _m2 = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'invoiceEndDate' && doc.data()[eachProp]) {
              var _m3 = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m3.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'createdDate' && doc.data()[eachProp]) {
              var _m4 = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m4.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
              var _m5 = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m5.format('DD/MMM/YYYY hh:mm:ss a');
            } else {
              invoiceObject[propName] = doc.data()[eachProp];
            }
          }
          invoiceObject['_showDetails'] = false;
          invoiceObject.campaignId = doc.id;
          invoiceObject._rowVariant = '';
          context.state.all.push(invoiceObject);
        });
        context.commit('toggleShowLoadingAnimation', false);
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true);
        }
      }).catch(function (err) {
        console.log('Error while fetching documents in campaigns collection: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    } else {
      var lastRowShown = void 0;
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage;
      } else {
        lastRowShown = (context.state.currentPage - 1) * context.state.rowsPerPage;
      }
      console.log('lastRowShown: ' + lastRowShown);
      var _docQuery = context.rootState.firestoreDB.collection('campaigns').orderBy(payload.orderBys);
      _docQuery.get().then(function (querySnapshot) {
        var lastVisibleSnapshot = querySnapshot.docs[lastRowShown];

        var docSubQuery = context.rootState.firestoreDB.collection('campaigns').orderBy(payload.orderBys).startAt(lastVisibleSnapshot).limit(context.state.rowsPerPage);
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            var documentData = subDoc.data();
            var invoiceObject = {};
            for (var eachProp in documentData) {
              var propName = eachProp;

              if (propName === 'startDate' && subDoc.data()[eachProp]) {
                var m = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'endDate' && subDoc.data()[eachProp]) {
                var _m6 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m6.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'invoiceStartDate' && subDoc.data()[eachProp]) {
                var _m7 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m7.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'invoiceEndDate' && subDoc.data()[eachProp]) {
                var _m8 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m8.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'createdDate' && subDoc.data()[eachProp]) {
                var _m9 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m9.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
                var _m10 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m10.format('DD/MMM/YYYY hh:mm:ss a');
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp];
              }
            }
            invoiceObject['_showDetails'] = false;
            invoiceObject.campaignId = subDoc.id;
            invoiceObject._rowVariant = '';
            context.state.all.push(invoiceObject);
          });
          context.commit('toggleShowLoadingAnimation', false);
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true);
          }
        });
      }).catch(function (err) {
        console.log('Error while fetching documents in campaigns collection: ' + err);

        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    }
  },
  updateCampaignStatus: function updateCampaignStatus(context, payload) {
    if (!payload.newStatus || payload.newStatus.length === 0) {
      console.error('status cannot be empty');
      return;
    }
    context.commit('toggleShowUpdatingStatusModal', true);
    console.log('Update campaign: ' + payload.campaignId + ' status to: ' + payload.newStatus);

    if (payload.newStatus === 'ACTIVE' || payload.newStatus === 'DEMO_ACTIVE') {
      console.log('Adding counters to realtime db');
      var campaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId);
      campaignRef.once('value').then(function (snapshot) {
        console.log('snapshot.val():' + snapshot.val());
        if (snapshot.val() == null) {
          console.log('Adding new campaign to realtime db...');
          var notesPool = [];
          if (payload.notesPool) {
            for (var i = 0; i < payload.notesPool.length; i++) {
              var note = payload.notesPool[i];
              notesPool.push(normaliseReward(note, i));
            }
          }
          campaignRef.set({
            campaignId: payload.campaignId,
            totalPrizeMoney: calculateRewardTotal(notesPool),
            claimedPrizeMoney: 0,
            notesPool: notesPool
          }).catch(function (err) {
            console.error('Error while creating realtime campaign: ' + err);
          });
        } else {
          console.log('already have campaign data in realtime db, not creating another...');
        }
      });
    }

    var docRef = context.rootState.firestoreDB.collection('campaigns').doc(payload.campaignId);
    docRef.update({
      status: payload.newStatus,
      updatedBy: 'admin',
      updatedDate: new Date()
    }).then(function () {
      context.commit('toggleShowChangeStatusModal', false);
      context.commit('toggleShowUpdatingStatusModal', false);
      context.commit('toggleshowUpdateSuccessModal', true);
      context.dispatch('showAllCampaigns', { orderBys: 'createdDate' });
    }).catch(function (err) {
      console.log('Error while updating campaign status: ' + err);
      context.commit('setLoadingErrorMessage', err && err.message ? err.message : 'Update failed');
      context.commit('toggleShowUpdatingStatusModal', false);
      context.commit('toggleShowUpdateFailModal', true);
    });
  },
  fetchEditedCampaignLiveRewards: function fetchEditedCampaignLiveRewards(context, payload) {
    if (!payload || !payload.campaignId) {
      return;
    }
    var campaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId);
    campaignRef.once('value').then(function (snapshot) {
      var liveCampaign = snapshot.val();
      if (liveCampaign && liveCampaign.notesPool) {
        context.commit('updateEditedCampaignRewards', liveCampaign.notesPool);
      }
    }).catch(function (err) {
      console.log('Error while fetching live rewards for campaign edit: ' + err);
    });
  },
  updateCampaign: function updateCampaign(context, payload) {
    context.commit('toggleShowUpdatingStatusModal', true);
    console.log('Update campaign, name: ' + context.state.editedCampaign.name + ' description:' + context.state.editedCampaign.description + ' start date:' + context.state.editedCampaign.campaignStartDate.format('DD/MMM/YYYY hh:mm:ss a') + ' end date:' + context.state.editedCampaign.campaignEndDate.format('DD/MMM/YYYY hh:mm:ss a') + ' invoice start date:' + context.state.editedCampaign.invoiceStartDate.format('DD/MMM/YYYY hh:mm:ss a') + ' invoice end data:' + context.state.editedCampaign.invoiceEndDate.format('DD/MMM/YYYY hh:mm:ss a') + ' minimum price:' + context.state.editedCampaign.minimumInvoicePerPiece + ' id: ' + payload.campaignId);
    console.log('Update campaign, name: ' + context.state.editedCampaign.name + ' new eligible order types: ' + context.state.editedCampaign.eligibleOrderTypes + ' new eligible lens designs: ' + context.state.editedCampaign.eligibleLensDesigns + ' new eligible lens indexes: ' + context.state.editedCampaign.eligibleLensIndexes);

    var docRef = context.rootState.firestoreDB.collection('campaigns').doc(payload.campaignId);
    var campaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId);
    var notesPool = normaliseRewards(context.state.editedCampaign.notesPool);
    var totalPrizeMoney = calculateRewardTotal(notesPool);
    var liveCampaignData = null;

    uploadEditedCampaignBanner(context).then(function (bannerInfo) {
      return campaignRef.once('value').then(function (snapshot) {
        liveCampaignData = snapshot.val();
        var validationMessage = validateRewards(notesPool, liveCampaignData ? liveCampaignData.notesPool : null);
        if (validationMessage) {
          throw new Error(validationMessage);
        }
        return bannerInfo;
      });
    }).then(function (bannerInfo) {
      return context.rootState.firestoreDB.runTransaction(function (transaction) {
        return transaction.get(docRef).then(function (doc) {
          if (doc && doc.exists) {
            transaction.update(docRef, {
              name: context.state.editedCampaign.name,
              description: context.state.editedCampaign.description,
              campaignImageUrl: bannerInfo.campaignImageUrl,
              campaignImageStoragePath: bannerInfo.campaignImageStoragePath,
              startDate: context.state.editedCampaign.campaignStartDate.toDate(),
              endDate: context.state.editedCampaign.campaignEndDate.toDate(),
              invoiceStartDate: context.state.editedCampaign.invoiceStartDate.toDate(),
              invoiceEndDate: context.state.editedCampaign.invoiceEndDate.toDate(),
              minimumPrice: context.state.editedCampaign.minimumInvoicePerPiece,
              orderTypes: context.state.editedCampaign.eligibleOrderTypes,
              lensDesigns: context.state.editedCampaign.eligibleLensDesigns,
              lensIndexes: normalizeLensIndexes(context.state.editedCampaign.eligibleLensIndexes),
              notesPool: notesPool,
              totalPrizeMoney: totalPrizeMoney,
              demo: context.state.editedCampaign.editedIsDemoAccount
            });
          }
        });
      });
    }).then(function () {
      if (liveCampaignData) {
        return campaignRef.update({
          notesPool: notesPool,
          totalPrizeMoney: totalPrizeMoney
        });
      }
    }).then(function () {
      console.log('campaign updated');
      context.dispatch('showAllCampaigns', { orderBys: 'createdDate' });
      context.commit('toggleShowChangeStatusModal', false);
      context.commit('toggleShowUpdatingStatusModal', false);
      context.commit('toggleshowUpdateSuccessModal', true);
      context.commit('toggleShowEditCampaignModal', false);
    }).catch(function (err) {
      console.log('Error while updating campaign: ' + err);
      context.commit('setLoadingErrorMessage', err && err.message ? err.message : 'Update failed');
      context.commit('toggleShowUpdatingStatusModal', false);
      context.commit('toggleShowUpdateFailModal', true);
      context.commit('toggleShowEditCampaignModal', false);
    });
  },
  showCampaignMoneyPool: function showCampaignMoneyPool(context, payload) {
    if (context.state.realtimeCampaignRef) {
      context.state.realtimeCampaignRef.off();
    }

    state.campaignMoneyPool.claimedPrizeMoney = 0;
    state.campaignMoneyPool.totalPrizeMoney = 0;
    state.campaignMoneyPool.notesPool = [];

    context.state.realtimeCampaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId);
    context.state.realtimeCampaignRef.on('value', function (snapshot) {
      if (snapshot && snapshot.val()) {
        context.commit('updateLiveCampaignObject', snapshot.val());
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);
var firestoretable = __webpack_require__(129);
var state = {
  all: [],
  headers: [{ key: 'createdDate', label: 'Created Date' }, { key: 'claimEmail', label: 'Customer Email' }, { key: 'accountNumber', label: 'Account No.' }, { key: 'companyName', label: 'Company' }, { key: 'campaignDocId', label: 'Campaign ID' }, { key: 'claimMode', label: 'Claim Mode' }, { key: 'status', label: 'Status' }, { key: 'rewardSummary', label: 'Reward' }, { key: 'rewardType', label: 'Reward Type' }, { key: 'totalReward', label: 'Money Value' }, { key: 'invoiceSummary', label: 'Invoice(s)' }, { key: 'requestedClaimSubtypes', label: 'Requested Qty' }, { key: 'pairingClaimSubtypes', label: 'Pairing Qty' }, { key: 'remainingDrawTimes', label: 'Draws Left' }, { key: 'drawRecords', label: 'Draw Records' }, { key: 'updatedDate', label: 'Updated Date' }],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  calculatedObjects: [],
  calculatedTotalClaimedPrizeMoney: 0,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
};

function normaliseRewardDetails(claimData) {
  var rewardDetails = {
    moneyTotal: 0,
    labels: [],
    nonMoneyLabels: [],
    types: []
  };

  if (claimData.drawRecords && claimData.drawRecords.length > 0) {
    claimData.drawRecords.forEach(function (drawRecord) {
      var rewardValue = Number(drawRecord.rewardValue || drawRecord.reward || 0);
      var rewardType = (drawRecord.rewardType || (rewardValue > 0 ? 'MONEY' : 'VOUCHER')).toUpperCase();
      var rewardLabel = drawRecord.rewardLabel || (rewardValue > 0 ? 'RM ' + rewardValue : 'Reward');

      if (rewardType === 'MONEY') {
        rewardDetails.moneyTotal += rewardValue;
      } else {
        rewardDetails.nonMoneyLabels.push(rewardLabel);
      }
      rewardDetails.labels.push(rewardLabel);
      if (rewardDetails.types.indexOf(rewardType) === -1) {
        rewardDetails.types.push(rewardType);
      }
    });
  } else {
    var rewardValue = Number(claimData.prizeMoney != null && claimData.prizeMoney !== '' ? claimData.prizeMoney : claimData.totalReward);
    var rewardType = rewardValue > 0 ? 'MONEY' : claimData.rewardType || 'VOUCHER';
    rewardDetails.moneyTotal = rewardType === 'MONEY' ? rewardValue : 0;
    rewardDetails.labels.push(claimData.rewardSummary || (rewardValue > 0 ? 'RM ' + rewardValue : 'Reward'));
    if (rewardType !== 'MONEY') {
      rewardDetails.nonMoneyLabels.push(claimData.rewardSummary || 'Reward');
    }
    rewardDetails.types.push(rewardType);
  }

  rewardDetails.summary = rewardDetails.labels.join(', ');
  rewardDetails.nonMoneySummary = rewardDetails.nonMoneyLabels.join(', ');
  rewardDetails.typeSummary = rewardDetails.types.join(', ');
  return rewardDetails;
}

function formatDrawRecords(drawRecords) {
  var drawRecordsString = '';
  drawRecords.forEach(function (drawRecord) {
    if (drawRecordsString.length > 0) {
      drawRecordsString += ',';
    }
    var drawDate = moment(dateutils.toJsDate(drawRecord.drawDate));
    var rewardValue = Number(drawRecord.rewardValue || drawRecord.reward || 0);
    var rewardLabel = drawRecord.rewardLabel || (rewardValue > 0 ? 'RM ' + rewardValue : 'Reward');
    var rewardType = drawRecord.rewardType || (rewardValue > 0 ? 'MONEY' : 'VOUCHER');
    drawRecordsString += '[drawTimes=' + drawRecord.drawTimes + ', reward=' + rewardLabel + ', type=' + rewardType + ', drawDate=' + drawDate.format('DD/MMM/YYYY hh:mm:ss a') + ']';
  });
  return drawRecordsString;
}

function formatClaimSubtypes(subtypes) {
  if (!Array.isArray(subtypes) || subtypes.length === 0) {
    return '-';
  }

  return subtypes.map(function (eachType) {
    var quantity = Number(eachType.claimQuantity || 0);
    return 'Subtype: ' + (eachType.docId || eachType.subTypeDocId || '-') + '\nLenses: ' + quantity;
  }).join(', ');
}

function getPairingClaimSubtypes(claimData) {
  return claimData.pairingClaimSubtypes || claimData.pairedClaimSubtypes || [];
}

function decorateClaimRow(rowObject, claimData) {
  var requestedTaxInvoice = claimData.requestedTaxInvoice || '';
  var pairingTaxInvoice = claimData.pairingTaxInvoice || claimData.pairedTaxInvoice || '';
  var isPaired = claimData.paired === true || pairingTaxInvoice.length > 0;

  rowObject.claimMode = isPaired ? 'Paired claim' : 'Single invoice';
  rowObject.invoiceSummary = isPaired ? requestedTaxInvoice + ' + ' + pairingTaxInvoice : requestedTaxInvoice;
  rowObject.pairingTaxInvoice = pairingTaxInvoice;
  rowObject.pairedTaxInvoice = pairingTaxInvoice;
  rowObject.requestedClaimSubtypes = formatClaimSubtypes(claimData.requestedClaimSubtypes);
  rowObject.pairingClaimSubtypes = formatClaimSubtypes(getPairingClaimSubtypes(claimData));
  rowObject.pairedClaimSubtypes = rowObject.pairingClaimSubtypes;
}

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
    console.log('total rows: ' + state.totalRows);
  },
  selectTableRow: function selectTableRow(state, docId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info';
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
    console.log('show loading animation: ' + show);
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  toggleDisabledPagination: function toggleDisabledPagination(state, show) {
    state.disabledPagination = show;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      if (typeof eachHeader === 'string') {
        extraHeaders.push({
          key: eachHeader,
          sortable: true
        });
      } else {
        extraHeaders.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ sortable: true }, eachHeader));
      }
    }
    return extraHeaders;
  }
};

var actions = {
  showAllClaims: function showAllClaims(context, payload) {
    context.state.all = [];

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.commit('toggleDisabledPagination', true);

    var queryParameters = {
      collectionName: 'claims',
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'asc',
      orderByFlippedDirection: 'desc'
    };

    var docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters);

    docQuery.get().then(function (querySnapshot) {
      var index = 0;
      var jumpIndex = 0;
      var docIndex = 0;
      querySnapshot.forEach(function (doc) {
        docIndex++;
        if (queryParameters.jumpedPage && jumpIndex < queryParameters.jumpedLimit - context.state.rowsPerPage) {
          jumpIndex++;
          return;
        }
        if (index === 0) {
          context.state.lastShown.firstRowShown = doc;
        }
        index++;

        var documentData = doc.data();
        var rowObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'createdDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            rowObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            rowObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'requestedClaimSubtypes' || propName === 'pairedClaimSubtypes' || propName === 'pairingClaimSubtypes') {
            rowObject[propName] = formatClaimSubtypes(doc.data()[eachProp]);
          } else if (propName === 'drawRecords') {
            rowObject[propName] = formatDrawRecords(doc.data()[eachProp]);
          } else {
            rowObject[propName] = doc.data()[eachProp];
          }
        }
        var rewardDetails = normaliseRewardDetails(documentData);
        rowObject.totalReward = rewardDetails.moneyTotal;
        rowObject.rewardSummary = rewardDetails.summary;
        rowObject.rewardType = rewardDetails.typeSummary;
        decorateClaimRow(rowObject, documentData);

        context.rootState.firestoreDB.collection('users').doc(rowObject.claimEmail).get().then(function (userdoc) {
          if (userdoc.exists) {
            rowObject.accountNumber = userdoc.data().accountNumber;
            rowObject.companyName = userdoc.data().companyName;
          }
          rowObject.docId = doc.id;
          rowObject._rowVariant = '';
          console.log('flippedSorting: ' + queryParameters.flippedSorting);
          if (queryParameters.flippedSorting === true) {
            queryParameters.flippedResult.push(rowObject);
          } else {
            context.state.all.push(rowObject);
          }
          context.state.lastShown.lastShownPage = context.state.currentPage;
          context.state.lastShown.lastRowShown = doc;
          context.commit('toggleDisabledPagination', false);

          console.log('docIndex: ' + docIndex);
          console.log('querySnapshot.size: ' + querySnapshot.size);
          if (queryParameters.flippedResult.length === querySnapshot.size) {
            if (queryParameters.flippedSorting === true) {
              queryParameters.flippedResult.reverse();
              queryParameters.flippedResult.forEach(function (value) {
                context.state.all.push(value);
              });
              var tempHolder = context.state.lastShown.firstRowShown;
              context.state.lastShown.firstRowShown = context.state.lastShown.lastRowShown;
              context.state.lastShown.lastRowShown = tempHolder;
            }
          }
        }).catch(function (err) {
          console.error(err);
          context.commit('toggleDisabledPagination', false);
        });
      });

      context.commit('toggleShowLoadingAnimation', false);
      if (querySnapshot.size === 0) {
        context.commit('toggleShowNoResult', true);
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in claims collection: ' + err);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      context.commit('toggleDisabledPagination', false);
    });

    context.rootState.realtimeDb.ref('claims').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount));
      } else {
        var firstQuery = context.rootState.firestoreDB.collection('claims');
        firstQuery.get().then(function (querySnapshot) {
          context.commit('updateTotalRows', querySnapshot.docs.length);
        });
      }
    });
  },

  filterTable: function filterTable(context, payload) {
    if (!payload) {
      return;
    }
    var haveFilter = false;
    for (var i in payload) {
      if (payload[i] && payload[i].length > 0) {
        haveFilter = true;
      }
    }
    if (!haveFilter) {
      return;
    }

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.state.all = [];
    context.state.detailAll = [];
    context.commit('updateTotalRows', 0);

    var docQuery = context.rootState.firestoreDB.collection('claims');
    for (var _i in payload) {
      if (payload[_i] && payload[_i].length > 0) {
        docQuery = docQuery.where(_i, '==', payload[_i]);
      }
    }

    if (!docQuery) {
      return;
    }

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size);
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();
        var invoiceObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'orderDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = m.format('DD/MMM/YYYY');
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            var _m2 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m3 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m3.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'requestedClaimSubtypes' || propName === 'pairedClaimSubtypes' || propName === 'pairingClaimSubtypes') {
            invoiceObject[propName] = formatClaimSubtypes(doc.data()[eachProp]);
          } else if (propName === 'drawRecords') {
            invoiceObject[propName] = formatDrawRecords(doc.data()[eachProp]);
          } else {
            invoiceObject[propName] = doc.data()[eachProp];
          }
        }
        var rewardDetails = normaliseRewardDetails(documentData);
        invoiceObject.totalReward = rewardDetails.moneyTotal;
        invoiceObject.rewardSummary = rewardDetails.summary;
        invoiceObject.rewardType = rewardDetails.typeSummary;
        decorateClaimRow(invoiceObject, documentData);

        context.rootState.firestoreDB.collection('users').doc(invoiceObject.claimEmail).get().then(function (userdoc) {
          if (userdoc.exists) {
            invoiceObject.accountNumber = userdoc.data().accountNumber;
            invoiceObject.companyName = userdoc.data().companyName;
          }
          invoiceObject.docId = doc.id;
          invoiceObject._rowVariant = '';
          context.state.all.push(invoiceObject);
        }).catch(function (err) {
          console.error(err);
          invoiceObject.docId = doc.id;
          invoiceObject._rowVariant = '';
          context.state.all.push(invoiceObject);
        });
      });
      context.commit('toggleShowLoadingAnimation', false);
      if (querySnapshot.size === 0) {
        context.commit('toggleShowNoResult', true);
      }
    }).catch(function (err) {
      console.log('Error while fetching documents: ' + err);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
    });
  },
  calculateClaims: function calculateClaims(context, payload) {
    context.state.calculatedObjects = [];
    context.state.calculatedTotalClaimedPrizeMoney = 0;
    if (!payload) {
      console.log('no payload');
      return;
    }

    if (!payload.campaignDocId && !payload.claimEmail) {
      console.log('payload empty');
      return;
    }
    var docQuery = context.rootState.firestoreDB.collection('claims');

    if (payload.campaignDocId) {
      docQuery = docQuery.where('campaignDocId', '==', payload.campaignDocId);
    }
    if (payload.claimEmail) {
      docQuery = docQuery.where('claimEmail', '==', payload.claimEmail);
    }

    docQuery.get().then(function (querySnapshot) {
      var id = 0;

      querySnapshot.forEach(function (doc) {
        if (doc.exists && doc.data().status === 'CLAIMED') {
          var docData = doc.data();
          var rewardDetails = normaliseRewardDetails(docData);
          var claimPrizeMoney = Number(rewardDetails.moneyTotal);
          if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(claimPrizeMoney)) {
            console.warn('Invalid claim prize money for claim ' + doc.id + '. Using 0.');
            claimPrizeMoney = 0;
          }
          var nonMoneyRewardSummary = rewardDetails.nonMoneySummary;
          if (context.state.calculatedObjects.length === 0) {
            var calculatedObject = {
              id: id,
              campaignDocId: docData.campaignDocId,
              claimEmail: docData.claimEmail,
              prizeMoney: claimPrizeMoney,
              rewardSummary: nonMoneyRewardSummary
            };
            context.state.calculatedTotalClaimedPrizeMoney = Number(context.state.calculatedTotalClaimedPrizeMoney) + Number(calculatedObject.prizeMoney);
            id = id + 1;
            context.state.calculatedObjects.push(calculatedObject);
          } else {
            var incremented = false;
            for (var i = 0; i < context.state.calculatedObjects.length; i++) {
              var _calculatedObject = context.state.calculatedObjects[i];
              if (_calculatedObject.campaignDocId === docData.campaignDocId && _calculatedObject.claimEmail === docData.claimEmail) {
                _calculatedObject.prizeMoney = Number(_calculatedObject.prizeMoney) + claimPrizeMoney;
                if (nonMoneyRewardSummary) {
                  _calculatedObject.rewardSummary = _calculatedObject.rewardSummary ? _calculatedObject.rewardSummary + ', ' + nonMoneyRewardSummary : nonMoneyRewardSummary;
                }
                incremented = true;
                context.state.calculatedTotalClaimedPrizeMoney = Number(context.state.calculatedTotalClaimedPrizeMoney) + claimPrizeMoney;
              }
            }
            if (!incremented) {
              var _calculatedObject2 = {
                id: id,
                campaignDocId: docData.campaignDocId,
                claimEmail: docData.claimEmail,
                prizeMoney: claimPrizeMoney,
                rewardSummary: nonMoneyRewardSummary
              };
              context.state.calculatedTotalClaimedPrizeMoney = Number(context.state.calculatedTotalClaimedPrizeMoney) + Number(_calculatedObject2.prizeMoney);
              id = id + 1;
              context.state.calculatedObjects.push(_calculatedObject2);
            }
          }
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);

function normalizeLensIndex(lensIndex) {
  if (lensIndex === undefined || lensIndex === null) {
    return '';
  }

  var value = String(lensIndex).trim();
  if (value.length === 0) {
    return '';
  }

  var numericValue = Number(value);
  return isNaN(numericValue) ? value : numericValue.toFixed(2);
}

function normalizeLensIndexes(lensIndexes) {
  var normalised = [];
  if (!lensIndexes) {
    return normalised;
  }

  for (var i = 0; i < lensIndexes.length; i++) {
    var lensIndex = normalizeLensIndex(lensIndexes[i]);
    if (lensIndex.length > 0 && normalised.indexOf(lensIndex) === -1) {
      normalised.push(lensIndex);
    }
  }
  return normalised;
}

var state = {
  all: [],
  headers: ['campaignDocId', 'requesterEmail', 'requestedTaxInvoice', 'pairingTaxInvoice', 'status', 'rejectReason', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  showApproveOrRejectModal: false,
  showUpdatingModal: false,
  showUpdateSuccessModal: false,
  showUpdateFailedModal: false,
  updateFailMessage: '',
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false
};

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  selectTableRow: function selectTableRow(state, pairId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].pairRequestsDocId === pairId) {
        state.all[i]._rowVariant = 'info';
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleshowApproveOrRejectModal: function toggleshowApproveOrRejectModal(state, show) {
    state.showApproveOrRejectModal = show;
  },
  toogleShowUpdatingModal: function toogleShowUpdatingModal(state, show) {
    state.showUpdatingModal = show;
  },
  toggleShowUpdateSuccessModal: function toggleShowUpdateSuccessModal(state, show) {
    state.showUpdateSuccessModal = show;
  },
  toogleShowUpdateFailedModal: function toogleShowUpdateFailedModal(state, show) {
    state.showUpdateFailedModal = show;
  },
  approveFailedAction: function approveFailedAction(state, err) {
    console.log('err type: ' + (typeof err === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(err)));
    if (typeof err === 'string') {
      state.updateFailMessage = err;
    } else if (err.message) {
      console.log('err message:' + err.message);
      state.updateFailMessage = err.message;
    } else {
      state.updateFailMessage = err;
    }
    state.showApproveOrRejectModal = false;
    state.showUpdatingModal = false;
    state.showUpdateFailedModal = true;
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var actions = {
  showAllPairRequests: function showAllPairRequests(context, payload) {
    context.state.all = [];

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    var firstQuery = context.rootState.firestoreDB.collection('pairRequests');
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length);
    });

    if (context.state.currentPage === 1) {
      var docQuery = context.rootState.firestoreDB.collection('pairRequests').orderBy(payload.orderBys, 'desc').limit(context.state.rowsPerPage);
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var documentData = doc.data();
          var invoiceObject = {};
          for (var eachProp in documentData) {
            var propName = eachProp;

            if (propName === 'createdDate' && doc.data()[eachProp]) {
              var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
              var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
            } else {
              invoiceObject[propName] = doc.data()[eachProp];
            }
          }
          invoiceObject.pairId = doc.id;
          invoiceObject._rowVariant = '';
          context.state.all.push(invoiceObject);
        });
        context.commit('toggleShowLoadingAnimation', false);
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true);
        }
      }).catch(function (err) {
        console.log('Error while fetching documents: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    } else {
      var lastRowShown = void 0;
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage;
      } else {
        lastRowShown = (context.state.currentPage - 1) * context.state.rowsPerPage;
      }
      console.log('lastRowShown: ' + lastRowShown);
      var _docQuery = context.rootState.firestoreDB.collection('users').orderBy(payload.orderBys);
      _docQuery.get().then(function (querySnapshot) {
        var lastVisibleSnapshot = querySnapshot.docs[lastRowShown];

        var docSubQuery = context.rootState.firestoreDB.collection('pairRequests').orderBy(payload.orderBys, 'desc').startAt(lastVisibleSnapshot).limit(context.state.rowsPerPage);
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            var documentData = subDoc.data();
            var invoiceObject = {};
            for (var eachProp in documentData) {
              var propName = eachProp;

              if (propName === 'createdDate' && subDoc.data()[eachProp]) {
                var m = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
                var _m2 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp];
              }
            }
            invoiceObject.pairId = subDoc.id;
            invoiceObject._rowVariant = '';
            context.state.all.push(invoiceObject);
          });
          context.commit('toggleShowLoadingAnimation', false);
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true);
          }
        });
      }).catch(function (err) {
        console.log('Error while fetching documents: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    }
  },

  filterTable: function filterTable(context, payload) {
    if (!payload) {
      return;
    }
    var haveFilter = false;
    for (var i in payload) {
      if (payload[i] && payload[i].length > 0) {
        haveFilter = true;
      }
    }
    if (!haveFilter) {
      return;
    }

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.state.all = [];
    context.state.detailAll = [];
    context.commit('updateTotalRows', 0);

    var docQuery = context.rootState.firestoreDB.collection('pairRequests');
    for (var _i in payload) {
      if (payload[_i] && payload[_i].length > 0) {
        docQuery = docQuery.where(_i, '==', payload[_i]);
      }
    }

    if (!docQuery) {
      return;
    }

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size);
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();
        var invoiceObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'orderDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = m.format('DD/MMM/YYYY');
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            var _m3 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m3.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m4 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m4.format('DD/MMM/YYYY hh:mm:ss a');
          } else {
            invoiceObject[propName] = doc.data()[eachProp];
          }
        }
        invoiceObject.pairId = doc.id;
        invoiceObject._rowVariant = '';
        context.state.all.push(invoiceObject);
      });
      context.commit('toggleShowLoadingAnimation', false);
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true);
      }
    }).catch(function (err) {
      console.log('Error while fetching documents: ' + err);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
    });
  },
  approveRequest: function approveRequest(context, payload) {
    context.state.updateFailMessage = '';
    if (payload && payload.pairRequestsDocId) {
      context.commit('toogleShowUpdatingModal', true);
      console.log('Approving request...');
      context.dispatch('createInvoiceLockingDataFirstCheck', payload);
    }
  },
  createInvoiceLockingDataFirstCheck: function createInvoiceLockingDataFirstCheck(context, payload) {
    console.log('Checking requester user account');
    context.rootState.firestoreDB.collection('users').doc(payload.requester).get().then(function (doc) {
      if (doc.exists) {
        var data = doc.data();
        if (data.approved === false) {
          console.error('User not approved yet, cannot approve pairing request');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('User not approved yet, cannot approve pairing request'));
        } else if (data.status !== 'ACTIVE') {
          console.error('User status is not ACTIVE yet, cannot approve pairing request');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('User status is not ACTIVE yet, cannot approve pairing request'));
        } else {
          context.dispatch('createInvoiceLockingDataSecondCheck', payload);
        }
      } else {
        console.error(payload.requester + ' does not exists, cannot approve pairing request');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(payload.requester + ' does not exists, cannot approve pairing request'));
      }
    }).catch(function (err) {
      console.error('Err:' + err);
      context.commit('approveFailedAction', err);
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
    });
  },
  createInvoiceLockingDataSecondCheck: function createInvoiceLockingDataSecondCheck(context, payload) {
    console.log('Checking campaign');
    context.rootState.firestoreDB.collection('campaigns').doc(payload.campaignId).get().then(function (doc) {
      var campaignObject = null;
      if (doc.exists) {
        var data = doc.data();
        campaignObject = {
          campaignId: data.id,
          name: data.name,
          description: data.description,
          status: data.status,
          startDate: data.startDate,
          endDate: data.endDate,
          invoiceStartDate: data.invoiceStartDate,
          invoiceEndDate: data.invoiceEndDate,
          minimumPrice: data.minimumPrice,
          lensDesigns: data.lensDesigns,
          orderTypes: data.orderTypes,
          lensIndexes: data.lensIndexes || []
        };
        if (campaignObject.status !== 'ACTIVE') {
          console.error('Campaign is not ACTIVE, cannot approve pairing request');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Campaign is not ACTIVE, cannot approve pairing request'));
        } else {
          var today = new Date();
          if (dateutils.toJsDate(campaignObject.startDate) > today) {
            console.error('Campaign has not start, cannot approve pairing request');
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Campaign has not start, cannot approve pairing request'));
          } else if (dateutils.toJsDate(campaignObject.endDate) < today) {
            console.error('Campaign has ended, cannot approve pairing request');
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Campaign has ended, cannot approve pairing request'));
          } else {
            payload.campaignObject = campaignObject;
            context.dispatch('createInvoiceLockingDataThirdCheck', payload);
          }
        }
      } else {
        console.error('Campaign does not exists, cannot approve pairing request');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Campaign does not exists, cannot approve pairing request'));
      }
    }).catch(function (err) {
      console.error('Err:' + err);
      context.commit('approveFailedAction', err);
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
    });
  },
  createInvoiceLockingDataThirdCheck: function createInvoiceLockingDataThirdCheck(context, payload) {
    context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId).once('value').then(function (snapshot) {
      if (snapshot && snapshot.val()) {
        var totalPrizeMoney = Number(snapshot.val().totalPrizeMoney);
        var claimed = Number(snapshot.val().claimedPrizeMoney);

        if (claimed >= totalPrizeMoney) {
          console.error('Campaign has no more money to claim');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Campaign has no more money to claim'));
        } else {
          context.dispatch('createClaimPlaceHolderAndProceed', payload);
        }
      }
    }).catch(function (err) {
      console.error('Err:' + err);
      context.commit('approveFailedAction', err);
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
    });
  },
  createClaimPlaceHolderAndProceed: function createClaimPlaceHolderAndProceed(context, payload) {
    console.log('Creating claim place holder');

    var claimDocPlaceHolder = { createdDate: new Date(), createdBy: 'admin' };
    context.rootState.firestoreDB.collection('claims').add(claimDocPlaceHolder).then(function (doc) {
      payload.claimsPlaceHolderId = doc.id;
      context.dispatch('fetchInvoicesSubTypesAndProceed', payload);
    }).catch(function (err) {
      console.error('Err:' + err);
      context.commit('approveFailedAction', err);
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
    });
  },
  fetchInvoicesSubTypesAndProceed: function fetchInvoicesSubTypesAndProceed(context, payload) {
    context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberOne).collection('subtypes').get().then(function (querySnapshot) {
      var invoiceOneSubtypes = [];
      querySnapshot.forEach(function (doc) {
        if (doc.exists) {
          var invoiceOneSubtype = doc.data();
          invoiceOneSubtype.id = doc.id;
          invoiceOneSubtypes.push(invoiceOneSubtype);
        }
      });
      if (invoiceOneSubtypes.length === 0) {
        console.error('No available quantity in invoice one, cannot approve pairing request');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('No available quantity in invoice one, cannot approve pairing request'));
      } else {
        context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberTwo).collection('subtypes').get().then(function (querySnapshotTwo) {
          var invoiceTwoSubtypes = [];
          querySnapshotTwo.forEach(function (doc) {
            if (doc.exists) {
              var invoiceTwoSubtype = doc.data();
              invoiceTwoSubtype.id = doc.id;
              invoiceTwoSubtypes.push(invoiceTwoSubtype);
            }
          });
          if (invoiceTwoSubtypes.length === 0) {
            console.error('No available quantity in invoice two, cannot approve pairing request');
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('No available quantity in invoice two, cannot approve pairing request'));
          } else {
            payload.invoiceOneSubtypes = invoiceOneSubtypes;
            payload.invoiceTwoSubtypes = invoiceTwoSubtypes;
            context.dispatch('createInvoiceLockingDataForthCheck', payload);
          }
        }).catch(function (err) {
          console.error('Err:' + err);
          context.commit('approveFailedAction', err);
          context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
        });
      }
    }).catch(function (err) {
      console.error('Err:' + err);
      context.commit('approveFailedAction', err);
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
    });
  },
  createInvoiceLockingDataForthCheck: function createInvoiceLockingDataForthCheck(context, payload) {
    console.log('Checking invoice one');
    var invoiceOneRef = context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberOne);
    var invoiceTwoRef = context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberTwo);

    var claimDocRef = context.rootState.firestoreDB.collection('claims').doc(payload.claimsPlaceHolderId);
    var pairRequestRef = context.rootState.firestoreDB.collection('pairRequests').doc(payload.pairRequestsDocId);

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(invoiceOneRef).then(function (doc) {
        if (doc.exists) {
          var data = doc.data();
          var invoiceOneUpdateObject = {};
          if (data.status === 'CLAIMING' && data.claimEmail !== payload.requester) {
            console.error('Other people are claiming this invoice, cannot approve pairing request');
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Other people are claiming this invoice, cannot approve pairing request'));
          } else {
            console.log('proceed to check invoice 2');
            return transaction.get(invoiceTwoRef).then(function (doc) {
              if (doc.exists) {
                var dataTwo = doc.data();
                if (dataTwo.status === 'CLAIMING' && dataTwo.claimEmail !== payload.requester) {
                  console.error('Other people are claiming this invoice, cannot approve pairing request');
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Other people are claiming this invoice, cannot approve pairing request'));
                } else {
                  if (data.status === 'NEW') {
                    console.log('Found unlock invoice one, locking it...');
                    invoiceOneUpdateObject.status = 'CLAIMING';
                    invoiceOneUpdateObject.claimEmail = payload.requester;
                  }

                  invoiceOneUpdateObject.updatedDate = new Date();
                  invoiceOneUpdateObject.updatedBy = 'admin';

                  var invoiceTwoUpdateObject = {};
                  if (dataTwo.status === 'NEW') {
                    console.log('Found unlocked invoice two, locking it...');
                    invoiceTwoUpdateObject.status = 'CLAIMING';
                    invoiceTwoUpdateObject.claimEmail = payload.requester;
                  }

                  invoiceTwoUpdateObject.updatedDate = new Date();
                  invoiceTwoUpdateObject.updatedBy = 'admin';

                  var invoiceOneAvailableSubtype = null;
                  for (var i = 0; i < payload.invoiceOneSubtypes.length; i++) {
                    var claimedQuantity = 0;
                    if (payload.invoiceOneSubtypes[i].claimedQuantity) {
                      claimedQuantity = payload.invoiceOneSubtypes[i].claimedQuantity;
                    }
                    var subTypeAvailableQuantity = 0;
                    if (Number(claimedQuantity) < Number(payload.invoiceOneSubtypes[i].quantity)) {
                      subTypeAvailableQuantity = Number(payload.invoiceOneSubtypes[i].quantity) - Number(claimedQuantity);
                    }
                    if (subTypeAvailableQuantity > 0) {
                      invoiceOneAvailableSubtype = payload.invoiceOneSubtypes[i];
                      break;
                    }
                  }
                  var invoiceTwoAvailableSubtype = null;
                  for (var _i2 = 0; _i2 < payload.invoiceTwoSubtypes.length; _i2++) {
                    var _claimedQuantity = 0;
                    if (payload.invoiceTwoSubtypes[_i2].claimedQuantity) {
                      _claimedQuantity = payload.invoiceTwoSubtypes[_i2].claimedQuantity;
                    }
                    var _subTypeAvailableQuantity = 0;
                    if (Number(_claimedQuantity) < Number(payload.invoiceTwoSubtypes[_i2].quantity)) {
                      _subTypeAvailableQuantity = Number(payload.invoiceTwoSubtypes[_i2].quantity) - Number(_claimedQuantity);
                    }
                    if (_subTypeAvailableQuantity > 0) {
                      invoiceTwoAvailableSubtype = payload.invoiceTwoSubtypes[_i2];
                      break;
                    }
                  }
                  if (invoiceOneAvailableSubtype && invoiceTwoAvailableSubtype) {
                    console.log('Both invoice subtype has enough quantity for claim');

                    var campaignLensIndexes = normalizeLensIndexes(payload.campaignObject.lensIndexes);
                    var invoiceOneLensIndex = normalizeLensIndex(invoiceOneAvailableSubtype.lensIndex);
                    var invoiceTwoLensIndex = normalizeLensIndex(invoiceTwoAvailableSubtype.lensIndex);
                    console.log('Invoice one lens pass: ' + payload.campaignObject.lensDesigns.indexOf(invoiceOneAvailableSubtype.lensDesign));
                    console.log('Invoice one order type pass: ' + payload.campaignObject.orderTypes.indexOf(invoiceOneAvailableSubtype.orderType));
                    console.log('Invoice one lens index pass: ' + campaignLensIndexes.indexOf(invoiceOneLensIndex));
                    console.log('Invoice two lens pass: ' + payload.campaignObject.lensDesigns.indexOf(invoiceTwoAvailableSubtype.lensDesign));
                    console.log('Invoice two order type pass: ' + payload.campaignObject.orderTypes.indexOf(invoiceTwoAvailableSubtype.orderType));
                    console.log('Invoice two lens index pass: ' + campaignLensIndexes.indexOf(invoiceTwoLensIndex));

                    var skipLensIndexCheck = campaignLensIndexes.length === 0;

                    if (payload.campaignObject.lensDesigns.indexOf(invoiceOneAvailableSubtype.lensDesign) !== -1 && payload.campaignObject.orderTypes.indexOf(invoiceOneAvailableSubtype.orderType) !== -1 && (skipLensIndexCheck || campaignLensIndexes.indexOf(invoiceOneLensIndex) !== -1) && payload.campaignObject.lensDesigns.indexOf(invoiceTwoAvailableSubtype.lensDesign) !== -1 && payload.campaignObject.orderTypes.indexOf(invoiceTwoAvailableSubtype.orderType) !== -1 && (skipLensIndexCheck || campaignLensIndexes.indexOf(invoiceTwoLensIndex) !== -1)) {
                      console.log('Both invoice subtype lens design, order type and lens index fulfill campaign requirement');

                      transaction.update(invoiceOneRef, invoiceOneUpdateObject);
                      transaction.update(invoiceTwoRef, invoiceTwoUpdateObject);
                      var claimObject = {
                        campaignDocId: payload.campaignId,
                        updatedDate: new Date(),
                        updatedBy: 'admin',
                        claimEmail: payload.requester,
                        taxInvoice: payload.invoiceNumberOne,
                        subtypes: [{
                          claimQuantity: 1,
                          subTypeDocId: invoiceOneAvailableSubtype.id
                        }],
                        status: 'CLAIMING',
                        paired: true,
                        taxInvoiceTwo: payload.invoiceNumberTwo,
                        subtypesTwo: [{
                          claimQuantity: 1,
                          subTypeDocId: invoiceTwoAvailableSubtype.id
                        }]
                      };
                      transaction.update(claimDocRef, claimObject);
                      transaction.update(pairRequestRef, { status: 'APPROVED' });
                    } else {
                      console.error('Invoice subtype does not meet campaign lens design, order type and lens index');
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Invoice subtype does not meet campaign lens design, order type and lens index'));
                    }
                  }
                }
              } else {
                console.error('Invoice data does not exists, cannot approve pairing request');
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Invoice data does not exists, cannot approve pairing request'));
              }
            });
          }
        } else {
          console.error('Invoice data does not exists, cannot approve pairing request');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('The invoice had been locked by other people'));
        }
      });
    }).then(function () {
      console.log('All transaction in approve request completed');
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
      context.commit('toggleshowApproveOrRejectModal', false);
      context.commit('toogleShowUpdatingModal', false);
      context.commit('toggleShowUpdateSuccessModal', true);
    }).catch(function (err) {
      console.error('Err:' + err);
      context.commit('approveFailedAction', err);
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
    });
  },
  rejectRequest: function rejectRequest(context, payload) {
    context.state.updateFailMessage = '';
    if (payload && payload.pairRequestsDocId) {
      context.commit('toogleShowUpdatingModal', true);
      console.log('Rejecting request...');
      var pairRequestRef = context.rootState.firestoreDB.collection('pairRequests').doc(payload.pairRequestsDocId);

      context.rootState.firestoreDB.runTransaction(function (transaction) {
        return transaction.get(pairRequestRef).then(function (doc) {
          if (doc && doc.exists) {
            transaction.update(pairRequestRef, {
              status: 'REJECT',
              rejectReason: payload.rejectReason
            });
          }
        });
      }).then(function () {
        console.log('REquest rejected');
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
        context.commit('toggleshowApproveOrRejectModal', false);
        context.commit('toogleShowUpdatingModal', false);
        context.commit('toggleShowUpdateSuccessModal', true);
      }).catch(function (err) {
        console.error('Err:' + err);
        context.commit('approveFailedAction', err);
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);
var firestoretable = __webpack_require__(129);
var state = {
  all: [],
  headers: ['customerAccount', 'name'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  showCreateModal: false,
  showSearchModal: false,
  newCustomer: {
    customerAccount: '',
    name: '',
    error: ''
  },
  searchCustomer: {
    customerAccount: '',
    name: ''
  },
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  selectTableRow: function selectTableRow(state, docId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info';
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowCreateModal: function toggleShowCreateModal(state, show) {
    state.showCreateModal = show;
  },
  setNewCustomerAccount: function setNewCustomerAccount(state, customerAccount) {
    state.newCustomer.customerAccount = customerAccount;
  },
  setNewCustomerName: function setNewCustomerName(state, name) {
    state.newCustomer.name = name;
  },
  setNewCustomerError: function setNewCustomerError(state, error) {
    state.newCustomer.error = error;
  },
  toggleShowSearchModal: function toggleShowSearchModal(state, show) {
    state.showSearchModal = show;
  },
  setSearchCustomerAccount: function setSearchCustomerAccount(state, customerAccount) {
    state.searchCustomer.customerAccount = customerAccount;
  },
  setSearchCustomerName: function setSearchCustomerName(state, name) {
    state.searchCustomer.name = name;
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  toggleDisabledPagination: function toggleDisabledPagination(state, show) {
    state.disabledPagination = show;
  }
};

var actions = {
  showAllCustomerAccounts: function showAllCustomerAccounts(context, payload) {
    context.state.all = [];

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.commit('toggleDisabledPagination', true);

    var queryParameters = {
      collectionName: 'customerAccounts',
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: 'customerAccount',
      orderByDirection: 'asc',
      orderByFlippedDirection: 'desc'
    };

    var docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters);

    firestoretable.queryCollection(docQuery, context, queryParameters, false);

    context.rootState.realtimeDb.ref('customerAccounts').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount));
      } else {
        var firstQuery = context.rootState.firestoreDB.collection('customerAccounts');
        firstQuery.get().then(function (querySnapshot) {
          context.commit('updateTotalRows', querySnapshot.docs.length);
        });
      }
    });
  },
  addCustomerAccount: function addCustomerAccount(context, payload) {
    console.log('customerAccount: ' + context.state.newCustomer.customerAccount);
    console.log('name: ' + context.state.newCustomer.name);

    context.commit('setNewCustomerError', '');

    if (context.state.newCustomer.customerAccount) {
      if (context.state.newCustomer.customerAccount.length !== 6) {
        context.commit('setNewCustomerError', 'Customer account must be 6 digits long');
      } else {
        context.commit('setNewCustomerError', '');

        context.rootState.firestoreDB.collection('customerAccounts').where('customerAccount', '==', context.state.newCustomer.customerAccount).get().then(function (querySnapshot) {
          if (querySnapshot.size === 0) {
            context.rootState.firestoreDB.collection('customerAccounts').add({
              customerAccount: context.state.newCustomer.customerAccount,
              name: context.state.newCustomer.name
            }).then(function (doc) {
              console.log('Customer account added');
              context.commit('toggleShowCreateModal', false);
            }).catch(function (err) {
              console.error(err);
              context.commit('setNewCustomerError', err);
            });
          } else {
            context.commit('setNewCustomerError', 'Customer account already exist');
          }
        }).catch(function (err) {
          console.error(err);
          context.commit('setNewCustomerError', err);
        });
      }
    }
  },
  searchCustomer: function searchCustomer(context, payload) {
    console.log('search customer account: ' + context.state.searchCustomer.customerAccount);
    console.log('search customer name: ' + context.state.searchCustomer.name);

    if (!context.state.searchCustomer.name && !context.state.searchCustomer.customerAccount) {
      return;
    }

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.state.all = [];
    context.state.detailAll = [];
    context.commit('updateTotalRows', 0);

    var docQuery = context.rootState.firestoreDB.collection('customerAccounts');
    if (context.state.searchCustomer.customerAccount && context.state.searchCustomer.customerAccount.length > 0) {
      docQuery = docQuery.where('customerAccount', '==', context.state.searchCustomer.customerAccount);
    }
    if (context.state.searchCustomer.name && context.state.searchCustomer.name.length > 0) {
      docQuery = docQuery.where('name', '==', context.state.searchCustomer.name);
    }

    if (!docQuery) {
      return;
    }

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size);
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();
        var invoiceObject = {};
        for (var eachProp in documentData) {
          var propName = eachProp;

          if (propName === 'orderDate' && doc.data()[eachProp]) {
            var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = m.format('DD/MMM/YYYY');
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            var _m2 = moment(dateutils.toJsDate(doc.data()[eachProp]));
            invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
          } else {
            invoiceObject[propName] = doc.data()[eachProp];
          }
        }
        invoiceObject.id = doc.id;
        invoiceObject._rowVariant = '';
        context.state.all.push(invoiceObject);
      });
      context.commit('toggleShowSearchModal', false);
      context.commit('toggleShowLoadingAnimation', false);
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true);
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in invoice collection: ' + err);
      context.commit('toggleShowSearchModal', false);
      context.commit('toggleShowLoadingAnimation', false);

      context.commit('toggleshowLoadingError', true);
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var firestoretable = __webpack_require__(129);

var state = {
  uploadedCustomerAccountsCollectionName: 'customerAccountUploads',
  uploadFolderPath: 'customeraccountuploads/',
  uploadFileName: '',
  uploadProgress: '',
  showUploadingModal: false,
  showUploadingSuccessModal: false,
  showUploadingFailedModal: false,
  showImportingModal: false,
  showImportingSuccessModal: false,
  showImportingFailedModal: false,
  importFailedMessage: '',
  uploadFailedMessage: '',
  all: [],
  headers: ['fileName', 'uploadedDate', 'status'],
  rowsPerPage: 20,
  currentPage: 1,
  totalRows: 0,
  showLoadingAnimation: false,
  showLoadingError: false,
  showNoResult: false,
  loadingErrorMessage: '',
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
};

var mutations = {
  toggleUploadingModal: function toggleUploadingModal(state, show) {
    state.showUploadingModal = show;
  },
  toggleUploadingSuccessModal: function toggleUploadingSuccessModal(state, show) {
    state.showUploadingSuccessModal = show;
  },
  toggleUploadingFailedModal: function toggleUploadingFailedModal(state, show) {
    state.showUploadingFailedModal = show;
  },
  setUploadFailedMessage: function setUploadFailedMessage(state, message) {
    state.uploadFailedMessage = message;
  },
  toggleImportingModal: function toggleImportingModal(state, show) {
    state.showImportingModal = show;
  },
  toggleImportingSuccessModal: function toggleImportingSuccessModal(state, show) {
    state.showImportingSuccessModal = show;
  },
  toggleImportingFailedModal: function toggleImportingFailedModal(state, show) {
    state.showImportingFailedModal = show;
  },
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  selectTableRow: function selectTableRow(state, docId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info';
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  toggleDisabledPagination: function toggleDisabledPagination(state, show) {
    state.disabledPagination = show;
  }
};

var getters = {
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var actions = {
  uploadFileToFirebaseStorage: function uploadFileToFirebaseStorage(context, payload) {
    if (!payload.file) {
      console.log('Nothing to upload');
      context.commit('setUploadFailedMessage', 'Please select an Excel file to upload.');
      context.commit('toggleUploadingFailedModal', true);
      return;
    }

    var firebaseStorageRef = context.rootState.fbStorage.ref();
    context.commit('toggleUploadingModal', true);

    var uploadTask = firebaseStorageRef.child(context.state.uploadFolderPath + payload.file.name).put(payload.file);
    uploadTask.on('state_changed', function (snapshot) {
      context.state.uploadProgress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
    }, function (error) {
      context.commit('toggleUploadingModal', false);
      context.commit('toggleUploadingFailedModal', true);
      console.error(error);
    }, function () {
      var objToAdd = {
        fileName: payload.file.name,
        uploadedDate: new Date(),
        status: 'NEW'
      };

      context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).add(objToAdd).then(function () {
        context.commit('toggleUploadingModal', false);
        context.commit('toggleUploadingSuccessModal', true);
        context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
      }).catch(function (err) {
        console.error(err);
        context.commit('toggleUploadingModal', false);
        context.commit('toggleUploadingFailedModal', true);
      });
    });
  },
  showAllUploads: function showAllUploads(context, payload) {
    context.state.all = [];

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);
    context.commit('toggleDisabledPagination', true);

    var queryParameters = {
      collectionName: context.state.uploadedCustomerAccountsCollectionName,
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'desc',
      orderByFlippedDirection: 'asc'
    };

    var docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters);
    firestoretable.queryCollection(docQuery, context, queryParameters, false);

    context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length);
    });
  },
  importFile: function importFile(context, payload) {
    context.commit('toggleImportingModal', true);
    context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).where('status', '==', 'IMPORTING').get().then(function (querySnapshot) {
      if (querySnapshot.size === 0) {
        var docRef = context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).doc(payload.docId);
        docRef.update({ status: 'IMPORTING' }).then(function () {
          context.dispatch('executeImport', payload);
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
        context.commit('toggleImportingModal', false);
      }
    });
  },
  executeImport: function executeImport(context, payload) {
    var currentUser = context.rootState.firebase.auth().currentUser;
    if (!currentUser) {
      context.commit('toggleImportingModal', false);
      context.state.importFailedMessage = 'Please login again before importing.';
      context.commit('toggleImportingFailedModal', true);
      return;
    }

    currentUser.getIdToken(true).then(function (idToken) {
      var projectId = context.rootState.firebase.app().options.projectId;
      var cloudFunctionImportUrl = 'https://asia-southeast1-' + projectId + '.cloudfunctions.net/importCustomerAccountsFromStorage';
      console.log('Customer account import function URL: ' + cloudFunctionImportUrl);
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          context.commit('toggleImportingModal', false);
          if (xmlHttp.status === 200) {
            context.commit('toggleImportingSuccessModal', true);
            context.dispatch('updateFileStatus', { docId: payload.docId, status: 'IMPORTED' });
            console.log('Customer account import result: ' + xmlHttp.responseText);
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
          } else {
            context.state.importFailedMessage = xmlHttp.responseText;
            context.dispatch('updateFileStatus', { docId: payload.docId, status: 'NEW' });
            context.commit('toggleImportingFailedModal', true);
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
          }
        }
      };
      xmlHttp.open('POST', cloudFunctionImportUrl, true);
      xmlHttp.setRequestHeader('Content-Type', 'application/json');
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + idToken);
      xmlHttp.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        filename: payload.filename,
        status: payload.status
      }));
    }).catch(function (err) {
      context.commit('toggleImportingModal', false);
      context.state.importFailedMessage = err.message;
      context.commit('toggleImportingFailedModal', true);
    });
  },
  updateFileStatus: function updateFileStatus(context, payload) {
    var docRef = context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).doc(payload.docId);
    docRef.update({ status: payload.status }).catch(function (err) {
      console.error(err);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  totalPieces: '',
  totalAmount: '',
  groupedByMoneyTypeClaims: []
};

var mutations = {};

var getters = {};

var actions = {
  fetchUserClaims: function fetchUserClaims(context, payload) {
    console.log('Fetching claims for email: ' + payload.email);
    if (!payload.email) {
      return;
    }
    context.state.groupedByMoneyTypeClaims = [];
    context.state.totalPieces = '';
    context.state.totalAmount = '';

    var calculatedTotalPieces = 0;
    var calculatedTotalAmount = 0;

    context.rootState.firestoreDB.collection('claims').where('claimEmail', '==', payload.email).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var documentData = doc.data();

        var _loop = function _loop(eachProp) {
          var propName = eachProp;
          if (propName === 'prizeMoney') {
            var incremented = false;
            context.state.groupedByMoneyTypeClaims.forEach(function (groupedByMoneyTypeClaim) {
              if (groupedByMoneyTypeClaim.moneyType === doc.data()[propName]) {
                groupedByMoneyTypeClaim.pieces = groupedByMoneyTypeClaim.pieces + 1;
                groupedByMoneyTypeClaim.totalAmount = parseInt(groupedByMoneyTypeClaim.totalAmount) + parseInt(doc.data()[propName]);

                incremented = true;
              }
            });
            if (!incremented) {
              var groupedByMoneyTypeClaim = {
                moneyType: doc.data()[propName],
                pieces: 1,
                totalAmount: parseInt(doc.data()[propName])
              };
              context.state.groupedByMoneyTypeClaims.push(groupedByMoneyTypeClaim);
            }
          }
        };

        for (var eachProp in documentData) {
          _loop(eachProp);
        }
      });

      context.state.groupedByMoneyTypeClaims.sort(function (firstParam, secondParam) {
        if (Number(firstParam.moneyType) < Number(secondParam.moneyType)) {
          return -1;
        } else if (Number(firstParam.moneyType) > Number(secondParam.moneyType)) {
          return 1;
        }
        return 0;
      });

      context.state.groupedByMoneyTypeClaims.forEach(function (groupedByMoneyTypeClaim) {
        calculatedTotalPieces += groupedByMoneyTypeClaim.pieces;
        calculatedTotalAmount += groupedByMoneyTypeClaim.totalAmount;
      });

      if (calculatedTotalPieces > 0) {
        context.state.totalPieces = calculatedTotalPieces;
      }
      if (calculatedTotalAmount > 0) {
        context.state.totalAmount = calculatedTotalAmount;
      }
    }).catch(function (err) {
      console.error(err);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var firestoretable = __webpack_require__(129);

var state = {
  uploadedInvoicesCollectionName: 'uploadedInvoices',
  uploadFolderPath: 'invoiceuploads/',
  uploadFileName: '',
  uploadProgress: '',
  showUploadingModal: false,
  showUploadingSuccessModal: false,
  showUploadingFailedModal: false,
  showImportingModal: false,
  showImportingSuccessModal: false,
  showImportingFailedModal: false,
  importFailedMessage: '',
  all: [],
  headers: ['fileName', 'uploadedDate', 'status'],
  rowsPerPage: 20,
  currentPage: 1,
  totalRows: 0,
  showLoadingAnimation: false,
  showLoadingError: false,
  showNoResult: false,
  loadingErrorMessage: '',
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
};

var mutations = {
  toggleUploadingModal: function toggleUploadingModal(state, show) {
    state.showUploadingModal = show;
  },
  toggleUploadingSuccessModal: function toggleUploadingSuccessModal(state, show) {
    state.showUploadingSuccessModal = show;
  },
  toggleUploadingFailedModal: function toggleUploadingFailedModal(state, show) {
    state.showUploadingFailedModal = show;
  },
  toggleImportingModal: function toggleImportingModal(state, show) {
    state.showImportingModal = show;
  },
  toggleImportingSuccessModal: function toggleImportingSuccessModal(state, show) {
    state.showImportingSuccessModal = show;
  },
  toggleImportingFailedModal: function toggleImportingFailedModal(state, show) {
    state.showImportingFailedModal = show;
  },
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
    console.log('CHanged state page number to: ' + state.currentPage);
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
    console.log('Mutated totalRows to: ' + state.totalRows);
  },
  selectTableRow: function selectTableRow(state, docId) {
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info';
        console.log('selected docId:' + docId);
      } else {
        state.all[i]._rowVariant = '';
      }
    }
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  toggleDisabledPagination: function toggleDisabledPagination(state, show) {
    state.disabledPagination = show;
  }
};

var getters = {
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var actions = {
  uploadFileToFirebaseStorage: function uploadFileToFirebaseStorage(context, payload) {
    console.log('File to upload: ' + payload.file);
    if (!payload.file) {
      console.log('Nothing to upload');
      return;
    }
    var firebaseStorageRef = context.rootState.fbStorage.ref();
    context.commit('toggleUploadingModal', true);

    var uploadTask = firebaseStorageRef.child(context.state.uploadFolderPath + payload.file.name).put(payload.file);
    uploadTask.on('state_changed', function (snapshot) {
      context.state.uploadProgress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      console.log('Upload is ' + context.state.uploadProgress + '% done');
      switch (snapshot.state) {
        case context.rootState.firebase.storage.TaskState.PAUSED:
          console.log('Upload is paused');
          break;
        case context.rootState.firebase.storage.TaskState.RUNNING:
          console.log('Upload is running');
          break;
      }
    }, function (error) {
      context.commit('toggleUploadingModal', false);
      context.commit('toggleUploadingFailedModal', true);

      console.error(error);
    }, function () {
      var downloadURL = uploadTask.snapshot.downloadURL;
      console.log('Successfully uploaded to: ' + downloadURL);

      var objToAdd = {
        fileName: payload.file.name,
        uploadedDate: new Date(),
        status: 'NEW'
      };

      var uploadedInvoiceCollection = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName);
      uploadedInvoiceCollection.add(objToAdd).then(function (docRef) {
        context.commit('toggleUploadingModal', false);
        context.commit('toggleUploadingSuccessModal', true);
        context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
      }).catch(function (err) {
        console.error(err);
        context.commit('toggleUploadingModal', false);
        context.commit('toggleUploadingFailedModal', true);
      });
    });
  },
  showAllUploads: function showAllUploads(context, payload) {
    context.state.all = [];

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    context.commit('toggleDisabledPagination', true);

    var queryParameters = {
      collectionName: context.state.uploadedInvoicesCollectionName,
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'desc',
      orderByFlippedDirection: 'asc'
    };

    var docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters);

    firestoretable.queryCollection(docQuery, context, queryParameters, false);

    var firstQuery = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName);
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length);
    });
  },
  importFile: function importFile(context, payload) {
    console.log('Import file at: ' + payload.downloadURL);
    context.commit('toggleImportingModal', true);
    context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName).where('status', '==', 'IMPORTING').get().then(function (querySnapshot) {
      if (querySnapshot.size === 0) {
        var docRef = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName).doc(payload.docId);
        docRef.update({ status: 'IMPORTING' }).then(function () {
          console.log('Import file updated to IMPORTING');
          context.dispatch('executeImport', payload);
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        console.log('Cannot import more than 1 file at the same time');
        context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
        context.commit('toggleImportingModal', false);
      }
    });
  },
  executeImport: function executeImport(context, payload) {
    var currentUser = context.rootState.firebase.auth().currentUser;
    if (!currentUser) {
      context.commit('toggleImportingModal', false);
      context.state.importFailedMessage = 'Please login again before importing.';
      context.commit('toggleImportingFailedModal', true);
      return;
    }

    currentUser.getIdToken(true).then(function (idToken) {
      var projectId = context.rootState.firebase.app().options.projectId;
      var cloudFunctionImportUrl = 'https://asia-southeast1-' + projectId + '.cloudfunctions.net/importFromStorage';
      console.log('Import function URL: ' + cloudFunctionImportUrl);
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          context.commit('toggleImportingModal', false);
          if (xmlHttp.status === 200) {
            context.commit('toggleImportingSuccessModal', true);
            context.dispatch('updateFileStatus', { docId: payload.docId, status: 'IMPPORTED' });
            console.log('Import result: ' + xmlHttp.responseText);
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
          } else {
            console.log('Import failed with status ' + xmlHttp.status + ': ' + xmlHttp.responseText);
            context.state.importFailedMessage = xmlHttp.responseText;
            context.dispatch('updateFileStatus', { docId: payload.docId, status: 'NEW' });
            context.commit('toggleImportingFailedModal', true);
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' });
          }
        }
      };
      xmlHttp.open('POST', cloudFunctionImportUrl, true);
      xmlHttp.setRequestHeader('Content-Type', 'application/json');
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + idToken);
      console.log('Stringify: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ filename: payload.filename, status: payload.status }));
      xmlHttp.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        filename: payload.filename,
        status: payload.status
      }));
    }).catch(function (err) {
      context.commit('toggleImportingModal', false);
      context.state.importFailedMessage = err.message;
      context.commit('toggleImportingFailedModal', true);
    });
  },
  updateFileStatus: function updateFileStatus(context, payload) {
    var docId = payload.docId;
    var status = payload.status;
    var docRef = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName).doc(docId);
    docRef.update({ status: status }).then(function () {
      console.log('Import file updated to ' + status);
    }).catch(function (err) {
      console.error(err);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var moment = __webpack_require__(2);
var dateutils = __webpack_require__(62);

var state = {
  all: [],
  headers: ['jobNumber', 'status', 'createdDate', 'updatedDate'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  showGeneratingModal: false,
  showGeneratingSuccessModal: false,
  showGeneratingFailedModal: false,
  showCannotGenerateModal: false
};

var mutations = {
  setRowsPerPage: function setRowsPerPage(state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage;
  },
  changePageNumber: function changePageNumber(state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  updateTotalRows: function updateTotalRows(state, newTotalRows) {
    state.totalRows = newTotalRows;
  },
  toggleShowLoadingAnimation: function toggleShowLoadingAnimation(state, show) {
    state.showLoadingAnimation = show;
  },
  toggleshowLoadingError: function toggleshowLoadingError(state, show) {
    state.showLoadingError = show;
  },
  toggleShowNoResult: function toggleShowNoResult(state, show) {
    state.showNoResult = show;
  },
  setLoadingErrorMessage: function setLoadingErrorMessage(state, message) {
    state.loadingErrorMessage = message;
  },
  updateDownloadUrl: function updateDownloadUrl(state, updatePackage) {
    console.log('Update download url to: ' + updatePackage.url + ' for job: ' + updatePackage.jobNumber);
    state.all.forEach(function (row) {
      if (row.jobNumber === updatePackage.jobNumber) {
        row.downloadUrl = updatePackage.url;
      }
    });
  },
  toggleShowGeneratingModal: function toggleShowGeneratingModal(state, show) {
    state.showGeneratingModal = show;
  },
  toggleShowGeneratingSuccessModal: function toggleShowGeneratingSuccessModal(state, show) {
    state.showGeneratingSuccessModal = show;
  },
  toggleShowGeneratingFailedModal: function toggleShowGeneratingFailedModal(state, show) {
    state.showGeneratingFailedModal = show;
  },
  toggleShowCannotGenerateModal: function toggleShowCannotGenerateModal(state, show) {
    state.showCannotGenerateModal = show;
  }
};

var getters = {
  getAll: function getAll(state, getters, rootState) {
    return state.all;
  },
  getHeaders: function getHeaders(state, getters, rootState) {
    var extraHeaders = [];
    for (var i = 0; i < state.headers.length; i++) {
      var eachHeader = state.headers[i];
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      });
    }
    return extraHeaders;
  }
};

var actions = {
  showAllClaimReportJobs: function showAllClaimReportJobs(context, payload) {
    context.state.all = [];

    context.commit('toggleShowLoadingAnimation', true);
    context.commit('toggleshowLoadingError', false);
    context.commit('toggleShowNoResult', false);

    var importsCollectionName = 'batchReports';

    var firstQuery = context.rootState.firestoreDB.collection(importsCollectionName);
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length);
    });

    if (context.state.currentPage === 1) {
      var docQuery = context.rootState.firestoreDB.collection(importsCollectionName).orderBy(payload.orderBys, 'desc').limit(context.state.rowsPerPage);
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var documentData = doc.data();
          var invoiceObject = {};
          for (var eachProp in documentData) {
            var propName = eachProp;

            if (propName === 'createdDate' && doc.data()[eachProp]) {
              var m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
            } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
              var _m = moment(dateutils.toJsDate(doc.data()[eachProp]));
              invoiceObject[propName] = _m.format('DD/MMM/YYYY hh:mm:ss a');
            } else {
              invoiceObject[propName] = doc.data()[eachProp];
            }
          }
          invoiceObject['downloadUrl'] = '';
          context.state.all.push(invoiceObject);
        });
        context.commit('toggleShowLoadingAnimation', false);
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true);
        }
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    } else {
      var lastRowShown = void 0;
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage;
      } else {
        lastRowShown = (context.state.currentPage - 1) * context.state.rowsPerPage;
      }
      console.log('lastRowShown: ' + lastRowShown);
      var _docQuery = context.rootState.firestoreDB.collection(importsCollectionName).orderBy(payload.orderBys, 'desc');
      _docQuery.get().then(function (querySnapshot) {
        var lastVisibleSnapshot = querySnapshot.docs[lastRowShown];

        var docSubQuery = context.rootState.firestoreDB.collection(importsCollectionName).orderBy(payload.orderBys).startAt(lastVisibleSnapshot).limit(context.state.rowsPerPage);
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            var documentData = subDoc.data();
            var invoiceObject = {};
            for (var eachProp in documentData) {
              var propName = eachProp;

              if (propName === 'createdDate' && subDoc.data()[eachProp]) {
                var m = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a');
              } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
                var _m2 = moment(dateutils.toJsDate(subDoc.data()[eachProp]));
                invoiceObject[propName] = _m2.format('DD/MMM/YYYY hh:mm:ss a');
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp];
              }
            }
            invoiceObject['downloadUrl'] = '';
            context.state.all.push(invoiceObject);
          });
          context.commit('toggleShowLoadingAnimation', false);
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true);
          }
        });
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err);
        context.commit('toggleShowLoadingAnimation', false);

        context.commit('toggleshowLoadingError', true);
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]');
      });
    }
  },
  downloadFileFromGCS: function downloadFileFromGCS(context, payload) {
    var firebaseStorageRef = context.rootState.fbStorage.ref();
    firebaseStorageRef.child('batchReports/' + payload.jobNumber + '/azip/claimsreports.zip').getDownloadURL().then(function (url) {
      console.log('Download url: ' + url);

      var updatePackage = {
        jobNumber: payload.jobNumber,
        url: url
      };
      context.commit('updateDownloadUrl', updatePackage);
    }).catch(function (error) {
      console.error(error);

      var updatePackage = {
        jobNumber: payload.jobNumber,
        url: ''
      };
      context.commit('updateDownloadUrl', updatePackage);
    });
  },
  generateClaimsReports: function generateClaimsReports(context, payload) {
    console.log('Generate claims reports');
    context.commit('toggleShowGeneratingModal', true);
    context.rootState.firestoreDB.collection('batchReports').get().then(function (querySnapshot) {
      if (querySnapshot.size === 0) {
        context.dispatch('triggerTick');
        return;
      }
      var hasUnfinishedJob = false;
      querySnapshot.forEach(function (doc) {
        if (doc.exists) {
          var data = doc.data();

          if (data.status !== 'READY_FOR_DOWNLOAD' && data.status !== 'FAILED_AND_STOPPED') {
            console.log('has pending job: ' + data.status);
            hasUnfinishedJob = true;
          }
        }
      });
      if (hasUnfinishedJob) {
        context.commit('toggleShowCannotGenerateModal', true);
        context.commit('toggleShowGeneratingModal', false);
        context.dispatch('showAllClaimReportJobs', { orderBys: 'createdDate' });
      } else {
        context.dispatch('triggerTick');
      }
    });
  },
  triggerTick: function triggerTick(context, payload) {
    console.log('Tick db to generate claim');
    var dataCommitted = false;

    context.rootState.realtimeDb.ref('batchReport/').transaction(function (data) {
      if (data) {
        data.tick = Number(data.tick) + 1;
      } else {
        data = {
          archiveJobNumber: 0,
          invoiceTick: 0,
          jobNumber: 1,
          lastParsedEmail: '',
          parsedEmails: 0,
          recordsToParsePerBatch: 100,
          tick: 1,
          totalUsers: 0
        };
      }
      return data;
    }, function (error, committed, snapshot) {
      if (error) {
        console.error('Tick update failed: ' + error);
      }
      if (committed) {
        console.log('Updated tick');
        dataCommitted = true;
      }
    }).then(function () {
      context.dispatch('showAllClaimReportJobs', { orderBys: 'createdDate' });
      if (dataCommitted) {}
    }).catch(function (err) {
      context.dispatch('showAllClaimReportJobs', { orderBys: 'createdDate' });
      console.error(err);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var state = {
  multi: true,
  allowImage: false,
  allowDetails: false,
  banners: [],
  loading: false,
  message: '',
  alertVariant: 'success',
  showDismissibleAlert: false,
  uploadProgress: 0
};

var mutations = {
  setBanners: function setBanners(state, banners) {
    state.banners = banners;
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  setUploadProgress: function setUploadProgress(state, progress) {
    state.uploadProgress = progress;
  },
  showAlert: function showAlert(state, payload) {
    state.alertVariant = payload.variant;
    state.message = payload.message;
    state.showDismissibleAlert = true;
  },
  closeDismissibleAlert: function closeDismissibleAlert(state, dismiss) {
    state.showDismissibleAlert = dismiss;
  }
};

function cleanFileName(fileName) {
  return fileName.replace(/[^a-zA-Z0-9._-]/g, '_');
}

function toDateString(value) {
  if (!value) {
    return '';
  }
  if (value.toDate) {
    return value.toDate().toLocaleString();
  }
  return value;
}

function bannerCollection(context) {
  return context.rootState.firestoreDB.collection('banners');
}

function currentUserEmail(context) {
  return context.rootState.currentUser ? context.rootState.currentUser.email : '';
}

var actions = {
  fetchBanners: function fetchBanners(context) {
    context.commit('setLoading', true);
    bannerCollection(context).orderBy('sortOrder', 'asc').get().then(function (querySnapshot) {
      var banners = [];
      querySnapshot.forEach(function (doc) {
        var data = doc.data();
        banners.push({
          docId: doc.id,
          title: data.title || '',
          description: data.description || '',
          article: data.article || '',
          imageUrl: data.imageUrl || '',
          storagePath: data.storagePath || '',
          active: data.active === true,
          sortOrder: data.sortOrder || 0,
          createdDateDisplay: toDateString(data.createdDate),
          updatedDateDisplay: toDateString(data.updatedDate)
        });
      });
      context.commit('setBanners', context.state.multi ? banners : banners.slice(0, 1));
      context.commit('setLoading', false);
    }).catch(function (err) {
      console.error('Error while fetching banners: ' + err);
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Error loading banners: ' + err });
    });
  },
  saveSingleBanner: function saveSingleBanner(context, payload) {
    var title = payload && payload.title ? payload.title.trim() : '';
    if (!title) {
      context.commit('showAlert', { variant: 'warning', message: 'Please enter a banner title.' });
      return;
    }

    context.commit('setLoading', true);
    bannerCollection(context).orderBy('sortOrder', 'asc').limit(1).get().then(function (querySnapshot) {
      if (querySnapshot.empty) {
        return bannerCollection(context).add({
          title: title,
          description: '',
          article: '',
          imageUrl: '',
          storagePath: '',
          active: true,
          sortOrder: 0,
          createdBy: currentUserEmail(context),
          createdDate: context.rootState.firebase.firestore.FieldValue.serverTimestamp(),
          updatedBy: '',
          updatedDate: null
        });
      }

      var doc = querySnapshot.docs[0];
      var data = doc.data() || {};
      return bannerCollection(context).doc(doc.id).update({
        title: title,
        active: data.active === true,
        updatedBy: currentUserEmail(context),
        updatedDate: context.rootState.firebase.firestore.FieldValue.serverTimestamp()
      });
    }).then(function () {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'success', message: 'Banner announcement saved.' });
      context.dispatch('fetchBanners');
    }).catch(function (err) {
      console.error('Error while saving banner announcement: ' + err);
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Save failed: ' + err.message });
    });
  },
  uploadBanner: function uploadBanner(context, payload) {
    if (!context.state.multi) {
      context.dispatch('saveSingleBanner', payload);
      return;
    }

    context.commit('setLoading', true);
    context.commit('setUploadProgress', 0);

    var saveBanner = function saveBanner(downloadURL, storagePath) {
      return bannerCollection(context).add({
        title: payload.title || '',
        description: context.state.allowDetails ? payload.description || '' : '',
        article: context.state.allowDetails ? payload.article || '' : '',
        imageUrl: downloadURL || '',
        storagePath: storagePath || '',
        active: payload.active === true,
        sortOrder: Number(payload.sortOrder) || 0,
        createdBy: currentUserEmail(context),
        createdDate: context.rootState.firebase.firestore.FieldValue.serverTimestamp(),
        updatedBy: '',
        updatedDate: null
      });
    };

    if (!context.state.allowImage) {
      saveBanner('', '').then(function () {
        context.commit('setLoading', false);
        context.commit('setUploadProgress', 0);
        context.commit('showAlert', { variant: 'success', message: 'Banner uploaded.' });
        context.dispatch('fetchBanners');
      }).catch(function (err) {
        console.error('Error while saving banner: ' + err);
        context.commit('setLoading', false);
        context.commit('showAlert', { variant: 'danger', message: 'Banner save failed: ' + err.message });
      });
      return;
    }

    if (!payload || !payload.file) {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'warning', message: 'Please choose an image first.' });
      return;
    }

    var fileName = Date.now() + '_' + cleanFileName(payload.file.name);
    var storagePath = 'banners/' + fileName;
    var storageRef = context.rootState.fbStorage.ref().child(storagePath);
    var uploadTask = storageRef.put(payload.file);

    uploadTask.on('state_changed', function (snapshot) {
      var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      context.commit('setUploadProgress', Math.round(progress));
    }, function (error) {
      console.error('Error while uploading banner: ' + error);
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Upload failed: ' + error.message });
    }, function () {
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        return saveBanner(downloadURL, storagePath);
      }).then(function () {
        context.commit('setLoading', false);
        context.commit('setUploadProgress', 0);
        context.commit('showAlert', { variant: 'success', message: 'Banner uploaded.' });
        context.dispatch('fetchBanners');
      }).catch(function (err) {
        console.error('Error while saving banner: ' + err);
        context.commit('setLoading', false);
        context.commit('showAlert', { variant: 'danger', message: 'Banner save failed: ' + err.message });
      });
    });
  },
  updateBanner: function updateBanner(context, banner) {
    if (!banner || !banner.docId) {
      return;
    }
    context.commit('setLoading', true);

    var updateData = context.state.multi ? {
      title: banner.title || '',
      description: context.state.allowDetails ? banner.description || '' : '',
      article: context.state.allowDetails ? banner.article || '' : '',
      active: banner.active === true,
      sortOrder: Number(banner.sortOrder) || 0,
      updatedBy: currentUserEmail(context),
      updatedDate: context.rootState.firebase.firestore.FieldValue.serverTimestamp()
    } : {
      title: banner.title || '',
      active: banner.active === true,
      updatedBy: currentUserEmail(context),
      updatedDate: context.rootState.firebase.firestore.FieldValue.serverTimestamp()
    };

    bannerCollection(context).doc(banner.docId).update(updateData).then(function () {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'success', message: 'Banner updated.' });
      context.dispatch('fetchBanners');
    }).catch(function (err) {
      console.error('Error while updating banner: ' + err);
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Update failed: ' + err.message });
    });
  },
  deleteBanner: function deleteBanner(context, banner) {
    if (!context.state.multi) {
      context.commit('showAlert', { variant: 'warning', message: 'Single banner mode does not allow delete.' });
      return;
    }

    if (!banner || !banner.docId) {
      return;
    }
    context.commit('setLoading', true);
    var deleteImagePromise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    if (banner.storagePath) {
      deleteImagePromise = context.rootState.fbStorage.ref().child(banner.storagePath).delete().catch(function (err) {
        console.warn('Could not delete banner image from storage: ' + err);
      });
    }
    deleteImagePromise.then(function () {
      return bannerCollection(context).doc(banner.docId).delete();
    }).then(function () {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'success', message: 'Banner deleted.' });
      context.dispatch('fetchBanners');
    }).catch(function (err) {
      console.error('Error while deleting banner: ' + err);
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Delete failed: ' + err.message });
    });
  }
};

var getters = {
  bannerFields: function bannerFields(state) {
    if (!state.multi) {
      return [{ key: 'title', label: 'Title' }, { key: 'active', label: 'Visible' }, { key: 'actions', label: 'Actions' }];
    }

    var fields = [{ key: 'title', label: 'Title' }, { key: 'sortOrder', label: 'Sort' }, { key: 'active', label: 'Active' }, { key: 'createdDateDisplay', label: 'Created' }, { key: 'actions', label: 'Actions' }];

    if (state.allowDetails) {
      fields.splice(1, 0, { key: 'description', label: 'Description' }, { key: 'article', label: 'Article' });
    }

    if (state.allowImage) {
      fields.unshift({ key: 'preview', label: 'Preview' });
    }

    return fields;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


var state = {
  loading: false,
  logs: [],
  users: [],
  invoiceEligibleSettings: {
    enabled: false,
    title: 'New eligible invoice available',
    body: 'A new invoice has been uploaded and some items are eligible for an active campaign. Open HOYA E-Surprise to check your rewards.'
  },
  message: '',
  alertVariant: 'success',
  showDismissibleAlert: false
};

var mutations = {
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  setLogs: function setLogs(state, logs) {
    state.logs = logs;
  },
  setUsers: function setUsers(state, users) {
    state.users = users;
  },
  setInvoiceEligibleSettings: function setInvoiceEligibleSettings(state, settings) {
    state.invoiceEligibleSettings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.invoiceEligibleSettings, settings);
  },
  showAlert: function showAlert(state, payload) {
    state.message = payload.message;
    state.alertVariant = payload.variant;
    state.showDismissibleAlert = true;
  },
  closeDismissibleAlert: function closeDismissibleAlert(state, dismiss) {
    state.showDismissibleAlert = dismiss;
  }
};

var getters = {
  userFields: function userFields() {
    return [{ key: 'companyName', label: 'Company', sortable: true }, { key: 'accountNumber', label: 'Customer Account', sortable: true }, { key: 'email', label: 'Email', sortable: true }, { key: 'phoneNumber', label: 'Phone', sortable: true }, { key: 'status', label: 'Status', sortable: true }];
  },
  logFields: function logFields() {
    return [{ key: 'createdDate', sortable: true }, { key: 'title', sortable: true }, { key: 'blast', sortable: true }, { key: 'successCount', sortable: true }, { key: 'failureCount', sortable: true }, { key: 'status', sortable: true }, { key: 'details', label: 'Details' }];
  }
};

var actions = {
  fetchUsers: function fetchUsers(context) {
    context.commit('setLoading', true);
    context.rootState.firestoreDB.collection('users').orderBy('email').get().then(function (querySnapshot) {
      var users = [];
      querySnapshot.forEach(function (doc) {
        var data = doc.data();
        users.push({
          docId: doc.id,
          companyName: data.companyName || data.name || '',
          accountNumber: data.accountNumber || data.customerAccount || '',
          email: data.email || doc.id,
          phoneNumber: data.phoneNumber || '',
          status: data.status || '',
          approved: data.approved === true
        });
      });
      context.commit('setUsers', users);
      context.commit('setLoading', false);
    }).catch(function (err) {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Error loading users: ' + err.message });
    });
  },
  fetchInvoiceEligibleSettings: function fetchInvoiceEligibleSettings(context) {
    context.rootState.firestoreDB.collection('configuration').doc('invoiceEligibleNotification').get().then(function (doc) {
      if (!doc.exists) {
        return;
      }
      var data = doc.data();
      context.commit('setInvoiceEligibleSettings', {
        enabled: data.enabled === true,
        title: data.title || '',
        body: data.body || ''
      });
    }).catch(function (err) {
      context.commit('showAlert', { variant: 'danger', message: 'Error loading invoice notification settings: ' + err.message });
    });
  },
  saveInvoiceEligibleSettings: function saveInvoiceEligibleSettings(context, settings) {
    context.commit('setLoading', true);
    var currentUser = context.rootState.firebase.auth().currentUser;
    var payload = {
      enabled: settings.enabled === true,
      title: settings.title || '',
      body: settings.body || '',
      updatedBy: currentUser ? currentUser.email : '',
      updatedDate: new Date()
    };

    context.rootState.firestoreDB.collection('configuration').doc('invoiceEligibleNotification').set(payload, { merge: true }).then(function () {
      context.commit('setInvoiceEligibleSettings', payload);
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'success', message: 'Invoice notification settings saved.' });
    }).catch(function (err) {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Error saving invoice notification settings: ' + err.message });
    });
  },
  sendNotification: function sendNotification(context, payload) {
    context.commit('setLoading', true);
    var currentUser = context.rootState.firebase.auth().currentUser;
    if (!currentUser) {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: 'Please login again before sending notifications.' });
      return;
    }

    currentUser.getIdToken(true).then(function (idToken) {
      var projectId = context.rootState.firebase.app().options.projectId;
      var cloudFunctionUrl = 'https://asia-southeast1-' + projectId + '.cloudfunctions.net/sendCustomerNotification';
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          context.commit('setLoading', false);
          if (xmlHttp.status === 200) {
            context.commit('showAlert', { variant: 'success', message: 'Notification sent: ' + xmlHttp.responseText });
            context.dispatch('fetchLogs');
          } else {
            context.commit('showAlert', { variant: 'danger', message: 'Notification failed: ' + xmlHttp.responseText });
          }
        }
      };
      xmlHttp.open('POST', cloudFunctionUrl, true);
      xmlHttp.setRequestHeader('Content-Type', 'application/json');
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + idToken);
      xmlHttp.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
    }).catch(function (err) {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: err.message });
    });
  },
  fetchLogs: function fetchLogs(context) {
    context.commit('setLoading', true);
    context.rootState.firestoreDB.collection('notificationLogs').orderBy('createdDate', 'desc').limit(100).get().then(function (querySnapshot) {
      var logs = [];
      querySnapshot.forEach(function (doc) {
        var data = doc.data();
        data.docId = doc.id;
        if (data.createdDate && data.createdDate.toDate) {
          data.createdDate = data.createdDate.toDate().toLocaleString();
        }
        data.recipients = data.blast ? 'Blast' : Array.isArray(data.emails) ? data.emails.join(', ') : '';
        data.body = data.body || data.message || '';
        data.responses = Array.isArray(data.responses) ? data.responses : [];
        logs.push(data);
      });
      context.commit('setLogs', logs);
      context.commit('setLoading', false);
    }).catch(function (err) {
      context.commit('setLoading', false);
      context.commit('showAlert', { variant: 'danger', message: err.message });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions, getters: getters });

/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  showDismissibleAlert: false,
  alertVariant: '',
  message: '',
  configId: 'invoiceFieldsToDisplay',

  availableInvoiceFields: [{ name: 'Net Amount', value: 'netAmount' }, { name: 'Quantity', value: 'quantity' }, { name: 'Order Type', value: 'orderType' }, { name: 'Lens Design', value: 'lensDesign' }, { name: 'Lens Index', value: 'lensIndex' }, { name: 'Status', value: 'status' }],
  invoiceFieldsToDisplay: []
};

var mutations = {
  updateInvoiceFieldsToDisplay: function updateInvoiceFieldsToDisplay(state, newValues) {
    state.invoiceFieldsToDisplay = newValues;
  },
  promptDismissibleAlert: function promptDismissibleAlert(state) {
    state.showDismissibleAlert = true;
  },
  closeDismissibleAlert: function closeDismissibleAlert(state, dismiss) {
    state.showDismissibleAlert = dismiss;
  }
};

var actions = {
  initialiseConfiguration: function initialiseConfiguration(context) {
    context.state.showDismissibleAlert = false;
    context.state.variant = '';
    context.state.message = '';
    context.state.invoiceFieldsToDisplay = [];
    var results = context.rootState.firestoreDB.collection('configuration').doc(context.state.configId);
    results.get().then(function (snapshot) {
      context.state.invoiceFieldsToDisplay = snapshot.get('configData');
    });
  },
  saveInvoiceFieldsToDisplay: function saveInvoiceFieldsToDisplay(context) {
    var saveSuccess = true;
    context.state.variant = 'success';
    var docRef = context.rootState.firestoreDB.collection('configuration').doc(context.state.configId);
    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, {
            configData: context.state.invoiceFieldsToDisplay
          });
        } else {
          context.rootState.firestoreDB.collection('configuration').doc(context.state.configId).set({
            configData: context.state.invoiceFieldsToDisplay
          }).catch(function (err) {
            console.error('Error creating configuration: ' + err);
            saveSuccess = false;
            context.state.message = 'Error when update: ' + err;
          });
        }
      });
    }).catch(function (err) {
      console.error('Error while updating configuration: ' + err);
      saveSuccess = false;
      context.state.message = 'Error when update: ' + err;
    });
    if (saveSuccess) {
      context.state.alertVariant = 'success';
      context.state.message = 'Update successfully';
    } else {
      context.state.alertVariant = 'danger';
    }
    context.commit('promptDismissibleAlert');
  },
  resetInvoiceFieldsToDisplay: function resetInvoiceFieldsToDisplay(context) {
    context.dispatch('initialiseConfiguration');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state, mutations: mutations, actions: actions });

/***/ })

},[650]);


// WEBPACK FOOTER //
// static/js/app.b0bcab7a7f013023f949.js